import gql from 'graphql-tag';
export const AccessGroupGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        createdAt
description
entityId
entityType
id
info
name
networkId
type
      `;
};
export const ActionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        status
      `;
};
export const ActionPermissionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            inputPermissions: 'basic',
            isAuthorized: 'basic',
            outputPermissions: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.inputPermissions
        ? `
      inputPermissions {
        ${InputPathPermissionsGQLFields(fields.inputPermissions)}
      }
    `
        : ``}
  

    ${fields.isAuthorized
        ? `
      isAuthorized {
        ${IsAuthorizedGQLFields(fields.isAuthorized)}
      }
    `
        : ``}
  
name

    ${fields.outputPermissions
        ? `
      outputPermissions {
        ${PathPermissionsGQLFields(fields.outputPermissions)}
      }
    `
        : ``}
  
      `;
};
export const ActiveSsoGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        logoutUrl
settingsUrl
      `;
};
export const AnalyticsLimitsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            planLimits: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.planLimits
        ? `
      planLimits {
        ${AnalyticsPlanLimitsGQLFields(fields.planLimits)}
      }
    `
        : ``}
  
      `;
};
export const AnalyticsPlanLimitsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        daysLimitation
plan
      `;
};
export const AnalyticsQueryTimeframeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        from
to
      `;
};
export const AnalyticsResponseGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            records: 'basic',
            timeframe: 'basic',
        };
    }
    return `
        __typename
        maxCacheTime
query

    ${fields.records
        ? `
      records {
        ${ReportRecordGQLFields(fields.records)}
      }
    `
        : ``}
  

    ${fields.timeframe
        ? `
      timeframe {
        ${AnalyticsQueryTimeframeGQLFields(fields.timeframe)}
      }
    `
        : ``}
  
      `;
};
export const AppGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            authMemberInstallation: 'basic',
            banner: 'basic',
            createdBy: 'basic',
            customCodes: 'basic',
            dynamicBlocks: 'basic',
            embeds: 'basic',
            favicon: 'basic',
            globalBanner: 'basic',
            globalEmbeds: 'basic',
            globalFavicon: 'basic',
            globalImage: 'basic',
            globalImages: 'basic',
            globalNetwork: 'basic',
            image: 'basic',
            images: 'basic',
            network: 'basic',
            settingsBlock: 'basic',
            updatedBy: 'basic',
        };
    }
    return `
        __typename
        about

    ${fields.authMemberInstallation
        ? `
      authMemberInstallation {
        ${AppInstallationGQLFields(fields.authMemberInstallation)}
      }
    `
        : ``}
  
authorName
authorUrl

    ${fields.banner
        ? `
      banner {
        ${MediaGQLFields(fields.banner)}
      }
    `
        : ``}
  
bannerId
clientId
clientSecret
comingSoon
createdAt

    ${fields.createdBy
        ? `
      createdBy {
        ${MemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
  
createdById

    ${fields.customCodes
        ? `
      customCodes {
        ${AppCustomCodesGQLFields(fields.customCodes)}
      }
    `
        : ``}
  
description
docsUrl

    ${fields.dynamicBlocks
        ? `
      dynamicBlocks {
        ${DynamicBlockGQLFields(fields.dynamicBlocks)}
      }
    `
        : ``}
  
embedIds

    ${fields.embeds
        ? `
      embeds {
        ${EmbedGQLFields(fields.embeds)}
      }
    `
        : ``}
  
enabledContexts

    ${fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``}
  
faviconId
federatedSearchEnabled

    ${fields.globalBanner
        ? `
      globalBanner {
        ${MediaGQLFields(fields.globalBanner)}
      }
    `
        : ``}
  

    ${fields.globalEmbeds
        ? `
      globalEmbeds {
        ${EmbedGQLFields(fields.globalEmbeds)}
      }
    `
        : ``}
  

    ${fields.globalFavicon
        ? `
      globalFavicon {
        ${MediaGQLFields(fields.globalFavicon)}
      }
    `
        : ``}
  

    ${fields.globalImage
        ? `
      globalImage {
        ${MediaGQLFields(fields.globalImage)}
      }
    `
        : ``}
  

    ${fields.globalImages
        ? `
      globalImages {
        ${MediaGQLFields(fields.globalImages)}
      }
    `
        : ``}
  

    ${fields.globalNetwork
        ? `
      globalNetwork {
        ${PluralNetworkGQLFields(fields.globalNetwork)}
      }
    `
        : ``}
  
id

    ${fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``}
  
imageId
imageIds

    ${fields.images
        ? `
      images {
        ${MediaGQLFields(fields.images)}
      }
    `
        : ``}
  
installed
locked
name

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
networkId
privacyPolicyUrl
privatelyPublished
requiredPermissions
requiredPlan
secretToken

    ${fields.settingsBlock
        ? `
      settingsBlock {
        ${DynamicBlockGQLFields(fields.settingsBlock)}
      }
    `
        : ``}
  
slug
standing
status
termsOfServiceUrl
updatedAt

    ${fields.updatedBy
        ? `
      updatedBy {
        ${MemberGQLFields(fields.updatedBy)}
      }
    `
        : ``}
  
updatedById
webhookSignSecret
webhookSubscriptions
webhookUrl
      `;
};
export const AppActionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        data
status
      `;
};
export const AppCollaboratorGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            app: 'basic',
        };
    }
    return `
        __typename
        addedById

    ${fields.app
        ? `
      app {
        ${AppGQLFields(fields.app)}
      }
    `
        : ``}
  
appId
createdAt
email
id
type
      `;
};
export const AppCustomCodesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        body
head
      `;
};
export const AppEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${AppGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const AppInstallationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            app: 'basic',
            installedBy: 'basic',
            network: 'basic',
            templatesMappings: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.app
        ? `
      app {
        ${AppGQLFields(fields.app)}
      }
    `
        : ``}
  
appVersion
context
createdAt
id
installedAt

    ${fields.installedBy
        ? `
      installedBy {
        ${MemberGQLFields(fields.installedBy)}
      }
    `
        : ``}
  

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
permissions
status

    ${fields.templatesMappings
        ? `
      templatesMappings {
        ${AppInstallationTemplatesMappingsGQLFields(fields.templatesMappings)}
      }
    `
        : ``}
  
updatedAt
      `;
};
export const AppInstallationEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${AppInstallationGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const AppInstallationTemplatesMappingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
            postTypes: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.member
        ? `
      member {
        ${TemplatesMappingGQLFields(fields.member)}
      }
    `
        : ``}
  

    ${fields.postTypes
        ? `
      postTypes {
        ${TemplatesMappingGQLFields(fields.postTypes)}
      }
    `
        : ``}
  
      `;
};
export const AppInteractionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            slate: 'basic',
        };
    }
    return `
        __typename
        appId
interactionId
props

    ${fields.slate
        ? `
      slate {
        ${SlateGQLFields(fields.slate)}
      }
    `
        : ``}
  
type
      `;
};
export const AppPublicationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        addedById
createdAt
id
itemId
networkId
      `;
};
export const AppSettingGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        appId
context
entityId
id
networkId
settings
      `;
};
export const AppTokenGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        accessToken
gatewayUrl
      `;
};
export const AuthInfoWithOtpGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
            network: 'basic',
            role: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
otp

    ${fields.role
        ? `
      role {
        ${RoleGQLFields(fields.role)}
      }
    `
        : ``}
  
      `;
};
export const AuthTokenGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
            network: 'basic',
            networkPublicInfo: 'basic',
            role: 'basic',
        };
    }
    return `
        __typename
        accessToken

    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  

    ${fields.networkPublicInfo
        ? `
      networkPublicInfo {
        ${NetworkPublicInfoGQLFields(fields.networkPublicInfo)}
      }
    `
        : ``}
  
refreshToken

    ${fields.role
        ? `
      role {
        ${RoleGQLFields(fields.role)}
      }
    `
        : ``}
  
      `;
};
export const AuthTokenWithOtpGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
            network: 'basic',
            networkPublicInfo: 'basic',
            role: 'basic',
        };
    }
    return `
        __typename
        accessToken

    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  

    ${fields.networkPublicInfo
        ? `
      networkPublicInfo {
        ${NetworkPublicInfoGQLFields(fields.networkPublicInfo)}
      }
    `
        : ``}
  
otp
refreshToken

    ${fields.role
        ? `
      role {
        ${RoleGQLFields(fields.role)}
      }
    `
        : ``}
  
      `;
};
export const BadgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            image: 'basic',
            settings: 'basic',
        };
    }
    return `
        __typename
        active
backgroundColor
daysUntilExpired
id

    ${fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``}
  
imageId
longDescription
name
networkId

    ${fields.settings
        ? `
      settings {
        ${BadgeSettingsGQLFields(fields.settings)}
      }
    `
        : ``}
  
shortDescription
text
textColor
type
      `;
};
export const BadgeSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
value
      `;
};
export const BaseCustomFieldSchemaGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            items: 'basic',
            properties: 'basic',
            typeOptions: 'basic',
            validators: 'basic',
        };
    }
    return `
        __typename
        archived
description
externalKeys

    ${fields.items
        ? `
      items {
        ${BaseCustomFieldSchemaGQLFields(fields.items)}
      }
    `
        : ``}
  
key
name

    ${fields.properties
        ? `
      properties {
        ${BaseCustomFieldSchemaGQLFields(fields.properties)}
      }
    `
        : ``}
  
required
type

    ${fields.typeOptions
        ? `
      typeOptions {
        ${CustomFieldTypeOptionsGQLFields(fields.typeOptions)}
      }
    `
        : ``}
  

    ${fields.validators
        ? `
      validators {
        ${CustomFieldValidatorGQLFields(fields.validators)}
      }
    `
        : ``}
  
      `;
};
export const BasketGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            items: 'basic',
            total: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.items
        ? `
      items {
        ${BasketItemGQLFields(fields.items)}
      }
    `
        : ``}
  
promoErrorMessage
renewalType

    ${fields.total
        ? `
      total {
        ${PriceGQLFields(fields.total)}
      }
    `
        : ``}
  
      `;
};
export const BasketItemGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            value: 'basic',
        };
    }
    return `
        __typename
        note
promoCodeItem
title

    ${fields.value
        ? `
      value {
        ${PriceGQLFields(fields.value)}
      }
    `
        : ``}
  
      `;
};
export const BillingAddressGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        city
country
postalCode
state
streetAddress
      `;
};
export const BillingDetailsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            address: 'basic',
            card: 'basic',
            vat: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.address
        ? `
      address {
        ${BillingAddressGQLFields(fields.address)}
      }
    `
        : ``}
  
billingEmail

    ${fields.card
        ? `
      card {
        ${CardPublicInformationGQLFields(fields.card)}
      }
    `
        : ``}
  
companyName

    ${fields.vat
        ? `
      vat {
        ${VatGQLFields(fields.vat)}
      }
    `
        : ``}
  
      `;
};
export const BlockGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        children
extraProps
id
name
output
props
      `;
};
export const ByGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onMember: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onMember
        ? `
            ... on Member {
              ${MemberGQLFields(fields.onMember)}
            }
          `
        : ``}
        
      `;
};
export const CallbackResponseGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            slate: 'basic',
            toast: 'basic',
        };
    }
    return `
        __typename
        action

    ${fields.slate
        ? `
      slate {
        ${SlateGQLFields(fields.slate)}
      }
    `
        : ``}
  

    ${fields.toast
        ? `
      toast {
        ${ToastGQLFields(fields.toast)}
      }
    `
        : ``}
  
      `;
};
export const CardPublicInformationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        expirationMonth
expirationYear
lastFourDigits
updatedAt
      `;
};
export const ChartDataGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        label
points
value
      `;
};
export const CollectionGQLFields = (fields) => {
    var _a;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            createdBy: 'basic',
            network: 'basic',
        };
    }
    return `
        __typename
        createdAt

    ${fields.createdBy
        ? `
      createdBy {
        ${MemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
  
customOrderingIndex
description
id
name

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
relativeUrl
slug

      ${fields.spaces
        ? `
        spaces
        ${((_a = fields.spaces) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.spaces.variables.limit
                ? `
      limit: ${fields.spaces.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.spaces.fields)}
        }
      `
        : ``}
    
updatedAt
url
      `;
};
export const CollectionEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${CollectionGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const ContentTranslationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        enabled
      `;
};
export const ContentTypeTemplateGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            postFields: 'basic',
            slate: 'basic',
        };
    }
    return `
        __typename
        allowedEmojis
context
forbiddenEmojis
languageTemplate
name
negativeReactions
pluralName
positiveReactions

    ${fields.postFields
        ? `
      postFields {
        ${CustomFieldsSchemaGQLFields(fields.postFields)}
      }
    `
        : ``}
  
primaryReactionType
selfRepliable
shortContentTemplate
singleChoiceReactions

    ${fields.slate
        ? `
      slate {
        ${SlateGQLFields(fields.slate)}
      }
    `
        : ``}
  
slug
titleTemplate
validReplyTypesIds
      `;
};
export const ContextPermissionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            entityActions: 'basic',
        };
    }
    return `
        __typename
        context

    ${fields.entityActions
        ? `
      entityActions {
        ${EntityPermissionsGQLFields(fields.entityActions)}
      }
    `
        : ``}
  
      `;
};
export const ContextScopesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            entityScopes: 'basic',
        };
    }
    return `
        __typename
        context

    ${fields.entityScopes
        ? `
      entityScopes {
        ${EntityScopesGQLFields(fields.entityScopes)}
      }
    `
        : ``}
  
      `;
};
export const CustomCodeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        anonymize
code
position
      `;
};
export const CustomFieldGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            relationEntities: 'basic',
        };
    }
    return `
        __typename
        key

    ${fields.relationEntities
        ? `
      relationEntities {
        ${CustomFieldRelationGQLFields(fields.relationEntities)}
      }
    `
        : ``}
  
value
      `;
};
export const CustomFieldPrivacyGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        allow
      `;
};
export const CustomFieldRelationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            medias: 'basic',
            members: 'basic',
            posts: 'basic',
            spaces: 'basic',
            tags: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.medias
        ? `
      medias {
        ${MediaGQLFields(fields.medias)}
      }
    `
        : ``}
  

    ${fields.members
        ? `
      members {
        ${MemberGQLFields(fields.members)}
      }
    `
        : ``}
  

    ${fields.posts
        ? `
      posts {
        ${PostGQLFields(fields.posts)}
      }
    `
        : ``}
  

    ${fields.spaces
        ? `
      spaces {
        ${SpaceGQLFields(fields.spaces)}
      }
    `
        : ``}
  

    ${fields.tags
        ? `
      tags {
        ${TagGQLFields(fields.tags)}
      }
    `
        : ``}
  
      `;
};
export const CustomFieldSchemaGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            items: 'basic',
            properties: 'basic',
            readPrivacy: 'basic',
            settings: 'basic',
            typeOptions: 'basic',
            validators: 'basic',
            writePrivacy: 'basic',
        };
    }
    return `
        __typename
        archived
default
description
externalKeys

    ${fields.items
        ? `
      items {
        ${BaseCustomFieldSchemaGQLFields(fields.items)}
      }
    `
        : ``}
  
key
name

    ${fields.properties
        ? `
      properties {
        ${BaseCustomFieldSchemaGQLFields(fields.properties)}
      }
    `
        : ``}
  

    ${fields.readPrivacy
        ? `
      readPrivacy {
        ${CustomFieldPrivacyGQLFields(fields.readPrivacy)}
      }
    `
        : ``}
  
required
searchable

    ${fields.settings
        ? `
      settings {
        ${CustomFieldSettingsGQLFields(fields.settings)}
      }
    `
        : ``}
  
type

    ${fields.typeOptions
        ? `
      typeOptions {
        ${CustomFieldTypeOptionsGQLFields(fields.typeOptions)}
      }
    `
        : ``}
  

    ${fields.validators
        ? `
      validators {
        ${CustomFieldValidatorGQLFields(fields.validators)}
      }
    `
        : ``}
  

    ${fields.writePrivacy
        ? `
      writePrivacy {
        ${CustomFieldPrivacyGQLFields(fields.writePrivacy)}
      }
    `
        : ``}
  
      `;
};
export const CustomFieldSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
value
      `;
};
export const CustomFieldTypeOptionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        dateType
numberType
relationType
richTextType
textType
      `;
};
export const CustomFieldValidatorGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        customErrorMessage
validation
value
      `;
};
export const CustomFieldsSchemaGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            fields: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.fields
        ? `
      fields {
        ${CustomFieldSchemaGQLFields(fields.fields)}
      }
    `
        : ``}
  
      `;
};
export const CustomReactionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            icon: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.icon
        ? `
      icon {
        ${MediaGQLFields(fields.icon)}
      }
    `
        : ``}
  
iconId
key
name
reactedName
      `;
};
export const CustomSeoDetailGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            thumbnail: 'basic',
        };
    }
    return `
        __typename
        canonicalUrl
description
noIndex

    ${fields.thumbnail
        ? `
      thumbnail {
        ${MediaGQLFields(fields.thumbnail)}
      }
    `
        : ``}
  
thumbnailId
title
      `;
};
export const DomainAvailabilityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        available
      `;
};
export const DomainTransferStatusGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        aaaarecordSuccess
aaaarecords
arecordSuccess
arecords
cnameSuccess
cnames
domain
ns
root
success
tribeARecords
tribeCname
      `;
};
export const DynamicBlockGQLFields = (fields) => {
    var _a;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            app: 'basic',
            favicon: 'basic',
            image: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.app
        ? `
      app {
        ${AppGQLFields(fields.app)}
      }
    `
        : ``}
  
appId
contexts
description

    ${fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``}
  
faviconId
id

    ${fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``}
  
imageId
key
maxSize
name

      ${fields.slate
        ? `
        slate
        ${((_a = fields.slate) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.slate.variables.context
                ? `
      context: ${fields.slate.variables.context}
    `
                : ``}
  

    ${fields.slate.variables.entityId
                ? `
      entityId: ${fields.slate.variables.entityId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SlateGQLFields(fields.slate.fields)}
        }
      `
        : ``}
    
staffOnly
      `;
};
export const DynamicBlockEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${DynamicBlockGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const EmailAvailabilityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        available
      `;
};
export const EmailLogGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        createdAt
id
reason
recipient
status
type
updatedAt
      `;
};
export const EmailLogEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${EmailLogGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const EmbedGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        author
author_url
description
html
id
options
provider_name
thumbnail_height
thumbnail_url
thumbnail_width
title
type
url
      `;
};
export const EmojiGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        id
text
      `;
};
export const EntityPermissionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            actions: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.actions
        ? `
      actions {
        ${ActionPermissionsGQLFields(fields.actions)}
      }
    `
        : ``}
  
id
      `;
};
export const EntityReportGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            data: 'basic',
            entity: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.data
        ? `
      data {
        ${ReportDataGQLFields(fields.data)}
      }
    `
        : ``}
  
description
endDate

    ${fields.entity
        ? `
      entity {
        ${ReportableEntityGQLFields(fields.entity)}
      }
    `
        : ``}
  
entityId
entityType
startDate
tooltip
      `;
};
export const EntityScopesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        id
scopes
      `;
};
export const EventTypeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        description
name
noun
requiredScope
shortDescription
verb
      `;
};
export const ExportGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            file: 'basic',
            filterBy: 'basic',
        };
    }
    return `
        __typename
        createdAt
endedAt
fields

    ${fields.file
        ? `
      file {
        ${FileGQLFields(fields.file)}
      }
    `
        : ``}
  
fileId

    ${fields.filterBy
        ? `
      filterBy {
        ${MemberListFilterByGQLFields(fields.filterBy)}
      }
    `
        : ``}
  
id
networkId
startedAt
status
updatedAt
      `;
};
export const ExportEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${ExportGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const ExtraPropertyGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
value
      `;
};
export const FileGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        downloadUrl
extension
id
name
size
url
      `;
};
export const FooterGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            urls: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.urls
        ? `
      urls {
        ${FooterUrlGQLFields(fields.urls)}
      }
    `
        : ``}
  
      `;
};
export const FooterUrlGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        title
url
      `;
};
export const GlobalTokenGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        accessToken
email
      `;
};
export const HighlightedTagGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            tag: 'basic',
        };
    }
    return `
        __typename
        description
id
indent
slug

    ${fields.tag
        ? `
      tag {
        ${TagGQLFields(fields.tag)}
      }
    `
        : ``}
  
text
title
topicId
type
      `;
};
export const ImageGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            urls: 'basic',
        };
    }
    return `
        __typename
        cropHeight
cropWidth
cropX
cropY
cropZoom
dominantColorHex
downloadUrl
dpi
height
id
name
url

    ${fields.urls
        ? `
      urls {
        ${MediaUrlsGQLFields(fields.urls)}
      }
    `
        : ``}
  
width
      `;
};
export const InGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onSpace: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onSpace
        ? `
            ... on Space {
              ${SpaceGQLFields(fields.onSpace)}
            }
          `
        : ``}
        
      `;
};
export const InputPathPermissionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            isAuthorized: 'basic',
            values: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.isAuthorized
        ? `
      isAuthorized {
        ${IsAuthorizedGQLFields(fields.isAuthorized)}
      }
    `
        : ``}
  
path

    ${fields.values
        ? `
      values {
        ${ValuePermissionsGQLFields(fields.values)}
      }
    `
        : ``}
  
      `;
};
export const IntValueGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        int
      `;
};
export const InvoiceGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        cardLastFourDigits
currency
date
invoiceUrl
status
total
      `;
};
export const IsAuthorizedGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        authorized
reason
requiredPlan
      `;
};
export const JwtSsoAuthUrlsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        authorizationUrl
signUpUrl
      `;
};
export const KeyValueGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
value
      `;
};
export const LeaderboardItemGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  
memberId
score
      `;
};
export const MassActionFiltersModelGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            filterBy: 'basic',
        };
    }
    return `
        __typename
        entityIds

    ${fields.filterBy
        ? `
      filterBy {
        ${MemberListFilterByGQLFields(fields.filterBy)}
      }
    `
        : ``}
  
query
      `;
};
export const MassActionRequestGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            filters: 'basic',
        };
    }
    return `
        __typename
        action
context
createdAt
createdById
endedAt
entitiesCount
failedCount

    ${fields.filters
        ? `
      filters {
        ${MassActionFiltersModelGQLFields(fields.filters)}
      }
    `
        : ``}
  
id
networkId
processedCount
startedAt
status
updatedAt
      `;
};
export const MediaGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onEmoji: 'basic',
            onFile: 'basic',
            onImage: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onEmoji
        ? `
            ... on Emoji {
              ${EmojiGQLFields(fields.onEmoji)}
            }
          `
        : ``}
        

          ${fields.onFile
        ? `
            ... on File {
              ${FileGQLFields(fields.onFile)}
            }
          `
        : ``}
        

          ${fields.onImage
        ? `
            ... on Image {
              ${ImageGQLFields(fields.onImage)}
            }
          `
        : ``}
        
      `;
};
export const MediaLimitsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        fileSizeLimit
fileTypesLimit
imageSizeLimit
imageTypesLimit
      `;
};
export const MediaNetworkSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        fileSizeLimit
fileTypesLimit
imageSizeLimit
imageTypesLimit
      `;
};
export const MediaUrlsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        full
large
medium
small
thumb
      `;
};
export const MemberGQLFields = (fields) => {
    var _a, _b;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            activeSession: 'basic',
            attributes: 'basic',
            authMemberProps: 'basic',
            badges: 'basic',
            banner: 'basic',
            blockedMembers: 'basic',
            fields: 'basic',
            network: 'basic',
            profilePicture: 'basic',
            role: 'basic',
            sessions: 'basic',
            settings: 'basic',
            shortcuts: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.activeSession
        ? `
      activeSession {
        ${MemberSessionGQLFields(fields.activeSession)}
      }
    `
        : ``}
  

    ${fields.attributes
        ? `
      attributes {
        ${MemberAttributesGQLFields(fields.attributes)}
      }
    `
        : ``}
  

    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${MemberAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
  

    ${fields.badges
        ? `
      badges {
        ${MemberBadgeGQLFields(fields.badges)}
      }
    `
        : ``}
  

    ${fields.banner
        ? `
      banner {
        ${MediaGQLFields(fields.banner)}
      }
    `
        : ``}
  
bannerId
blockedMemberIds

    ${fields.blockedMembers
        ? `
      blockedMembers {
        ${MemberGQLFields(fields.blockedMembers)}
      }
    `
        : ``}
  
createdAt
displayName
email
emailStatus
externalId

      ${fields.extraProperties
        ? `
        extraProperties
        ${((_a = fields.extraProperties) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.extraProperties.variables.keys
                ? `
      keys: ${fields.extraProperties.variables.keys}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ExtraPropertyGQLFields(fields.extraProperties.fields)}
        }
      `
        : ``}
    

    ${fields.fields
        ? `
      fields {
        ${CustomFieldGQLFields(fields.fields)}
      }
    `
        : ``}
  
flagged
id
lastSeen
lastSeenAt
locale
name

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
networkId
newEmail
overrideTeammate

    ${fields.profilePicture
        ? `
      profilePicture {
        ${MediaGQLFields(fields.profilePicture)}
      }
    `
        : ``}
  
profilePictureId
relativeUrl

    ${fields.role
        ? `
      role {
        ${RoleGQLFields(fields.role)}
      }
    `
        : ``}
  
roleId
score

    ${fields.sessions
        ? `
      sessions {
        ${MemberSessionGQLFields(fields.sessions)}
      }
    `
        : ``}
  

    ${fields.settings
        ? `
      settings {
        ${MemberSettingsGQLFields(fields.settings)}
      }
    `
        : ``}
  

    ${fields.shortcuts
        ? `
      shortcuts {
        ${ShortcutGQLFields(fields.shortcuts)}
      }
    `
        : ``}
  

      ${fields.spaces
        ? `
        spaces
        ${((_b = fields.spaces) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.spaces.variables.limit
                ? `
      limit: ${fields.spaces.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.spaces.fields)}
        }
      `
        : ``}
    
status
tagline
teammate
updatedAt
url
username
verifiedAt
      `;
};
export const MemberAttributesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        locale
      `;
};
export const MemberAuthMemberPropsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            permissions: 'basic',
        };
    }
    return `
        __typename
        canSendPrivateMessages
context

    ${fields.permissions
        ? `
      permissions {
        ${ActionPermissionsGQLFields(fields.permissions)}
      }
    `
        : ``}
  
scopes
      `;
};
export const MemberBadgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            badge: 'basic',
            image: 'basic',
        };
    }
    return `
        __typename
        backgroundColor

    ${fields.badge
        ? `
      badge {
        ${BadgeGQLFields(fields.badge)}
      }
    `
        : ``}
  
badgeId

    ${fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``}
  
imageId
longDescription
shortDescription
text
textColor
type
      `;
};
export const MemberEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${MemberGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const MemberInvitationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            emailLog: 'basic',
            emailLogs: 'basic',
            invitee: 'basic',
            inviter: 'basic',
            network: 'basic',
            role: 'basic',
        };
    }
    return `
        __typename
        createdAt

    ${fields.emailLog
        ? `
      emailLog {
        ${EmailLogGQLFields(fields.emailLog)}
      }
    `
        : ``}
  

    ${fields.emailLogs
        ? `
      emailLogs {
        ${EmailLogGQLFields(fields.emailLogs)}
      }
    `
        : ``}
  
expiresAt
id
invitationMessage

    ${fields.invitee
        ? `
      invitee {
        ${MemberGQLFields(fields.invitee)}
      }
    `
        : ``}
  
inviteeEmail
inviteeId
inviteeName

    ${fields.inviter
        ? `
      inviter {
        ${MemberGQLFields(fields.inviter)}
      }
    `
        : ``}
  
inviterId
joinedAt

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
networkId

    ${fields.role
        ? `
      role {
        ${RoleGQLFields(fields.role)}
      }
    `
        : ``}
  
roleId
status
      `;
};
export const MemberInvitationEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${MemberInvitationGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const MemberInvitationLinkGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            inviter: 'basic',
            network: 'basic',
        };
    }
    return `
        __typename
        createdAt
id

    ${fields.inviter
        ? `
      inviter {
        ${MemberGQLFields(fields.inviter)}
      }
    `
        : ``}
  
link

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
      `;
};
export const MemberListFilterByGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
operator
value
      `;
};
export const MemberNetworkNotificationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        channel
enabled
isDefault
mention
reaction
sameAsDefault
      `;
};
export const MemberNotificationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            network: 'basic',
            spaces: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.network
        ? `
      network {
        ${MemberNetworkNotificationSettingsGQLFields(fields.network)}
      }
    `
        : ``}
  

    ${fields.spaces
        ? `
      spaces {
        ${MemberSpaceNotificationSettingsGQLFields(fields.spaces)}
      }
    `
        : ``}
  
      `;
};
export const MemberPostNotificationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        enabled
memberId
postId
      `;
};
export const MemberPrivateMessagingSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        privateMessagingEnabled
      `;
};
export const MemberSessionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        active
country
createdAt
deviceBrand
id
ip
lastActivityAt
os
osVersion
      `;
};
export const MemberSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            privateMessaging: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.privateMessaging
        ? `
      privateMessaging {
        ${MemberPrivateMessagingSettingsGQLFields(fields.privateMessaging)}
      }
    `
        : ``}
  
      `;
};
export const MemberSpaceNotificationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            space: 'basic',
        };
    }
    return `
        __typename
        channel
enabled
isDefault
preference
sameAsDefault

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  
      `;
};
export const MembersPermissionSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        canDeleteAccount
      `;
};
export const MigrationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        id
networkId
requesterId
stage
status
      `;
};
export const MigrationFieldErrorGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        field
message
      `;
};
export const MigrationFileResultGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            rowErrors: 'basic',
        };
    }
    return `
        __typename
        file
insertedRows

    ${fields.rowErrors
        ? `
      rowErrors {
        ${MigrationRowErrorsGQLFields(fields.rowErrors)}
      }
    `
        : ``}
  
skippedRows
      `;
};
export const MigrationRowErrorsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            fieldErrors: 'basic',
        };
    }
    return `
        __typename
        externalId

    ${fields.fieldErrors
        ? `
      fieldErrors {
        ${MigrationFieldErrorGQLFields(fields.fieldErrors)}
      }
    `
        : ``}
  
message
rowNumber
      `;
};
export const ModerationItemGQLFields = (fields) => {
    var _a;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            entity: 'basic',
            moderator: 'basic',
        };
    }
    return `
        __typename
        createdAt
description

    ${fields.entity
        ? `
      entity {
        ${ModerationItemEntityGQLFields(fields.entity)}
      }
    `
        : ``}
  
flaggedBy
id

    ${fields.moderator
        ? `
      moderator {
        ${MemberGQLFields(fields.moderator)}
      }
    `
        : ``}
  

      ${fields.reporters
        ? `
        reporters
        ${((_a = fields.reporters) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.reporters.variables.after
                ? `
      after: ${fields.reporters.variables.after}
    `
                : ``}
  

    ${fields.reporters.variables.before
                ? `
      before: ${fields.reporters.variables.before}
    `
                : ``}
  

    ${fields.reporters.variables.limit
                ? `
      limit: ${fields.reporters.variables.limit}
    `
                : ``}
  

    ${fields.reporters.variables.offset
                ? `
      offset: ${fields.reporters.variables.offset}
    `
                : ``}
  

    ${fields.reporters.variables.reverse
                ? `
      reverse: ${fields.reporters.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedModerationItemReporterGQLFields(fields.reporters.fields)}
        }
      `
        : ``}
    
spaceId
status
updatedAt
      `;
};
export const ModerationItemEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${ModerationItemGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const ModerationItemEntityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onMember: 'basic',
            onPost: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onMember
        ? `
            ... on Member {
              ${MemberGQLFields(fields.onMember)}
            }
          `
        : ``}
        

          ${fields.onPost
        ? `
            ... on Post {
              ${PostGQLFields(fields.onPost)}
            }
          `
        : ``}
        
      `;
};
export const ModerationItemReporterGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            reporter: 'basic',
        };
    }
    return `
        __typename
        createdAt
description
id
reportCategory

    ${fields.reporter
        ? `
      reporter {
        ${MemberGQLFields(fields.reporter)}
      }
    `
        : ``}
  
updatedAt
      `;
};
export const ModerationItemReporterEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${ModerationItemReporterGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const ModerationMemberSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        minimumHoursToPost
minimumHoursToReply
      `;
};
export const ModerationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
        };
    }
    return `
        __typename
        customBlacklist
enableBlacklisting

    ${fields.member
        ? `
      member {
        ${ModerationMemberSettingsGQLFields(fields.member)}
      }
    `
        : ``}
  
useDefaultBlacklisting
      `;
};
export const MutationGQLFields = (fields) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            clearNewDomain: 'basic',
            clearNotificationsCount: 'basic',
            deleteNetwork: 'basic',
            removeNetwork: 'basic',
            resendVerification: 'basic',
            transferToNewDomain: 'basic',
        };
    }
    return `
        __typename
        
      ${fields.addEmoji
        ? `
        addEmoji
        ${((_a = fields.addEmoji) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.addEmoji.variables.input
                ? `
      input: ${fields.addEmoji.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmojiGQLFields(fields.addEmoji.fields)}
        }
      `
        : ``}
    

      ${fields.addEmojis
        ? `
        addEmojis
        ${((_b = fields.addEmojis) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.addEmojis.variables.input
                ? `
      input: ${fields.addEmojis.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmojiGQLFields(fields.addEmojis.fields)}
        }
      `
        : ``}
    

      ${fields.addGroup
        ? `
        addGroup
        ${((_c = fields.addGroup) === null || _c === void 0 ? void 0 : _c.variables)
            ? `
          (
            
    ${fields.addGroup.variables.input
                ? `
      input: ${fields.addGroup.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CollectionGQLFields(fields.addGroup.fields)}
        }
      `
        : ``}
    

      ${fields.addImage
        ? `
        addImage
        ${((_d = fields.addImage) === null || _d === void 0 ? void 0 : _d.variables)
            ? `
          (
            
    ${fields.addImage.variables.input
                ? `
      input: ${fields.addImage.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SignedUrlGQLFields(fields.addImage.fields)}
        }
      `
        : ``}
    

      ${fields.addImages
        ? `
        addImages
        ${((_e = fields.addImages) === null || _e === void 0 ? void 0 : _e.variables)
            ? `
          (
            
    ${fields.addImages.variables.input
                ? `
      input: ${fields.addImages.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SignedUrlGQLFields(fields.addImages.fields)}
        }
      `
        : ``}
    

      ${fields.addMedias
        ? `
        addMedias
        ${((_f = fields.addMedias) === null || _f === void 0 ? void 0 : _f.variables)
            ? `
          (
            
    ${fields.addMedias.variables.input
                ? `
      input: ${fields.addMedias.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SignedUrlGQLFields(fields.addMedias.fields)}
        }
      `
        : ``}
    

      ${fields.addMemberSchemaField
        ? `
        addMemberSchemaField
        ${((_g = fields.addMemberSchemaField) === null || _g === void 0 ? void 0 : _g.variables)
            ? `
          (
            
    ${fields.addMemberSchemaField.variables.input
                ? `
      input: ${fields.addMemberSchemaField.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.addMemberSchemaField.fields)}
        }
      `
        : ``}
    

      ${fields.addModerationReport
        ? `
        addModerationReport
        ${((_h = fields.addModerationReport) === null || _h === void 0 ? void 0 : _h.variables)
            ? `
          (
            
    ${fields.addModerationReport.variables.input
                ? `
      input: ${fields.addModerationReport.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ModerationItemGQLFields(fields.addModerationReport.fields)}
        }
      `
        : ``}
    

      ${fields.addNetwork
        ? `
        addNetwork
        ${((_j = fields.addNetwork) === null || _j === void 0 ? void 0 : _j.variables)
            ? `
          (
            
    ${fields.addNetwork.variables.input
                ? `
      input: ${fields.addNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenWithOtpGQLFields(fields.addNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.addNewDomain
        ? `
        addNewDomain
        ${((_k = fields.addNewDomain) === null || _k === void 0 ? void 0 : _k.variables)
            ? `
          (
            
    ${fields.addNewDomain.variables.input
                ? `
      input: ${fields.addNewDomain.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DomainTransferStatusGQLFields(fields.addNewDomain.fields)}
        }
      `
        : ``}
    

      ${fields.addPost
        ? `
        addPost
        ${((_l = fields.addPost) === null || _l === void 0 ? void 0 : _l.variables)
            ? `
          (
            
    ${fields.addPost.variables.input
                ? `
      input: ${fields.addPost.variables.input}
    `
                : ``}
  

    ${fields.addPost.variables.spaceId
                ? `
      spaceId: ${fields.addPost.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.addPost.fields)}
        }
      `
        : ``}
    

      ${fields.addPostTypeField
        ? `
        addPostTypeField
        ${((_m = fields.addPostTypeField) === null || _m === void 0 ? void 0 : _m.variables)
            ? `
          (
            
    ${fields.addPostTypeField.variables.id
                ? `
      id: ${fields.addPostTypeField.variables.id}
    `
                : ``}
  

    ${fields.addPostTypeField.variables.input
                ? `
      input: ${fields.addPostTypeField.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.addPostTypeField.fields)}
        }
      `
        : ``}
    

      ${fields.addReaction
        ? `
        addReaction
        ${((_o = fields.addReaction) === null || _o === void 0 ? void 0 : _o.variables)
            ? `
          (
            
    ${fields.addReaction.variables.input
                ? `
      input: ${fields.addReaction.variables.input}
    `
                : ``}
  

    ${fields.addReaction.variables.postId
                ? `
      postId: ${fields.addReaction.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.addReaction.fields)}
        }
      `
        : ``}
    

      ${fields.addReply
        ? `
        addReply
        ${((_p = fields.addReply) === null || _p === void 0 ? void 0 : _p.variables)
            ? `
          (
            
    ${fields.addReply.variables.input
                ? `
      input: ${fields.addReply.variables.input}
    `
                : ``}
  

    ${fields.addReply.variables.postId
                ? `
      postId: ${fields.addReply.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.addReply.fields)}
        }
      `
        : ``}
    

      ${fields.addSpace
        ? `
        addSpace
        ${((_q = fields.addSpace) === null || _q === void 0 ? void 0 : _q.variables)
            ? `
          (
            
    ${fields.addSpace.variables.input
                ? `
      input: ${fields.addSpace.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.addSpace.fields)}
        }
      `
        : ``}
    

      ${fields.addSpaceMembers
        ? `
        addSpaceMembers
        ${((_r = fields.addSpaceMembers) === null || _r === void 0 ? void 0 : _r.variables)
            ? `
          (
            
    ${fields.addSpaceMembers.variables.input
                ? `
      input: ${fields.addSpaceMembers.variables.input}
    `
                : ``}
  

    ${fields.addSpaceMembers.variables.spaceId
                ? `
      spaceId: ${fields.addSpaceMembers.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceMemberGQLFields(fields.addSpaceMembers.fields)}
        }
      `
        : ``}
    

      ${fields.addTrialPlan
        ? `
        addTrialPlan
        ${((_s = fields.addTrialPlan) === null || _s === void 0 ? void 0 : _s.variables)
            ? `
          (
            
    ${fields.addTrialPlan.variables.trial
                ? `
      trial: ${fields.addTrialPlan.variables.trial}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PlanGQLFields(fields.addTrialPlan.fields)}
        }
      `
        : ``}
    

      ${fields.approveSpaceJoinRequest
        ? `
        approveSpaceJoinRequest
        ${((_t = fields.approveSpaceJoinRequest) === null || _t === void 0 ? void 0 : _t.variables)
            ? `
          (
            
    ${fields.approveSpaceJoinRequest.variables.spaceId
                ? `
      spaceId: ${fields.approveSpaceJoinRequest.variables.spaceId}
    `
                : ``}
  

    ${fields.approveSpaceJoinRequest.variables.spaceJoinRequestId
                ? `
      spaceJoinRequestId: ${fields.approveSpaceJoinRequest.variables.spaceJoinRequestId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.approveSpaceJoinRequest.fields)}
        }
      `
        : ``}
    

      ${fields.approveSpaceMembershipRequest
        ? `
        approveSpaceMembershipRequest
        ${((_u = fields.approveSpaceMembershipRequest) === null || _u === void 0 ? void 0 : _u.variables)
            ? `
          (
            
    ${fields.approveSpaceMembershipRequest.variables.spaceId
                ? `
      spaceId: ${fields.approveSpaceMembershipRequest.variables.spaceId}
    `
                : ``}
  

    ${fields.approveSpaceMembershipRequest.variables.spaceMembershipRequestId
                ? `
      spaceMembershipRequestId: ${fields.approveSpaceMembershipRequest.variables.spaceMembershipRequestId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.approveSpaceMembershipRequest.fields)}
        }
      `
        : ``}
    

      ${fields.archiveMemberSchemaField
        ? `
        archiveMemberSchemaField
        ${((_v = fields.archiveMemberSchemaField) === null || _v === void 0 ? void 0 : _v.variables)
            ? `
          (
            
    ${fields.archiveMemberSchemaField.variables.key
                ? `
      key: ${fields.archiveMemberSchemaField.variables.key}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.archiveMemberSchemaField.fields)}
        }
      `
        : ``}
    

      ${fields.archivePostTypeField
        ? `
        archivePostTypeField
        ${((_w = fields.archivePostTypeField) === null || _w === void 0 ? void 0 : _w.variables)
            ? `
          (
            
    ${fields.archivePostTypeField.variables.id
                ? `
      id: ${fields.archivePostTypeField.variables.id}
    `
                : ``}
  

    ${fields.archivePostTypeField.variables.key
                ? `
      key: ${fields.archivePostTypeField.variables.key}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.archivePostTypeField.fields)}
        }
      `
        : ``}
    

      ${fields.assignBadge
        ? `
        assignBadge
        ${((_x = fields.assignBadge) === null || _x === void 0 ? void 0 : _x.variables)
            ? `
          (
            
    ${fields.assignBadge.variables.id
                ? `
      id: ${fields.assignBadge.variables.id}
    `
                : ``}
  

    ${fields.assignBadge.variables.input
                ? `
      input: ${fields.assignBadge.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.assignBadge.fields)}
        }
      `
        : ``}
    

      ${fields.blockMember
        ? `
        blockMember
        ${((_y = fields.blockMember) === null || _y === void 0 ? void 0 : _y.variables)
            ? `
          (
            
    ${fields.blockMember.variables.memberId
                ? `
      memberId: ${fields.blockMember.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.blockMember.fields)}
        }
      `
        : ``}
    

      ${fields.callback
        ? `
        callback
        ${((_z = fields.callback) === null || _z === void 0 ? void 0 : _z.variables)
            ? `
          (
            
    ${fields.callback.variables.appId
                ? `
      appId: ${fields.callback.variables.appId}
    `
                : ``}
  

    ${fields.callback.variables.callbackId
                ? `
      callbackId: ${fields.callback.variables.callbackId}
    `
                : ``}
  

    ${fields.callback.variables.context
                ? `
      context: ${fields.callback.variables.context}
    `
                : ``}
  

    ${fields.callback.variables.dynamicBlockId
                ? `
      dynamicBlockId: ${fields.callback.variables.dynamicBlockId}
    `
                : ``}
  

    ${fields.callback.variables.entityId
                ? `
      entityId: ${fields.callback.variables.entityId}
    `
                : ``}
  

    ${fields.callback.variables.inputs
                ? `
      inputs: ${fields.callback.variables.inputs}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CallbackResponseGQLFields(fields.callback.fields)}
        }
      `
        : ``}
    

      ${fields.cancelEmailUpdate
        ? `
        cancelEmailUpdate
        ${((_0 = fields.cancelEmailUpdate) === null || _0 === void 0 ? void 0 : _0.variables)
            ? `
          (
            
    ${fields.cancelEmailUpdate.variables.id
                ? `
      id: ${fields.cancelEmailUpdate.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.cancelEmailUpdate.fields)}
        }
      `
        : ``}
    

      ${fields.changeNetworkSubscriptionPlan
        ? `
        changeNetworkSubscriptionPlan
        ${((_1 = fields.changeNetworkSubscriptionPlan) === null || _1 === void 0 ? void 0 : _1.variables)
            ? `
          (
            
    ${fields.changeNetworkSubscriptionPlan.variables.name
                ? `
      name: ${fields.changeNetworkSubscriptionPlan.variables.name}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.changeNetworkSubscriptionPlan.fields)}
        }
      `
        : ``}
    

    ${fields.clearNewDomain
        ? `
      clearNewDomain {
        ${ActionGQLFields(fields.clearNewDomain)}
      }
    `
        : ``}
  

    ${fields.clearNotificationsCount
        ? `
      clearNotificationsCount {
        ${ActionGQLFields(fields.clearNotificationsCount)}
      }
    `
        : ``}
  

      ${fields.closeSpace
        ? `
        closeSpace
        ${((_2 = fields.closeSpace) === null || _2 === void 0 ? void 0 : _2.variables)
            ? `
          (
            
    ${fields.closeSpace.variables.spaceId
                ? `
      spaceId: ${fields.closeSpace.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.closeSpace.fields)}
        }
      `
        : ``}
    

      ${fields.confirmMassActionRequest
        ? `
        confirmMassActionRequest
        ${((_3 = fields.confirmMassActionRequest) === null || _3 === void 0 ? void 0 : _3.variables)
            ? `
          (
            
    ${fields.confirmMassActionRequest.variables.massActionRequestId
                ? `
      massActionRequestId: ${fields.confirmMassActionRequest.variables.massActionRequestId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MassActionRequestGQLFields(fields.confirmMassActionRequest.fields)}
        }
      `
        : ``}
    

      ${fields.confirmResetPassword
        ? `
        confirmResetPassword
        ${((_4 = fields.confirmResetPassword) === null || _4 === void 0 ? void 0 : _4.variables)
            ? `
          (
            
    ${fields.confirmResetPassword.variables.input
                ? `
      input: ${fields.confirmResetPassword.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.confirmResetPassword.fields)}
        }
      `
        : ``}
    

      ${fields.createAccessGroup
        ? `
        createAccessGroup
        ${((_5 = fields.createAccessGroup) === null || _5 === void 0 ? void 0 : _5.variables)
            ? `
          (
            
    ${fields.createAccessGroup.variables.input
                ? `
      input: ${fields.createAccessGroup.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AccessGroupGQLFields(fields.createAccessGroup.fields)}
        }
      `
        : ``}
    

      ${fields.createBadge
        ? `
        createBadge
        ${((_6 = fields.createBadge) === null || _6 === void 0 ? void 0 : _6.variables)
            ? `
          (
            
    ${fields.createBadge.variables.input
                ? `
      input: ${fields.createBadge.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${BadgeGQLFields(fields.createBadge.fields)}
        }
      `
        : ``}
    

      ${fields.createCollection
        ? `
        createCollection
        ${((_7 = fields.createCollection) === null || _7 === void 0 ? void 0 : _7.variables)
            ? `
          (
            
    ${fields.createCollection.variables.input
                ? `
      input: ${fields.createCollection.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CollectionGQLFields(fields.createCollection.fields)}
        }
      `
        : ``}
    

      ${fields.createEmojis
        ? `
        createEmojis
        ${((_8 = fields.createEmojis) === null || _8 === void 0 ? void 0 : _8.variables)
            ? `
          (
            
    ${fields.createEmojis.variables.input
                ? `
      input: ${fields.createEmojis.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmojiGQLFields(fields.createEmojis.fields)}
        }
      `
        : ``}
    

      ${fields.createExportMemberRequest
        ? `
        createExportMemberRequest
        ${((_9 = fields.createExportMemberRequest) === null || _9 === void 0 ? void 0 : _9.variables)
            ? `
          (
            
    ${fields.createExportMemberRequest.variables.input
                ? `
      input: ${fields.createExportMemberRequest.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ExportGQLFields(fields.createExportMemberRequest.fields)}
        }
      `
        : ``}
    

      ${fields.createFiles
        ? `
        createFiles
        ${((_10 = fields.createFiles) === null || _10 === void 0 ? void 0 : _10.variables)
            ? `
          (
            
    ${fields.createFiles.variables.input
                ? `
      input: ${fields.createFiles.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SignedUrlGQLFields(fields.createFiles.fields)}
        }
      `
        : ``}
    

      ${fields.createImages
        ? `
        createImages
        ${((_11 = fields.createImages) === null || _11 === void 0 ? void 0 : _11.variables)
            ? `
          (
            
    ${fields.createImages.variables.input
                ? `
      input: ${fields.createImages.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SignedUrlGQLFields(fields.createImages.fields)}
        }
      `
        : ``}
    

      ${fields.createMassActionRequest
        ? `
        createMassActionRequest
        ${((_12 = fields.createMassActionRequest) === null || _12 === void 0 ? void 0 : _12.variables)
            ? `
          (
            
    ${fields.createMassActionRequest.variables.input
                ? `
      input: ${fields.createMassActionRequest.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MassActionRequestGQLFields(fields.createMassActionRequest.fields)}
        }
      `
        : ``}
    

      ${fields.createModerationReport
        ? `
        createModerationReport
        ${((_13 = fields.createModerationReport) === null || _13 === void 0 ? void 0 : _13.variables)
            ? `
          (
            
    ${fields.createModerationReport.variables.input
                ? `
      input: ${fields.createModerationReport.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ModerationItemGQLFields(fields.createModerationReport.fields)}
        }
      `
        : ``}
    

      ${fields.createNetwork
        ? `
        createNetwork
        ${((_14 = fields.createNetwork) === null || _14 === void 0 ? void 0 : _14.variables)
            ? `
          (
            
    ${fields.createNetwork.variables.input
                ? `
      input: ${fields.createNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenWithOtpGQLFields(fields.createNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.createPermission
        ? `
        createPermission
        ${((_15 = fields.createPermission) === null || _15 === void 0 ? void 0 : _15.variables)
            ? `
          (
            
    ${fields.createPermission.variables.input
                ? `
      input: ${fields.createPermission.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PermissionGQLFields(fields.createPermission.fields)}
        }
      `
        : ``}
    

      ${fields.createPost
        ? `
        createPost
        ${((_16 = fields.createPost) === null || _16 === void 0 ? void 0 : _16.variables)
            ? `
          (
            
    ${fields.createPost.variables.input
                ? `
      input: ${fields.createPost.variables.input}
    `
                : ``}
  

    ${fields.createPost.variables.spaceId
                ? `
      spaceId: ${fields.createPost.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.createPost.fields)}
        }
      `
        : ``}
    

      ${fields.createPostType
        ? `
        createPostType
        ${((_17 = fields.createPostType) === null || _17 === void 0 ? void 0 : _17.variables)
            ? `
          (
            
    ${fields.createPostType.variables.input
                ? `
      input: ${fields.createPostType.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.createPostType.fields)}
        }
      `
        : ``}
    

      ${fields.createReply
        ? `
        createReply
        ${((_18 = fields.createReply) === null || _18 === void 0 ? void 0 : _18.variables)
            ? `
          (
            
    ${fields.createReply.variables.input
                ? `
      input: ${fields.createReply.variables.input}
    `
                : ``}
  

    ${fields.createReply.variables.postId
                ? `
      postId: ${fields.createReply.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.createReply.fields)}
        }
      `
        : ``}
    

      ${fields.createReport
        ? `
        createReport
        ${((_19 = fields.createReport) === null || _19 === void 0 ? void 0 : _19.variables)
            ? `
          (
            
    ${fields.createReport.variables.input
                ? `
      input: ${fields.createReport.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ModerationItemGQLFields(fields.createReport.fields)}
        }
      `
        : ``}
    

      ${fields.createSpace
        ? `
        createSpace
        ${((_20 = fields.createSpace) === null || _20 === void 0 ? void 0 : _20.variables)
            ? `
          (
            
    ${fields.createSpace.variables.input
                ? `
      input: ${fields.createSpace.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.createSpace.fields)}
        }
      `
        : ``}
    

      ${fields.createSpaceFromTemplate
        ? `
        createSpaceFromTemplate
        ${((_21 = fields.createSpaceFromTemplate) === null || _21 === void 0 ? void 0 : _21.variables)
            ? `
          (
            
    ${fields.createSpaceFromTemplate.variables.input
                ? `
      input: ${fields.createSpaceFromTemplate.variables.input}
    `
                : ``}
  

    ${fields.createSpaceFromTemplate.variables.style
                ? `
      style: ${fields.createSpaceFromTemplate.variables.style}
    `
                : ``}
  

    ${fields.createSpaceFromTemplate.variables.templateId
                ? `
      templateId: ${fields.createSpaceFromTemplate.variables.templateId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${TemplateRequestGQLFields(fields.createSpaceFromTemplate.fields)}
        }
      `
        : ``}
    

      ${fields.createTag
        ? `
        createTag
        ${((_22 = fields.createTag) === null || _22 === void 0 ? void 0 : _22.variables)
            ? `
          (
            
    ${fields.createTag.variables.input
                ? `
      input: ${fields.createTag.variables.input}
    `
                : ``}
  

    ${fields.createTag.variables.spaceId
                ? `
      spaceId: ${fields.createTag.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${TagGQLFields(fields.createTag.fields)}
        }
      `
        : ``}
    

      ${fields.createTemplate
        ? `
        createTemplate
        ${((_23 = fields.createTemplate) === null || _23 === void 0 ? void 0 : _23.variables)
            ? `
          (
            
    ${fields.createTemplate.variables.input
                ? `
      input: ${fields.createTemplate.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${TemplateGQLFields(fields.createTemplate.fields)}
        }
      `
        : ``}
    

      ${fields.declineSpaceJoinRequest
        ? `
        declineSpaceJoinRequest
        ${((_24 = fields.declineSpaceJoinRequest) === null || _24 === void 0 ? void 0 : _24.variables)
            ? `
          (
            
    ${fields.declineSpaceJoinRequest.variables.spaceId
                ? `
      spaceId: ${fields.declineSpaceJoinRequest.variables.spaceId}
    `
                : ``}
  

    ${fields.declineSpaceJoinRequest.variables.spaceJoinRequestId
                ? `
      spaceJoinRequestId: ${fields.declineSpaceJoinRequest.variables.spaceJoinRequestId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.declineSpaceJoinRequest.fields)}
        }
      `
        : ``}
    

      ${fields.declineSpaceMembershipRequest
        ? `
        declineSpaceMembershipRequest
        ${((_25 = fields.declineSpaceMembershipRequest) === null || _25 === void 0 ? void 0 : _25.variables)
            ? `
          (
            
    ${fields.declineSpaceMembershipRequest.variables.spaceId
                ? `
      spaceId: ${fields.declineSpaceMembershipRequest.variables.spaceId}
    `
                : ``}
  

    ${fields.declineSpaceMembershipRequest.variables.spaceMembershipRequestId
                ? `
      spaceMembershipRequestId: ${fields.declineSpaceMembershipRequest.variables.spaceMembershipRequestId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.declineSpaceMembershipRequest.fields)}
        }
      `
        : ``}
    

      ${fields.deleteAccessGroup
        ? `
        deleteAccessGroup
        ${((_26 = fields.deleteAccessGroup) === null || _26 === void 0 ? void 0 : _26.variables)
            ? `
          (
            
    ${fields.deleteAccessGroup.variables.id
                ? `
      id: ${fields.deleteAccessGroup.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteAccessGroup.fields)}
        }
      `
        : ``}
    

      ${fields.deleteBadge
        ? `
        deleteBadge
        ${((_27 = fields.deleteBadge) === null || _27 === void 0 ? void 0 : _27.variables)
            ? `
          (
            
    ${fields.deleteBadge.variables.id
                ? `
      id: ${fields.deleteBadge.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteBadge.fields)}
        }
      `
        : ``}
    

      ${fields.deleteCollection
        ? `
        deleteCollection
        ${((_28 = fields.deleteCollection) === null || _28 === void 0 ? void 0 : _28.variables)
            ? `
          (
            
    ${fields.deleteCollection.variables.id
                ? `
      id: ${fields.deleteCollection.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteCollection.fields)}
        }
      `
        : ``}
    

      ${fields.deleteMember
        ? `
        deleteMember
        ${((_29 = fields.deleteMember) === null || _29 === void 0 ? void 0 : _29.variables)
            ? `
          (
            
    ${fields.deleteMember.variables.id
                ? `
      id: ${fields.deleteMember.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteMember.fields)}
        }
      `
        : ``}
    

      ${fields.deleteMemberSchemaField
        ? `
        deleteMemberSchemaField
        ${((_30 = fields.deleteMemberSchemaField) === null || _30 === void 0 ? void 0 : _30.variables)
            ? `
          (
            
    ${fields.deleteMemberSchemaField.variables.key
                ? `
      key: ${fields.deleteMemberSchemaField.variables.key}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.deleteMemberSchemaField.fields)}
        }
      `
        : ``}
    

    ${fields.deleteNetwork
        ? `
      deleteNetwork {
        ${ActionGQLFields(fields.deleteNetwork)}
      }
    `
        : ``}
  

      ${fields.deleteNotification
        ? `
        deleteNotification
        ${((_31 = fields.deleteNotification) === null || _31 === void 0 ? void 0 : _31.variables)
            ? `
          (
            
    ${fields.deleteNotification.variables.notificationId
                ? `
      notificationId: ${fields.deleteNotification.variables.notificationId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteNotification.fields)}
        }
      `
        : ``}
    

      ${fields.deleteNotifications
        ? `
        deleteNotifications
        ${((_32 = fields.deleteNotifications) === null || _32 === void 0 ? void 0 : _32.variables)
            ? `
          (
            
    ${fields.deleteNotifications.variables.ids
                ? `
      ids: ${fields.deleteNotifications.variables.ids}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteNotifications.fields)}
        }
      `
        : ``}
    

      ${fields.deletePermission
        ? `
        deletePermission
        ${((_33 = fields.deletePermission) === null || _33 === void 0 ? void 0 : _33.variables)
            ? `
          (
            
    ${fields.deletePermission.variables.id
                ? `
      id: ${fields.deletePermission.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deletePermission.fields)}
        }
      `
        : ``}
    

      ${fields.deletePost
        ? `
        deletePost
        ${((_34 = fields.deletePost) === null || _34 === void 0 ? void 0 : _34.variables)
            ? `
          (
            
    ${fields.deletePost.variables.id
                ? `
      id: ${fields.deletePost.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deletePost.fields)}
        }
      `
        : ``}
    

      ${fields.deletePostTypeField
        ? `
        deletePostTypeField
        ${((_35 = fields.deletePostTypeField) === null || _35 === void 0 ? void 0 : _35.variables)
            ? `
          (
            
    ${fields.deletePostTypeField.variables.id
                ? `
      id: ${fields.deletePostTypeField.variables.id}
    `
                : ``}
  

    ${fields.deletePostTypeField.variables.key
                ? `
      key: ${fields.deletePostTypeField.variables.key}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.deletePostTypeField.fields)}
        }
      `
        : ``}
    

      ${fields.deleteSpace
        ? `
        deleteSpace
        ${((_36 = fields.deleteSpace) === null || _36 === void 0 ? void 0 : _36.variables)
            ? `
          (
            
    ${fields.deleteSpace.variables.id
                ? `
      id: ${fields.deleteSpace.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteSpace.fields)}
        }
      `
        : ``}
    

      ${fields.deleteSpacePostTypes
        ? `
        deleteSpacePostTypes
        ${((_37 = fields.deleteSpacePostTypes) === null || _37 === void 0 ? void 0 : _37.variables)
            ? `
          (
            
    ${fields.deleteSpacePostTypes.variables.postTypeIds
                ? `
      postTypeIds: ${fields.deleteSpacePostTypes.variables.postTypeIds}
    `
                : ``}
  

    ${fields.deleteSpacePostTypes.variables.spaceId
                ? `
      spaceId: ${fields.deleteSpacePostTypes.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteSpacePostTypes.fields)}
        }
      `
        : ``}
    

      ${fields.deleteSsoMembership
        ? `
        deleteSsoMembership
        ${((_38 = fields.deleteSsoMembership) === null || _38 === void 0 ? void 0 : _38.variables)
            ? `
          (
            
    ${fields.deleteSsoMembership.variables.memberId
                ? `
      memberId: ${fields.deleteSsoMembership.variables.memberId}
    `
                : ``}
  

    ${fields.deleteSsoMembership.variables.type
                ? `
      type: ${fields.deleteSsoMembership.variables.type}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteSsoMembership.fields)}
        }
      `
        : ``}
    

      ${fields.deleteTag
        ? `
        deleteTag
        ${((_39 = fields.deleteTag) === null || _39 === void 0 ? void 0 : _39.variables)
            ? `
          (
            
    ${fields.deleteTag.variables.id
                ? `
      id: ${fields.deleteTag.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteTag.fields)}
        }
      `
        : ``}
    

      ${fields.deleteTemplate
        ? `
        deleteTemplate
        ${((_40 = fields.deleteTemplate) === null || _40 === void 0 ? void 0 : _40.variables)
            ? `
          (
            
    ${fields.deleteTemplate.variables.id
                ? `
      id: ${fields.deleteTemplate.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.deleteTemplate.fields)}
        }
      `
        : ``}
    

      ${fields.doResetPassword
        ? `
        doResetPassword
        ${((_41 = fields.doResetPassword) === null || _41 === void 0 ? void 0 : _41.variables)
            ? `
          (
            
    ${fields.doResetPassword.variables.input
                ? `
      input: ${fields.doResetPassword.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.doResetPassword.fields)}
        }
      `
        : ``}
    

      ${fields.editImage
        ? `
        editImage
        ${((_42 = fields.editImage) === null || _42 === void 0 ? void 0 : _42.variables)
            ? `
          (
            
    ${fields.editImage.variables.imageId
                ? `
      imageId: ${fields.editImage.variables.imageId}
    `
                : ``}
  

    ${fields.editImage.variables.input
                ? `
      input: ${fields.editImage.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ImageGQLFields(fields.editImage.fields)}
        }
      `
        : ``}
    

      ${fields.extendCurrentTrial
        ? `
        extendCurrentTrial
        ${((_43 = fields.extendCurrentTrial) === null || _43 === void 0 ? void 0 : _43.variables)
            ? `
          (
            
    ${fields.extendCurrentTrial.variables.newEndDate
                ? `
      newEndDate: ${fields.extendCurrentTrial.variables.newEndDate}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PlanGQLFields(fields.extendCurrentTrial.fields)}
        }
      `
        : ``}
    

      ${fields.globalAddAppCollaborator
        ? `
        globalAddAppCollaborator
        ${((_44 = fields.globalAddAppCollaborator) === null || _44 === void 0 ? void 0 : _44.variables)
            ? `
          (
            
    ${fields.globalAddAppCollaborator.variables.appId
                ? `
      appId: ${fields.globalAddAppCollaborator.variables.appId}
    `
                : ``}
  

    ${fields.globalAddAppCollaborator.variables.input
                ? `
      input: ${fields.globalAddAppCollaborator.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppCollaboratorGQLFields(fields.globalAddAppCollaborator.fields)}
        }
      `
        : ``}
    

      ${fields.globalCreateApp
        ? `
        globalCreateApp
        ${((_45 = fields.globalCreateApp) === null || _45 === void 0 ? void 0 : _45.variables)
            ? `
          (
            
    ${fields.globalCreateApp.variables.input
                ? `
      input: ${fields.globalCreateApp.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.globalCreateApp.fields)}
        }
      `
        : ``}
    

      ${fields.globalCreateEmojis
        ? `
        globalCreateEmojis
        ${((_46 = fields.globalCreateEmojis) === null || _46 === void 0 ? void 0 : _46.variables)
            ? `
          (
            
    ${fields.globalCreateEmojis.variables.input
                ? `
      input: ${fields.globalCreateEmojis.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmojiGQLFields(fields.globalCreateEmojis.fields)}
        }
      `
        : ``}
    

      ${fields.globalCreateImages
        ? `
        globalCreateImages
        ${((_47 = fields.globalCreateImages) === null || _47 === void 0 ? void 0 : _47.variables)
            ? `
          (
            
    ${fields.globalCreateImages.variables.input
                ? `
      input: ${fields.globalCreateImages.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SignedUrlGQLFields(fields.globalCreateImages.fields)}
        }
      `
        : ``}
    

      ${fields.globalDeleteApp
        ? `
        globalDeleteApp
        ${((_48 = fields.globalDeleteApp) === null || _48 === void 0 ? void 0 : _48.variables)
            ? `
          (
            
    ${fields.globalDeleteApp.variables.id
                ? `
      id: ${fields.globalDeleteApp.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.globalDeleteApp.fields)}
        }
      `
        : ``}
    

      ${fields.globalDeleteAppSetting
        ? `
        globalDeleteAppSetting
        ${((_49 = fields.globalDeleteAppSetting) === null || _49 === void 0 ? void 0 : _49.variables)
            ? `
          (
            
    ${fields.globalDeleteAppSetting.variables.context
                ? `
      context: ${fields.globalDeleteAppSetting.variables.context}
    `
                : ``}
  

    ${fields.globalDeleteAppSetting.variables.entityId
                ? `
      entityId: ${fields.globalDeleteAppSetting.variables.entityId}
    `
                : ``}
  

    ${fields.globalDeleteAppSetting.variables.networkId
                ? `
      networkId: ${fields.globalDeleteAppSetting.variables.networkId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppSettingGQLFields(fields.globalDeleteAppSetting.fields)}
        }
      `
        : ``}
    

      ${fields.globalPublishAppPrivately
        ? `
        globalPublishAppPrivately
        ${((_50 = fields.globalPublishAppPrivately) === null || _50 === void 0 ? void 0 : _50.variables)
            ? `
          (
            
    ${fields.globalPublishAppPrivately.variables.appId
                ? `
      appId: ${fields.globalPublishAppPrivately.variables.appId}
    `
                : ``}
  

    ${fields.globalPublishAppPrivately.variables.networkId
                ? `
      networkId: ${fields.globalPublishAppPrivately.variables.networkId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppPublicationGQLFields(fields.globalPublishAppPrivately.fields)}
        }
      `
        : ``}
    

      ${fields.globalRegenerateClientSecret
        ? `
        globalRegenerateClientSecret
        ${((_51 = fields.globalRegenerateClientSecret) === null || _51 === void 0 ? void 0 : _51.variables)
            ? `
          (
            
    ${fields.globalRegenerateClientSecret.variables.appId
                ? `
      appId: ${fields.globalRegenerateClientSecret.variables.appId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.globalRegenerateClientSecret.fields)}
        }
      `
        : ``}
    

      ${fields.globalRemoveAppCollaborator
        ? `
        globalRemoveAppCollaborator
        ${((_52 = fields.globalRemoveAppCollaborator) === null || _52 === void 0 ? void 0 : _52.variables)
            ? `
          (
            
    ${fields.globalRemoveAppCollaborator.variables.appId
                ? `
      appId: ${fields.globalRemoveAppCollaborator.variables.appId}
    `
                : ``}
  

    ${fields.globalRemoveAppCollaborator.variables.collaboratorId
                ? `
      collaboratorId: ${fields.globalRemoveAppCollaborator.variables.collaboratorId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.globalRemoveAppCollaborator.fields)}
        }
      `
        : ``}
    

      ${fields.globalTestAppWebhook
        ? `
        globalTestAppWebhook
        ${((_53 = fields.globalTestAppWebhook) === null || _53 === void 0 ? void 0 : _53.variables)
            ? `
          (
            
    ${fields.globalTestAppWebhook.variables.appId
                ? `
      appId: ${fields.globalTestAppWebhook.variables.appId}
    `
                : ``}
  

    ${fields.globalTestAppWebhook.variables.input
                ? `
      input: ${fields.globalTestAppWebhook.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.globalTestAppWebhook.fields)}
        }
      `
        : ``}
    

      ${fields.globalUnPublishAppPrivately
        ? `
        globalUnPublishAppPrivately
        ${((_54 = fields.globalUnPublishAppPrivately) === null || _54 === void 0 ? void 0 : _54.variables)
            ? `
          (
            
    ${fields.globalUnPublishAppPrivately.variables.appId
                ? `
      appId: ${fields.globalUnPublishAppPrivately.variables.appId}
    `
                : ``}
  

    ${fields.globalUnPublishAppPrivately.variables.networkId
                ? `
      networkId: ${fields.globalUnPublishAppPrivately.variables.networkId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.globalUnPublishAppPrivately.fields)}
        }
      `
        : ``}
    

      ${fields.globalUpdateApp
        ? `
        globalUpdateApp
        ${((_55 = fields.globalUpdateApp) === null || _55 === void 0 ? void 0 : _55.variables)
            ? `
          (
            
    ${fields.globalUpdateApp.variables.id
                ? `
      id: ${fields.globalUpdateApp.variables.id}
    `
                : ``}
  

    ${fields.globalUpdateApp.variables.input
                ? `
      input: ${fields.globalUpdateApp.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.globalUpdateApp.fields)}
        }
      `
        : ``}
    

      ${fields.globalUpdateAppSetting
        ? `
        globalUpdateAppSetting
        ${((_56 = fields.globalUpdateAppSetting) === null || _56 === void 0 ? void 0 : _56.variables)
            ? `
          (
            
    ${fields.globalUpdateAppSetting.variables.context
                ? `
      context: ${fields.globalUpdateAppSetting.variables.context}
    `
                : ``}
  

    ${fields.globalUpdateAppSetting.variables.entityId
                ? `
      entityId: ${fields.globalUpdateAppSetting.variables.entityId}
    `
                : ``}
  

    ${fields.globalUpdateAppSetting.variables.networkId
                ? `
      networkId: ${fields.globalUpdateAppSetting.variables.networkId}
    `
                : ``}
  

    ${fields.globalUpdateAppSetting.variables.settings
                ? `
      settings: ${fields.globalUpdateAppSetting.variables.settings}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppSettingGQLFields(fields.globalUpdateAppSetting.fields)}
        }
      `
        : ``}
    

      ${fields.hidePost
        ? `
        hidePost
        ${((_57 = fields.hidePost) === null || _57 === void 0 ? void 0 : _57.variables)
            ? `
          (
            
    ${fields.hidePost.variables.id
                ? `
      id: ${fields.hidePost.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.hidePost.fields)}
        }
      `
        : ``}
    

      ${fields.impersonateLoginToNetwork
        ? `
        impersonateLoginToNetwork
        ${((_58 = fields.impersonateLoginToNetwork) === null || _58 === void 0 ? void 0 : _58.variables)
            ? `
          (
            
    ${fields.impersonateLoginToNetwork.variables.input
                ? `
      input: ${fields.impersonateLoginToNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthInfoWithOtpGQLFields(fields.impersonateLoginToNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.installApp
        ? `
        installApp
        ${((_59 = fields.installApp) === null || _59 === void 0 ? void 0 : _59.variables)
            ? `
          (
            
    ${fields.installApp.variables.appId
                ? `
      appId: ${fields.installApp.variables.appId}
    `
                : ``}
  

    ${fields.installApp.variables.input
                ? `
      input: ${fields.installApp.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppInstallationGQLFields(fields.installApp.fields)}
        }
      `
        : ``}
    

      ${fields.installAppOnAuthMember
        ? `
        installAppOnAuthMember
        ${((_60 = fields.installAppOnAuthMember) === null || _60 === void 0 ? void 0 : _60.variables)
            ? `
          (
            
    ${fields.installAppOnAuthMember.variables.appId
                ? `
      appId: ${fields.installAppOnAuthMember.variables.appId}
    `
                : ``}
  

    ${fields.installAppOnAuthMember.variables.input
                ? `
      input: ${fields.installAppOnAuthMember.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppInstallationGQLFields(fields.installAppOnAuthMember.fields)}
        }
      `
        : ``}
    

      ${fields.interactWithApps
        ? `
        interactWithApps
        ${((_61 = fields.interactWithApps) === null || _61 === void 0 ? void 0 : _61.variables)
            ? `
          (
            
    ${fields.interactWithApps.variables.context
                ? `
      context: ${fields.interactWithApps.variables.context}
    `
                : ``}
  

    ${fields.interactWithApps.variables.entityId
                ? `
      entityId: ${fields.interactWithApps.variables.entityId}
    `
                : ``}
  

    ${fields.interactWithApps.variables.input
                ? `
      input: ${fields.interactWithApps.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppInteractionGQLFields(fields.interactWithApps.fields)}
        }
      `
        : ``}
    

      ${fields.inviteMembers
        ? `
        inviteMembers
        ${((_62 = fields.inviteMembers) === null || _62 === void 0 ? void 0 : _62.variables)
            ? `
          (
            
    ${fields.inviteMembers.variables.input
                ? `
      input: ${fields.inviteMembers.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationGQLFields(fields.inviteMembers.fields)}
        }
      `
        : ``}
    

      ${fields.joinNetwork
        ? `
        joinNetwork
        ${((_63 = fields.joinNetwork) === null || _63 === void 0 ? void 0 : _63.variables)
            ? `
          (
            
    ${fields.joinNetwork.variables.input
                ? `
      input: ${fields.joinNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.joinNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.joinNetworkWithInvitationLink
        ? `
        joinNetworkWithInvitationLink
        ${((_64 = fields.joinNetworkWithInvitationLink) === null || _64 === void 0 ? void 0 : _64.variables)
            ? `
          (
            
    ${fields.joinNetworkWithInvitationLink.variables.input
                ? `
      input: ${fields.joinNetworkWithInvitationLink.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.joinNetworkWithInvitationLink.fields)}
        }
      `
        : ``}
    

      ${fields.joinNetworkWithToken
        ? `
        joinNetworkWithToken
        ${((_65 = fields.joinNetworkWithToken) === null || _65 === void 0 ? void 0 : _65.variables)
            ? `
          (
            
    ${fields.joinNetworkWithToken.variables.input
                ? `
      input: ${fields.joinNetworkWithToken.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.joinNetworkWithToken.fields)}
        }
      `
        : ``}
    

      ${fields.joinSpace
        ? `
        joinSpace
        ${((_66 = fields.joinSpace) === null || _66 === void 0 ? void 0 : _66.variables)
            ? `
          (
            
    ${fields.joinSpace.variables.spaceId
                ? `
      spaceId: ${fields.joinSpace.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.joinSpace.fields)}
        }
      `
        : ``}
    

      ${fields.leaveSpace
        ? `
        leaveSpace
        ${((_67 = fields.leaveSpace) === null || _67 === void 0 ? void 0 : _67.variables)
            ? `
          (
            
    ${fields.leaveSpace.variables.spaceId
                ? `
      spaceId: ${fields.leaveSpace.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.leaveSpace.fields)}
        }
      `
        : ``}
    

      ${fields.loginNetwork
        ? `
        loginNetwork
        ${((_68 = fields.loginNetwork) === null || _68 === void 0 ? void 0 : _68.variables)
            ? `
          (
            
    ${fields.loginNetwork.variables.input
                ? `
      input: ${fields.loginNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.loginNetworkWithPassword
        ? `
        loginNetworkWithPassword
        ${((_69 = fields.loginNetworkWithPassword) === null || _69 === void 0 ? void 0 : _69.variables)
            ? `
          (
            
    ${fields.loginNetworkWithPassword.variables.input
                ? `
      input: ${fields.loginNetworkWithPassword.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginNetworkWithPassword.fields)}
        }
      `
        : ``}
    

      ${fields.loginWithSamlResponse
        ? `
        loginWithSamlResponse
        ${((_70 = fields.loginWithSamlResponse) === null || _70 === void 0 ? void 0 : _70.variables)
            ? `
          (
            
    ${fields.loginWithSamlResponse.variables.input
                ? `
      input: ${fields.loginWithSamlResponse.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginWithSamlResponse.fields)}
        }
      `
        : ``}
    

      ${fields.loginWithSsoCode
        ? `
        loginWithSsoCode
        ${((_71 = fields.loginWithSsoCode) === null || _71 === void 0 ? void 0 : _71.variables)
            ? `
          (
            
    ${fields.loginWithSsoCode.variables.input
                ? `
      input: ${fields.loginWithSsoCode.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginWithSsoCode.fields)}
        }
      `
        : ``}
    

      ${fields.logoutMemberSessions
        ? `
        logoutMemberSessions
        ${((_72 = fields.logoutMemberSessions) === null || _72 === void 0 ? void 0 : _72.variables)
            ? `
          (
            
    ${fields.logoutMemberSessions.variables.memberId
                ? `
      memberId: ${fields.logoutMemberSessions.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.logoutMemberSessions.fields)}
        }
      `
        : ``}
    

      ${fields.logoutNetwork
        ? `
        logoutNetwork
        ${((_73 = fields.logoutNetwork) === null || _73 === void 0 ? void 0 : _73.variables)
            ? `
          (
            
    ${fields.logoutNetwork.variables.input
                ? `
      input: ${fields.logoutNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.logoutNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.movePost
        ? `
        movePost
        ${((_74 = fields.movePost) === null || _74 === void 0 ? void 0 : _74.variables)
            ? `
          (
            
    ${fields.movePost.variables.id
                ? `
      id: ${fields.movePost.variables.id}
    `
                : ``}
  

    ${fields.movePost.variables.sendNotification
                ? `
      sendNotification: ${fields.movePost.variables.sendNotification}
    `
                : ``}
  

    ${fields.movePost.variables.spaceId
                ? `
      spaceId: ${fields.movePost.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.movePost.fields)}
        }
      `
        : ``}
    

      ${fields.movePosts
        ? `
        movePosts
        ${((_75 = fields.movePosts) === null || _75 === void 0 ? void 0 : _75.variables)
            ? `
          (
            
    ${fields.movePosts.variables.ids
                ? `
      ids: ${fields.movePosts.variables.ids}
    `
                : ``}
  

    ${fields.movePosts.variables.sendNotification
                ? `
      sendNotification: ${fields.movePosts.variables.sendNotification}
    `
                : ``}
  

    ${fields.movePosts.variables.spaceId
                ? `
      spaceId: ${fields.movePosts.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.movePosts.fields)}
        }
      `
        : ``}
    

      ${fields.organizeCollections
        ? `
        organizeCollections
        ${((_76 = fields.organizeCollections) === null || _76 === void 0 ? void 0 : _76.variables)
            ? `
          (
            
    ${fields.organizeCollections.variables.ids
                ? `
      ids: ${fields.organizeCollections.variables.ids}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.organizeCollections.fields)}
        }
      `
        : ``}
    

      ${fields.organizeGroupSpaces
        ? `
        organizeGroupSpaces
        ${((_77 = fields.organizeGroupSpaces) === null || _77 === void 0 ? void 0 : _77.variables)
            ? `
          (
            
    ${fields.organizeGroupSpaces.variables.groupId
                ? `
      groupId: ${fields.organizeGroupSpaces.variables.groupId}
    `
                : ``}
  

    ${fields.organizeGroupSpaces.variables.spaceIds
                ? `
      spaceIds: ${fields.organizeGroupSpaces.variables.spaceIds}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.organizeGroupSpaces.fields)}
        }
      `
        : ``}
    

      ${fields.organizeGroups
        ? `
        organizeGroups
        ${((_78 = fields.organizeGroups) === null || _78 === void 0 ? void 0 : _78.variables)
            ? `
          (
            
    ${fields.organizeGroups.variables.groupIds
                ? `
      groupIds: ${fields.organizeGroups.variables.groupIds}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.organizeGroups.fields)}
        }
      `
        : ``}
    

      ${fields.organizeSpacesInCollection
        ? `
        organizeSpacesInCollection
        ${((_79 = fields.organizeSpacesInCollection) === null || _79 === void 0 ? void 0 : _79.variables)
            ? `
          (
            
    ${fields.organizeSpacesInCollection.variables.collectionId
                ? `
      collectionId: ${fields.organizeSpacesInCollection.variables.collectionId}
    `
                : ``}
  

    ${fields.organizeSpacesInCollection.variables.spaceIds
                ? `
      spaceIds: ${fields.organizeSpacesInCollection.variables.spaceIds}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.organizeSpacesInCollection.fields)}
        }
      `
        : ``}
    

      ${fields.pinPostToSpace
        ? `
        pinPostToSpace
        ${((_80 = fields.pinPostToSpace) === null || _80 === void 0 ? void 0 : _80.variables)
            ? `
          (
            
    ${fields.pinPostToSpace.variables.postId
                ? `
      postId: ${fields.pinPostToSpace.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.pinPostToSpace.fields)}
        }
      `
        : ``}
    

      ${fields.pinReplyToPost
        ? `
        pinReplyToPost
        ${((_81 = fields.pinReplyToPost) === null || _81 === void 0 ? void 0 : _81.variables)
            ? `
          (
            
    ${fields.pinReplyToPost.variables.postId
                ? `
      postId: ${fields.pinReplyToPost.variables.postId}
    `
                : ``}
  

    ${fields.pinReplyToPost.variables.replyId
                ? `
      replyId: ${fields.pinReplyToPost.variables.replyId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.pinReplyToPost.fields)}
        }
      `
        : ``}
    

      ${fields.publishAppPrivately
        ? `
        publishAppPrivately
        ${((_82 = fields.publishAppPrivately) === null || _82 === void 0 ? void 0 : _82.variables)
            ? `
          (
            
    ${fields.publishAppPrivately.variables.appId
                ? `
      appId: ${fields.publishAppPrivately.variables.appId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppPublicationGQLFields(fields.publishAppPrivately.fields)}
        }
      `
        : ``}
    

      ${fields.publishTemplate
        ? `
        publishTemplate
        ${((_83 = fields.publishTemplate) === null || _83 === void 0 ? void 0 : _83.variables)
            ? `
          (
            
    ${fields.publishTemplate.variables.id
                ? `
      id: ${fields.publishTemplate.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.publishTemplate.fields)}
        }
      `
        : ``}
    

      ${fields.purchase
        ? `
        purchase
        ${((_84 = fields.purchase) === null || _84 === void 0 ? void 0 : _84.variables)
            ? `
          (
            
    ${fields.purchase.variables.input
                ? `
      input: ${fields.purchase.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SubscriptionGQLFields(fields.purchase.fields)}
        }
      `
        : ``}
    

      ${fields.readNotification
        ? `
        readNotification
        ${((_85 = fields.readNotification) === null || _85 === void 0 ? void 0 : _85.variables)
            ? `
          (
            
    ${fields.readNotification.variables.notificationId
                ? `
      notificationId: ${fields.readNotification.variables.notificationId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.readNotification.fields)}
        }
      `
        : ``}
    

      ${fields.readNotifications
        ? `
        readNotifications
        ${((_86 = fields.readNotifications) === null || _86 === void 0 ? void 0 : _86.variables)
            ? `
          (
            
    ${fields.readNotifications.variables.ids
                ? `
      ids: ${fields.readNotifications.variables.ids}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.readNotifications.fields)}
        }
      `
        : ``}
    

      ${fields.readSpace
        ? `
        readSpace
        ${((_87 = fields.readSpace) === null || _87 === void 0 ? void 0 : _87.variables)
            ? `
          (
            
    ${fields.readSpace.variables.date
                ? `
      date: ${fields.readSpace.variables.date}
    `
                : ``}
  

    ${fields.readSpace.variables.spaceId
                ? `
      spaceId: ${fields.readSpace.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.readSpace.fields)}
        }
      `
        : ``}
    

      ${fields.removeGroup
        ? `
        removeGroup
        ${((_88 = fields.removeGroup) === null || _88 === void 0 ? void 0 : _88.variables)
            ? `
          (
            
    ${fields.removeGroup.variables.groupId
                ? `
      groupId: ${fields.removeGroup.variables.groupId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.removeGroup.fields)}
        }
      `
        : ``}
    

      ${fields.removeMember
        ? `
        removeMember
        ${((_89 = fields.removeMember) === null || _89 === void 0 ? void 0 : _89.variables)
            ? `
          (
            
    ${fields.removeMember.variables.memberId
                ? `
      memberId: ${fields.removeMember.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.removeMember.fields)}
        }
      `
        : ``}
    

    ${fields.removeNetwork
        ? `
      removeNetwork {
        ${ActionGQLFields(fields.removeNetwork)}
      }
    `
        : ``}
  

      ${fields.removePost
        ? `
        removePost
        ${((_90 = fields.removePost) === null || _90 === void 0 ? void 0 : _90.variables)
            ? `
          (
            
    ${fields.removePost.variables.postId
                ? `
      postId: ${fields.removePost.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.removePost.fields)}
        }
      `
        : ``}
    

      ${fields.removeReaction
        ? `
        removeReaction
        ${((_91 = fields.removeReaction) === null || _91 === void 0 ? void 0 : _91.variables)
            ? `
          (
            
    ${fields.removeReaction.variables.participantId
                ? `
      participantId: ${fields.removeReaction.variables.participantId}
    `
                : ``}
  

    ${fields.removeReaction.variables.postId
                ? `
      postId: ${fields.removeReaction.variables.postId}
    `
                : ``}
  

    ${fields.removeReaction.variables.reaction
                ? `
      reaction: ${fields.removeReaction.variables.reaction}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.removeReaction.fields)}
        }
      `
        : ``}
    

      ${fields.removeSpace
        ? `
        removeSpace
        ${((_92 = fields.removeSpace) === null || _92 === void 0 ? void 0 : _92.variables)
            ? `
          (
            
    ${fields.removeSpace.variables.spaceId
                ? `
      spaceId: ${fields.removeSpace.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.removeSpace.fields)}
        }
      `
        : ``}
    

      ${fields.removeSpaceMembers
        ? `
        removeSpaceMembers
        ${((_93 = fields.removeSpaceMembers) === null || _93 === void 0 ? void 0 : _93.variables)
            ? `
          (
            
    ${fields.removeSpaceMembers.variables.memberIds
                ? `
      memberIds: ${fields.removeSpaceMembers.variables.memberIds}
    `
                : ``}
  

    ${fields.removeSpaceMembers.variables.spaceId
                ? `
      spaceId: ${fields.removeSpaceMembers.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.removeSpaceMembers.fields)}
        }
      `
        : ``}
    

      ${fields.reorderMemberSchemaFields
        ? `
        reorderMemberSchemaFields
        ${((_94 = fields.reorderMemberSchemaFields) === null || _94 === void 0 ? void 0 : _94.variables)
            ? `
          (
            
    ${fields.reorderMemberSchemaFields.variables.input
                ? `
      input: ${fields.reorderMemberSchemaFields.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.reorderMemberSchemaFields.fields)}
        }
      `
        : ``}
    

      ${fields.reorderPostTypeFields
        ? `
        reorderPostTypeFields
        ${((_95 = fields.reorderPostTypeFields) === null || _95 === void 0 ? void 0 : _95.variables)
            ? `
          (
            
    ${fields.reorderPostTypeFields.variables.id
                ? `
      id: ${fields.reorderPostTypeFields.variables.id}
    `
                : ``}
  

    ${fields.reorderPostTypeFields.variables.input
                ? `
      input: ${fields.reorderPostTypeFields.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.reorderPostTypeFields.fields)}
        }
      `
        : ``}
    

      ${fields.requestGlobalTokenCode
        ? `
        requestGlobalTokenCode
        ${((_96 = fields.requestGlobalTokenCode) === null || _96 === void 0 ? void 0 : _96.variables)
            ? `
          (
            
    ${fields.requestGlobalTokenCode.variables.input
                ? `
      input: ${fields.requestGlobalTokenCode.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.requestGlobalTokenCode.fields)}
        }
      `
        : ``}
    

      ${fields.requestSpaceMembership
        ? `
        requestSpaceMembership
        ${((_97 = fields.requestSpaceMembership) === null || _97 === void 0 ? void 0 : _97.variables)
            ? `
          (
            
    ${fields.requestSpaceMembership.variables.spaceId
                ? `
      spaceId: ${fields.requestSpaceMembership.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceJoinRequestGQLFields(fields.requestSpaceMembership.fields)}
        }
      `
        : ``}
    

      ${fields.resendGlobalTokenCode
        ? `
        resendGlobalTokenCode
        ${((_98 = fields.resendGlobalTokenCode) === null || _98 === void 0 ? void 0 : _98.variables)
            ? `
          (
            
    ${fields.resendGlobalTokenCode.variables.input
                ? `
      input: ${fields.resendGlobalTokenCode.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.resendGlobalTokenCode.fields)}
        }
      `
        : ``}
    

      ${fields.resendMemberInvitation
        ? `
        resendMemberInvitation
        ${((_99 = fields.resendMemberInvitation) === null || _99 === void 0 ? void 0 : _99.variables)
            ? `
          (
            
    ${fields.resendMemberInvitation.variables.id
                ? `
      id: ${fields.resendMemberInvitation.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.resendMemberInvitation.fields)}
        }
      `
        : ``}
    

    ${fields.resendVerification
        ? `
      resendVerification {
        ${ActionGQLFields(fields.resendVerification)}
      }
    `
        : ``}
  

      ${fields.resetPassword
        ? `
        resetPassword
        ${((_100 = fields.resetPassword) === null || _100 === void 0 ? void 0 : _100.variables)
            ? `
          (
            
    ${fields.resetPassword.variables.input
                ? `
      input: ${fields.resetPassword.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.resetPassword.fields)}
        }
      `
        : ``}
    

      ${fields.revokeBadge
        ? `
        revokeBadge
        ${((_101 = fields.revokeBadge) === null || _101 === void 0 ? void 0 : _101.variables)
            ? `
          (
            
    ${fields.revokeBadge.variables.id
                ? `
      id: ${fields.revokeBadge.variables.id}
    `
                : ``}
  

    ${fields.revokeBadge.variables.input
                ? `
      input: ${fields.revokeBadge.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.revokeBadge.fields)}
        }
      `
        : ``}
    

      ${fields.revokeMemberInvitation
        ? `
        revokeMemberInvitation
        ${((_102 = fields.revokeMemberInvitation) === null || _102 === void 0 ? void 0 : _102.variables)
            ? `
          (
            
    ${fields.revokeMemberInvitation.variables.id
                ? `
      id: ${fields.revokeMemberInvitation.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.revokeMemberInvitation.fields)}
        }
      `
        : ``}
    

      ${fields.runMigration
        ? `
        runMigration
        ${((_103 = fields.runMigration) === null || _103 === void 0 ? void 0 : _103.variables)
            ? `
          (
            
    ${fields.runMigration.variables.id
                ? `
      id: ${fields.runMigration.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MigrationGQLFields(fields.runMigration.fields)}
        }
      `
        : ``}
    

      ${fields.sendResetPasswordEmail
        ? `
        sendResetPasswordEmail
        ${((_104 = fields.sendResetPasswordEmail) === null || _104 === void 0 ? void 0 : _104.variables)
            ? `
          (
            
    ${fields.sendResetPasswordEmail.variables.email
                ? `
      email: ${fields.sendResetPasswordEmail.variables.email}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.sendResetPasswordEmail.fields)}
        }
      `
        : ``}
    

      ${fields.setPrivatelyPublishedApps
        ? `
        setPrivatelyPublishedApps
        ${((_105 = fields.setPrivatelyPublishedApps) === null || _105 === void 0 ? void 0 : _105.variables)
            ? `
          (
            
    ${fields.setPrivatelyPublishedApps.variables.ids
                ? `
      ids: ${fields.setPrivatelyPublishedApps.variables.ids}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppPublicationGQLFields(fields.setPrivatelyPublishedApps.fields)}
        }
      `
        : ``}
    

      ${fields.ssoRedirect
        ? `
        ssoRedirect
        ${((_106 = fields.ssoRedirect) === null || _106 === void 0 ? void 0 : _106.variables)
            ? `
          (
            
    ${fields.ssoRedirect.variables.input
                ? `
      input: ${fields.ssoRedirect.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.ssoRedirect.fields)}
        }
      `
        : ``}
    

      ${fields.supportSsoRedirect
        ? `
        supportSsoRedirect
        ${((_107 = fields.supportSsoRedirect) === null || _107 === void 0 ? void 0 : _107.variables)
            ? `
          (
            
    ${fields.supportSsoRedirect.variables.input
                ? `
      input: ${fields.supportSsoRedirect.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SupportAuthTokenGQLFields(fields.supportSsoRedirect.fields)}
        }
      `
        : ``}
    

      ${fields.suspendMember
        ? `
        suspendMember
        ${((_108 = fields.suspendMember) === null || _108 === void 0 ? void 0 : _108.variables)
            ? `
          (
            
    ${fields.suspendMember.variables.memberId
                ? `
      memberId: ${fields.suspendMember.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.suspendMember.fields)}
        }
      `
        : ``}
    

      ${fields.syncTemplate
        ? `
        syncTemplate
        ${((_109 = fields.syncTemplate) === null || _109 === void 0 ? void 0 : _109.variables)
            ? `
          (
            
    ${fields.syncTemplate.variables.id
                ? `
      id: ${fields.syncTemplate.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${TemplateGQLFields(fields.syncTemplate.fields)}
        }
      `
        : ``}
    

    ${fields.transferToNewDomain
        ? `
      transferToNewDomain {
        ${ActionGQLFields(fields.transferToNewDomain)}
      }
    `
        : ``}
  

      ${fields.unArchiveMemberSchemaField
        ? `
        unArchiveMemberSchemaField
        ${((_110 = fields.unArchiveMemberSchemaField) === null || _110 === void 0 ? void 0 : _110.variables)
            ? `
          (
            
    ${fields.unArchiveMemberSchemaField.variables.key
                ? `
      key: ${fields.unArchiveMemberSchemaField.variables.key}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.unArchiveMemberSchemaField.fields)}
        }
      `
        : ``}
    
unPublishAppPrivately
        ${((_111 = fields.unPublishAppPrivately) === null || _111 === void 0 ? void 0 : _111.variables)
        ? `
          (
            
    ${fields.unPublishAppPrivately.variables.appId
            ? `
      appId: ${fields.unPublishAppPrivately.variables.appId}
    `
            : ``}
  

    ${fields.unPublishAppPrivately.variables.networkId
            ? `
      networkId: ${fields.unPublishAppPrivately.variables.networkId}
    `
            : ``}
  
          )
        `
        : ``}
      

      ${fields.unarchivePostTypeField
        ? `
        unarchivePostTypeField
        ${((_112 = fields.unarchivePostTypeField) === null || _112 === void 0 ? void 0 : _112.variables)
            ? `
          (
            
    ${fields.unarchivePostTypeField.variables.id
                ? `
      id: ${fields.unarchivePostTypeField.variables.id}
    `
                : ``}
  

    ${fields.unarchivePostTypeField.variables.key
                ? `
      key: ${fields.unarchivePostTypeField.variables.key}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.unarchivePostTypeField.fields)}
        }
      `
        : ``}
    

      ${fields.unblockMember
        ? `
        unblockMember
        ${((_113 = fields.unblockMember) === null || _113 === void 0 ? void 0 : _113.variables)
            ? `
          (
            
    ${fields.unblockMember.variables.memberId
                ? `
      memberId: ${fields.unblockMember.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unblockMember.fields)}
        }
      `
        : ``}
    

      ${fields.unhidePost
        ? `
        unhidePost
        ${((_114 = fields.unhidePost) === null || _114 === void 0 ? void 0 : _114.variables)
            ? `
          (
            
    ${fields.unhidePost.variables.id
                ? `
      id: ${fields.unhidePost.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unhidePost.fields)}
        }
      `
        : ``}
    

      ${fields.uninstallApp
        ? `
        uninstallApp
        ${((_115 = fields.uninstallApp) === null || _115 === void 0 ? void 0 : _115.variables)
            ? `
          (
            
    ${fields.uninstallApp.variables.appInstallationId
                ? `
      appInstallationId: ${fields.uninstallApp.variables.appInstallationId}
    `
                : ``}
  

    ${fields.uninstallApp.variables.reason
                ? `
      reason: ${fields.uninstallApp.variables.reason}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppInstallationGQLFields(fields.uninstallApp.fields)}
        }
      `
        : ``}
    

      ${fields.unpinPostFromSpace
        ? `
        unpinPostFromSpace
        ${((_116 = fields.unpinPostFromSpace) === null || _116 === void 0 ? void 0 : _116.variables)
            ? `
          (
            
    ${fields.unpinPostFromSpace.variables.postId
                ? `
      postId: ${fields.unpinPostFromSpace.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unpinPostFromSpace.fields)}
        }
      `
        : ``}
    

      ${fields.unpinReplyFromPost
        ? `
        unpinReplyFromPost
        ${((_117 = fields.unpinReplyFromPost) === null || _117 === void 0 ? void 0 : _117.variables)
            ? `
          (
            
    ${fields.unpinReplyFromPost.variables.postId
                ? `
      postId: ${fields.unpinReplyFromPost.variables.postId}
    `
                : ``}
  

    ${fields.unpinReplyFromPost.variables.replyId
                ? `
      replyId: ${fields.unpinReplyFromPost.variables.replyId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unpinReplyFromPost.fields)}
        }
      `
        : ``}
    

      ${fields.unpublishTemplate
        ? `
        unpublishTemplate
        ${((_118 = fields.unpublishTemplate) === null || _118 === void 0 ? void 0 : _118.variables)
            ? `
          (
            
    ${fields.unpublishTemplate.variables.id
                ? `
      id: ${fields.unpublishTemplate.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unpublishTemplate.fields)}
        }
      `
        : ``}
    

      ${fields.unsubscribeFromNotification
        ? `
        unsubscribeFromNotification
        ${((_119 = fields.unsubscribeFromNotification) === null || _119 === void 0 ? void 0 : _119.variables)
            ? `
          (
            
    ${fields.unsubscribeFromNotification.variables.input
                ? `
      input: ${fields.unsubscribeFromNotification.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unsubscribeFromNotification.fields)}
        }
      `
        : ``}
    

      ${fields.unsubscribeWithToken
        ? `
        unsubscribeWithToken
        ${((_120 = fields.unsubscribeWithToken) === null || _120 === void 0 ? void 0 : _120.variables)
            ? `
          (
            
    ${fields.unsubscribeWithToken.variables.input
                ? `
      input: ${fields.unsubscribeWithToken.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unsubscribeWithToken.fields)}
        }
      `
        : ``}
    

      ${fields.unsuspendMember
        ? `
        unsuspendMember
        ${((_121 = fields.unsuspendMember) === null || _121 === void 0 ? void 0 : _121.variables)
            ? `
          (
            
    ${fields.unsuspendMember.variables.memberId
                ? `
      memberId: ${fields.unsuspendMember.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.unsuspendMember.fields)}
        }
      `
        : ``}
    

      ${fields.updateAccessGroup
        ? `
        updateAccessGroup
        ${((_122 = fields.updateAccessGroup) === null || _122 === void 0 ? void 0 : _122.variables)
            ? `
          (
            
    ${fields.updateAccessGroup.variables.id
                ? `
      id: ${fields.updateAccessGroup.variables.id}
    `
                : ``}
  

    ${fields.updateAccessGroup.variables.input
                ? `
      input: ${fields.updateAccessGroup.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AccessGroupGQLFields(fields.updateAccessGroup.fields)}
        }
      `
        : ``}
    

      ${fields.updateAppInstallation
        ? `
        updateAppInstallation
        ${((_123 = fields.updateAppInstallation) === null || _123 === void 0 ? void 0 : _123.variables)
            ? `
          (
            
    ${fields.updateAppInstallation.variables.appInstallationId
                ? `
      appInstallationId: ${fields.updateAppInstallation.variables.appInstallationId}
    `
                : ``}
  

    ${fields.updateAppInstallation.variables.input
                ? `
      input: ${fields.updateAppInstallation.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppInstallationGQLFields(fields.updateAppInstallation.fields)}
        }
      `
        : ``}
    

      ${fields.updateAppNetworkSettings
        ? `
        updateAppNetworkSettings
        ${((_124 = fields.updateAppNetworkSettings) === null || _124 === void 0 ? void 0 : _124.variables)
            ? `
          (
            
    ${fields.updateAppNetworkSettings.variables.appId
                ? `
      appId: ${fields.updateAppNetworkSettings.variables.appId}
    `
                : ``}
  

    ${fields.updateAppNetworkSettings.variables.settings
                ? `
      settings: ${fields.updateAppNetworkSettings.variables.settings}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppActionGQLFields(fields.updateAppNetworkSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateAppSpaceSetting
        ? `
        updateAppSpaceSetting
        ${((_125 = fields.updateAppSpaceSetting) === null || _125 === void 0 ? void 0 : _125.variables)
            ? `
          (
            
    ${fields.updateAppSpaceSetting.variables.appId
                ? `
      appId: ${fields.updateAppSpaceSetting.variables.appId}
    `
                : ``}
  

    ${fields.updateAppSpaceSetting.variables.settings
                ? `
      settings: ${fields.updateAppSpaceSetting.variables.settings}
    `
                : ``}
  

    ${fields.updateAppSpaceSetting.variables.spaceId
                ? `
      spaceId: ${fields.updateAppSpaceSetting.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppActionGQLFields(fields.updateAppSpaceSetting.fields)}
        }
      `
        : ``}
    
updateAppStanding
        ${((_126 = fields.updateAppStanding) === null || _126 === void 0 ? void 0 : _126.variables)
        ? `
          (
            
    ${fields.updateAppStanding.variables.appId
            ? `
      appId: ${fields.updateAppStanding.variables.appId}
    `
            : ``}
  

    ${fields.updateAppStanding.variables.standing
            ? `
      standing: ${fields.updateAppStanding.variables.standing}
    `
            : ``}
  
          )
        `
        : ``}
      
updateAppStatus
        ${((_127 = fields.updateAppStatus) === null || _127 === void 0 ? void 0 : _127.variables)
        ? `
          (
            
    ${fields.updateAppStatus.variables.appId
            ? `
      appId: ${fields.updateAppStatus.variables.appId}
    `
            : ``}
  

    ${fields.updateAppStatus.variables.status
            ? `
      status: ${fields.updateAppStatus.variables.status}
    `
            : ``}
  
          )
        `
        : ``}
      

      ${fields.updateAuthMember
        ? `
        updateAuthMember
        ${((_128 = fields.updateAuthMember) === null || _128 === void 0 ? void 0 : _128.variables)
            ? `
          (
            
    ${fields.updateAuthMember.variables.input
                ? `
      input: ${fields.updateAuthMember.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberGQLFields(fields.updateAuthMember.fields)}
        }
      `
        : ``}
    

      ${fields.updateBadge
        ? `
        updateBadge
        ${((_129 = fields.updateBadge) === null || _129 === void 0 ? void 0 : _129.variables)
            ? `
          (
            
    ${fields.updateBadge.variables.id
                ? `
      id: ${fields.updateBadge.variables.id}
    `
                : ``}
  

    ${fields.updateBadge.variables.input
                ? `
      input: ${fields.updateBadge.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${BadgeGQLFields(fields.updateBadge.fields)}
        }
      `
        : ``}
    

      ${fields.updateBillingDetails
        ? `
        updateBillingDetails
        ${((_130 = fields.updateBillingDetails) === null || _130 === void 0 ? void 0 : _130.variables)
            ? `
          (
            
    ${fields.updateBillingDetails.variables.input
                ? `
      input: ${fields.updateBillingDetails.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${BillingDetailsGQLFields(fields.updateBillingDetails.fields)}
        }
      `
        : ``}
    

      ${fields.updateCollection
        ? `
        updateCollection
        ${((_131 = fields.updateCollection) === null || _131 === void 0 ? void 0 : _131.variables)
            ? `
          (
            
    ${fields.updateCollection.variables.id
                ? `
      id: ${fields.updateCollection.variables.id}
    `
                : ``}
  

    ${fields.updateCollection.variables.input
                ? `
      input: ${fields.updateCollection.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateCollection.fields)}
        }
      `
        : ``}
    

      ${fields.updateCustomSso
        ? `
        updateCustomSso
        ${((_132 = fields.updateCustomSso) === null || _132 === void 0 ? void 0 : _132.variables)
            ? `
          (
            
    ${fields.updateCustomSso.variables.input
                ? `
      input: ${fields.updateCustomSso.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SsoGQLFields(fields.updateCustomSso.fields)}
        }
      `
        : ``}
    

      ${fields.updateDefaultSsoStatus
        ? `
        updateDefaultSsoStatus
        ${((_133 = fields.updateDefaultSsoStatus) === null || _133 === void 0 ? void 0 : _133.variables)
            ? `
          (
            
    ${fields.updateDefaultSsoStatus.variables.sso
                ? `
      sso: ${fields.updateDefaultSsoStatus.variables.sso}
    `
                : ``}
  

    ${fields.updateDefaultSsoStatus.variables.status
                ? `
      status: ${fields.updateDefaultSsoStatus.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateDefaultSsoStatus.fields)}
        }
      `
        : ``}
    

      ${fields.updateFile
        ? `
        updateFile
        ${((_134 = fields.updateFile) === null || _134 === void 0 ? void 0 : _134.variables)
            ? `
          (
            
    ${fields.updateFile.variables.id
                ? `
      id: ${fields.updateFile.variables.id}
    `
                : ``}
  

    ${fields.updateFile.variables.input
                ? `
      input: ${fields.updateFile.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${FileGQLFields(fields.updateFile.fields)}
        }
      `
        : ``}
    

      ${fields.updateGroup
        ? `
        updateGroup
        ${((_135 = fields.updateGroup) === null || _135 === void 0 ? void 0 : _135.variables)
            ? `
          (
            
    ${fields.updateGroup.variables.groupId
                ? `
      groupId: ${fields.updateGroup.variables.groupId}
    `
                : ``}
  

    ${fields.updateGroup.variables.input
                ? `
      input: ${fields.updateGroup.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateGroup.fields)}
        }
      `
        : ``}
    

      ${fields.updateImage
        ? `
        updateImage
        ${((_136 = fields.updateImage) === null || _136 === void 0 ? void 0 : _136.variables)
            ? `
          (
            
    ${fields.updateImage.variables.id
                ? `
      id: ${fields.updateImage.variables.id}
    `
                : ``}
  

    ${fields.updateImage.variables.input
                ? `
      input: ${fields.updateImage.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ImageGQLFields(fields.updateImage.fields)}
        }
      `
        : ``}
    

      ${fields.updateJwtSso
        ? `
        updateJwtSso
        ${((_137 = fields.updateJwtSso) === null || _137 === void 0 ? void 0 : _137.variables)
            ? `
          (
            
    ${fields.updateJwtSso.variables.input
                ? `
      input: ${fields.updateJwtSso.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SsoGQLFields(fields.updateJwtSso.fields)}
        }
      `
        : ``}
    

      ${fields.updateMember
        ? `
        updateMember
        ${((_138 = fields.updateMember) === null || _138 === void 0 ? void 0 : _138.variables)
            ? `
          (
            
    ${fields.updateMember.variables.id
                ? `
      id: ${fields.updateMember.variables.id}
    `
                : ``}
  

    ${fields.updateMember.variables.input
                ? `
      input: ${fields.updateMember.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberGQLFields(fields.updateMember.fields)}
        }
      `
        : ``}
    

      ${fields.updateMemberInvitation
        ? `
        updateMemberInvitation
        ${((_139 = fields.updateMemberInvitation) === null || _139 === void 0 ? void 0 : _139.variables)
            ? `
          (
            
    ${fields.updateMemberInvitation.variables.id
                ? `
      id: ${fields.updateMemberInvitation.variables.id}
    `
                : ``}
  

    ${fields.updateMemberInvitation.variables.input
                ? `
      input: ${fields.updateMemberInvitation.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationGQLFields(fields.updateMemberInvitation.fields)}
        }
      `
        : ``}
    

      ${fields.updateMemberNetworkNotificationSettings
        ? `
        updateMemberNetworkNotificationSettings
        ${((_140 = fields.updateMemberNetworkNotificationSettings) === null || _140 === void 0 ? void 0 : _140.variables)
            ? `
          (
            
    ${fields.updateMemberNetworkNotificationSettings.variables.channel
                ? `
      channel: ${fields.updateMemberNetworkNotificationSettings.variables.channel}
    `
                : ``}
  

    ${fields.updateMemberNetworkNotificationSettings.variables.input
                ? `
      input: ${fields.updateMemberNetworkNotificationSettings.variables.input}
    `
                : ``}
  

    ${fields.updateMemberNetworkNotificationSettings.variables.memberId
                ? `
      memberId: ${fields.updateMemberNetworkNotificationSettings.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberNetworkNotificationSettingsGQLFields(fields.updateMemberNetworkNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateMemberPostNotificationSettings
        ? `
        updateMemberPostNotificationSettings
        ${((_141 = fields.updateMemberPostNotificationSettings) === null || _141 === void 0 ? void 0 : _141.variables)
            ? `
          (
            
    ${fields.updateMemberPostNotificationSettings.variables.input
                ? `
      input: ${fields.updateMemberPostNotificationSettings.variables.input}
    `
                : ``}
  

    ${fields.updateMemberPostNotificationSettings.variables.memberId
                ? `
      memberId: ${fields.updateMemberPostNotificationSettings.variables.memberId}
    `
                : ``}
  

    ${fields.updateMemberPostNotificationSettings.variables.postId
                ? `
      postId: ${fields.updateMemberPostNotificationSettings.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberPostNotificationSettingsGQLFields(fields.updateMemberPostNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateMemberPrivateMessagingSettings
        ? `
        updateMemberPrivateMessagingSettings
        ${((_142 = fields.updateMemberPrivateMessagingSettings) === null || _142 === void 0 ? void 0 : _142.variables)
            ? `
          (
            
    ${fields.updateMemberPrivateMessagingSettings.variables.input
                ? `
      input: ${fields.updateMemberPrivateMessagingSettings.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberPrivateMessagingSettingsGQLFields(fields.updateMemberPrivateMessagingSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateMemberSchemaField
        ? `
        updateMemberSchemaField
        ${((_143 = fields.updateMemberSchemaField) === null || _143 === void 0 ? void 0 : _143.variables)
            ? `
          (
            
    ${fields.updateMemberSchemaField.variables.input
                ? `
      input: ${fields.updateMemberSchemaField.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.updateMemberSchemaField.fields)}
        }
      `
        : ``}
    

      ${fields.updateMemberSpaceNotificationSettings
        ? `
        updateMemberSpaceNotificationSettings
        ${((_144 = fields.updateMemberSpaceNotificationSettings) === null || _144 === void 0 ? void 0 : _144.variables)
            ? `
          (
            
    ${fields.updateMemberSpaceNotificationSettings.variables.channel
                ? `
      channel: ${fields.updateMemberSpaceNotificationSettings.variables.channel}
    `
                : ``}
  

    ${fields.updateMemberSpaceNotificationSettings.variables.input
                ? `
      input: ${fields.updateMemberSpaceNotificationSettings.variables.input}
    `
                : ``}
  

    ${fields.updateMemberSpaceNotificationSettings.variables.memberId
                ? `
      memberId: ${fields.updateMemberSpaceNotificationSettings.variables.memberId}
    `
                : ``}
  

    ${fields.updateMemberSpaceNotificationSettings.variables.spaceId
                ? `
      spaceId: ${fields.updateMemberSpaceNotificationSettings.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberSpaceNotificationSettingsGQLFields(fields.updateMemberSpaceNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateMemberSpaceRole
        ? `
        updateMemberSpaceRole
        ${((_145 = fields.updateMemberSpaceRole) === null || _145 === void 0 ? void 0 : _145.variables)
            ? `
          (
            
    ${fields.updateMemberSpaceRole.variables.input
                ? `
      input: ${fields.updateMemberSpaceRole.variables.input}
    `
                : ``}
  

    ${fields.updateMemberSpaceRole.variables.memberId
                ? `
      memberId: ${fields.updateMemberSpaceRole.variables.memberId}
    `
                : ``}
  

    ${fields.updateMemberSpaceRole.variables.spaceId
                ? `
      spaceId: ${fields.updateMemberSpaceRole.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateMemberSpaceRole.fields)}
        }
      `
        : ``}
    

      ${fields.updateModeration
        ? `
        updateModeration
        ${((_146 = fields.updateModeration) === null || _146 === void 0 ? void 0 : _146.variables)
            ? `
          (
            
    ${fields.updateModeration.variables.id
                ? `
      id: ${fields.updateModeration.variables.id}
    `
                : ``}
  

    ${fields.updateModeration.variables.input
                ? `
      input: ${fields.updateModeration.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateModeration.fields)}
        }
      `
        : ``}
    

      ${fields.updateModerationItem
        ? `
        updateModerationItem
        ${((_147 = fields.updateModerationItem) === null || _147 === void 0 ? void 0 : _147.variables)
            ? `
          (
            
    ${fields.updateModerationItem.variables.id
                ? `
      id: ${fields.updateModerationItem.variables.id}
    `
                : ``}
  

    ${fields.updateModerationItem.variables.input
                ? `
      input: ${fields.updateModerationItem.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateModerationItem.fields)}
        }
      `
        : ``}
    

      ${fields.updateModerationSettings
        ? `
        updateModerationSettings
        ${((_148 = fields.updateModerationSettings) === null || _148 === void 0 ? void 0 : _148.variables)
            ? `
          (
            
    ${fields.updateModerationSettings.variables.input
                ? `
      input: ${fields.updateModerationSettings.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ModerationSettingsGQLFields(fields.updateModerationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateNetwork
        ? `
        updateNetwork
        ${((_149 = fields.updateNetwork) === null || _149 === void 0 ? void 0 : _149.variables)
            ? `
          (
            
    ${fields.updateNetwork.variables.input
                ? `
      input: ${fields.updateNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.updateNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.updateNetworkAvailableLocales
        ? `
        updateNetworkAvailableLocales
        ${((_150 = fields.updateNetworkAvailableLocales) === null || _150 === void 0 ? void 0 : _150.variables)
            ? `
          (
            
    ${fields.updateNetworkAvailableLocales.variables.availableLocales
                ? `
      availableLocales: ${fields.updateNetworkAvailableLocales.variables.availableLocales}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.updateNetworkAvailableLocales.fields)}
        }
      `
        : ``}
    

      ${fields.updateNetworkCustomCapacities
        ? `
        updateNetworkCustomCapacities
        ${((_151 = fields.updateNetworkCustomCapacities) === null || _151 === void 0 ? void 0 : _151.variables)
            ? `
          (
            
    ${fields.updateNetworkCustomCapacities.variables.additionalSeats
                ? `
      additionalSeats: ${fields.updateNetworkCustomCapacities.variables.additionalSeats}
    `
                : ``}
  

    ${fields.updateNetworkCustomCapacities.variables.customMemberCapacity
                ? `
      customMemberCapacity: ${fields.updateNetworkCustomCapacities.variables.customMemberCapacity}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.updateNetworkCustomCapacities.fields)}
        }
      `
        : ``}
    

      ${fields.updateNetworkDomainSubfolder
        ? `
        updateNetworkDomainSubfolder
        ${((_152 = fields.updateNetworkDomainSubfolder) === null || _152 === void 0 ? void 0 : _152.variables)
            ? `
          (
            
    ${fields.updateNetworkDomainSubfolder.variables.domainSubfolder
                ? `
      domainSubfolder: ${fields.updateNetworkDomainSubfolder.variables.domainSubfolder}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NetworkGQLFields(fields.updateNetworkDomainSubfolder.fields)}
        }
      `
        : ``}
    

      ${fields.updateNetworkMediaSettings
        ? `
        updateNetworkMediaSettings
        ${((_153 = fields.updateNetworkMediaSettings) === null || _153 === void 0 ? void 0 : _153.variables)
            ? `
          (
            
    ${fields.updateNetworkMediaSettings.variables.input
                ? `
      input: ${fields.updateNetworkMediaSettings.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MediaNetworkSettingsGQLFields(fields.updateNetworkMediaSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateNetworkNotificationSettings
        ? `
        updateNetworkNotificationSettings
        ${((_154 = fields.updateNetworkNotificationSettings) === null || _154 === void 0 ? void 0 : _154.variables)
            ? `
          (
            
    ${fields.updateNetworkNotificationSettings.variables.input
                ? `
      input: ${fields.updateNetworkNotificationSettings.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NotificationNetworkSettingsGQLFields(fields.updateNetworkNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateNetworkStatus
        ? `
        updateNetworkStatus
        ${((_155 = fields.updateNetworkStatus) === null || _155 === void 0 ? void 0 : _155.variables)
            ? `
          (
            
    ${fields.updateNetworkStatus.variables.input
                ? `
      input: ${fields.updateNetworkStatus.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateNetworkStatus.fields)}
        }
      `
        : ``}
    

      ${fields.updateNewDomain
        ? `
        updateNewDomain
        ${((_156 = fields.updateNewDomain) === null || _156 === void 0 ? void 0 : _156.variables)
            ? `
          (
            
    ${fields.updateNewDomain.variables.input
                ? `
      input: ${fields.updateNewDomain.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DomainTransferStatusGQLFields(fields.updateNewDomain.fields)}
        }
      `
        : ``}
    

      ${fields.updatePasswordWithToken
        ? `
        updatePasswordWithToken
        ${((_157 = fields.updatePasswordWithToken) === null || _157 === void 0 ? void 0 : _157.variables)
            ? `
          (
            
    ${fields.updatePasswordWithToken.variables.input
                ? `
      input: ${fields.updatePasswordWithToken.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updatePasswordWithToken.fields)}
        }
      `
        : ``}
    

      ${fields.updatePermission
        ? `
        updatePermission
        ${((_158 = fields.updatePermission) === null || _158 === void 0 ? void 0 : _158.variables)
            ? `
          (
            
    ${fields.updatePermission.variables.id
                ? `
      id: ${fields.updatePermission.variables.id}
    `
                : ``}
  

    ${fields.updatePermission.variables.input
                ? `
      input: ${fields.updatePermission.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PermissionGQLFields(fields.updatePermission.fields)}
        }
      `
        : ``}
    

      ${fields.updatePost
        ? `
        updatePost
        ${((_159 = fields.updatePost) === null || _159 === void 0 ? void 0 : _159.variables)
            ? `
          (
            
    ${fields.updatePost.variables.id
                ? `
      id: ${fields.updatePost.variables.id}
    `
                : ``}
  

    ${fields.updatePost.variables.input
                ? `
      input: ${fields.updatePost.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.updatePost.fields)}
        }
      `
        : ``}
    

      ${fields.updatePostType
        ? `
        updatePostType
        ${((_160 = fields.updatePostType) === null || _160 === void 0 ? void 0 : _160.variables)
            ? `
          (
            
    ${fields.updatePostType.variables.id
                ? `
      id: ${fields.updatePostType.variables.id}
    `
                : ``}
  

    ${fields.updatePostType.variables.input
                ? `
      input: ${fields.updatePostType.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.updatePostType.fields)}
        }
      `
        : ``}
    

      ${fields.updatePostTypeField
        ? `
        updatePostTypeField
        ${((_161 = fields.updatePostTypeField) === null || _161 === void 0 ? void 0 : _161.variables)
            ? `
          (
            
    ${fields.updatePostTypeField.variables.id
                ? `
      id: ${fields.updatePostTypeField.variables.id}
    `
                : ``}
  

    ${fields.updatePostTypeField.variables.input
                ? `
      input: ${fields.updatePostTypeField.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.updatePostTypeField.fields)}
        }
      `
        : ``}
    

      ${fields.updatePrivateMessagingSettings
        ? `
        updatePrivateMessagingSettings
        ${((_162 = fields.updatePrivateMessagingSettings) === null || _162 === void 0 ? void 0 : _162.variables)
            ? `
          (
            
    ${fields.updatePrivateMessagingSettings.variables.input
                ? `
      input: ${fields.updatePrivateMessagingSettings.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PrivateMessagingSettingsGQLFields(fields.updatePrivateMessagingSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateSpace
        ? `
        updateSpace
        ${((_163 = fields.updateSpace) === null || _163 === void 0 ? void 0 : _163.variables)
            ? `
          (
            
    ${fields.updateSpace.variables.id
                ? `
      id: ${fields.updateSpace.variables.id}
    `
                : ``}
  

    ${fields.updateSpace.variables.input
                ? `
      input: ${fields.updateSpace.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.updateSpace.fields)}
        }
      `
        : ``}
    

      ${fields.updateSpaceDefaultNotificationSettings
        ? `
        updateSpaceDefaultNotificationSettings
        ${((_164 = fields.updateSpaceDefaultNotificationSettings) === null || _164 === void 0 ? void 0 : _164.variables)
            ? `
          (
            
    ${fields.updateSpaceDefaultNotificationSettings.variables.channel
                ? `
      channel: ${fields.updateSpaceDefaultNotificationSettings.variables.channel}
    `
                : ``}
  

    ${fields.updateSpaceDefaultNotificationSettings.variables.input
                ? `
      input: ${fields.updateSpaceDefaultNotificationSettings.variables.input}
    `
                : ``}
  

    ${fields.updateSpaceDefaultNotificationSettings.variables.spaceId
                ? `
      spaceId: ${fields.updateSpaceDefaultNotificationSettings.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceDefaultNotificationSettingsGQLFields(fields.updateSpaceDefaultNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.updateSpaceHighlightedTags
        ? `
        updateSpaceHighlightedTags
        ${((_165 = fields.updateSpaceHighlightedTags) === null || _165 === void 0 ? void 0 : _165.variables)
            ? `
          (
            
    ${fields.updateSpaceHighlightedTags.variables.input
                ? `
      input: ${fields.updateSpaceHighlightedTags.variables.input}
    `
                : ``}
  

    ${fields.updateSpaceHighlightedTags.variables.spaceId
                ? `
      spaceId: ${fields.updateSpaceHighlightedTags.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateSpaceHighlightedTags.fields)}
        }
      `
        : ``}
    

      ${fields.updateSpaceMemberRole
        ? `
        updateSpaceMemberRole
        ${((_166 = fields.updateSpaceMemberRole) === null || _166 === void 0 ? void 0 : _166.variables)
            ? `
          (
            
    ${fields.updateSpaceMemberRole.variables.input
                ? `
      input: ${fields.updateSpaceMemberRole.variables.input}
    `
                : ``}
  

    ${fields.updateSpaceMemberRole.variables.memberId
                ? `
      memberId: ${fields.updateSpaceMemberRole.variables.memberId}
    `
                : ``}
  

    ${fields.updateSpaceMemberRole.variables.spaceId
                ? `
      spaceId: ${fields.updateSpaceMemberRole.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateSpaceMemberRole.fields)}
        }
      `
        : ``}
    

      ${fields.updateSpacePostTypes
        ? `
        updateSpacePostTypes
        ${((_167 = fields.updateSpacePostTypes) === null || _167 === void 0 ? void 0 : _167.variables)
            ? `
          (
            
    ${fields.updateSpacePostTypes.variables.input
                ? `
      input: ${fields.updateSpacePostTypes.variables.input}
    `
                : ``}
  

    ${fields.updateSpacePostTypes.variables.spaceId
                ? `
      spaceId: ${fields.updateSpacePostTypes.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpacePostTypeGQLFields(fields.updateSpacePostTypes.fields)}
        }
      `
        : ``}
    

      ${fields.updateSpaceTagFilter
        ? `
        updateSpaceTagFilter
        ${((_168 = fields.updateSpaceTagFilter) === null || _168 === void 0 ? void 0 : _168.variables)
            ? `
          (
            
    ${fields.updateSpaceTagFilter.variables.input
                ? `
      input: ${fields.updateSpaceTagFilter.variables.input}
    `
                : ``}
  

    ${fields.updateSpaceTagFilter.variables.spaceId
                ? `
      spaceId: ${fields.updateSpaceTagFilter.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateSpaceTagFilter.fields)}
        }
      `
        : ``}
    

      ${fields.updateSpaceTopicFilter
        ? `
        updateSpaceTopicFilter
        ${((_169 = fields.updateSpaceTopicFilter) === null || _169 === void 0 ? void 0 : _169.variables)
            ? `
          (
            
    ${fields.updateSpaceTopicFilter.variables.input
                ? `
      input: ${fields.updateSpaceTopicFilter.variables.input}
    `
                : ``}
  

    ${fields.updateSpaceTopicFilter.variables.spaceId
                ? `
      spaceId: ${fields.updateSpaceTopicFilter.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.updateSpaceTopicFilter.fields)}
        }
      `
        : ``}
    

      ${fields.updateTag
        ? `
        updateTag
        ${((_170 = fields.updateTag) === null || _170 === void 0 ? void 0 : _170.variables)
            ? `
          (
            
    ${fields.updateTag.variables.id
                ? `
      id: ${fields.updateTag.variables.id}
    `
                : ``}
  

    ${fields.updateTag.variables.input
                ? `
      input: ${fields.updateTag.variables.input}
    `
                : ``}
  

    ${fields.updateTag.variables.spaceId
                ? `
      spaceId: ${fields.updateTag.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${TagGQLFields(fields.updateTag.fields)}
        }
      `
        : ``}
    

      ${fields.updateTemplate
        ? `
        updateTemplate
        ${((_171 = fields.updateTemplate) === null || _171 === void 0 ? void 0 : _171.variables)
            ? `
          (
            
    ${fields.updateTemplate.variables.id
                ? `
      id: ${fields.updateTemplate.variables.id}
    `
                : ``}
  

    ${fields.updateTemplate.variables.input
                ? `
      input: ${fields.updateTemplate.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${TemplateGQLFields(fields.updateTemplate.fields)}
        }
      `
        : ``}
    

      ${fields.uploadMigrationFiles
        ? `
        uploadMigrationFiles
        ${((_172 = fields.uploadMigrationFiles) === null || _172 === void 0 ? void 0 : _172.variables)
            ? `
          (
            
    ${fields.uploadMigrationFiles.variables.baseUrl
                ? `
      baseUrl: ${fields.uploadMigrationFiles.variables.baseUrl}
    `
                : ``}
  

    ${fields.uploadMigrationFiles.variables.changeMemberEmails
                ? `
      changeMemberEmails: ${fields.uploadMigrationFiles.variables.changeMemberEmails}
    `
                : ``}
  

    ${fields.uploadMigrationFiles.variables.dryRun
                ? `
      dryRun: ${fields.uploadMigrationFiles.variables.dryRun}
    `
                : ``}
  

    ${fields.uploadMigrationFiles.variables.members
                ? `
      members: ${fields.uploadMigrationFiles.variables.members}
    `
                : ``}
  

    ${fields.uploadMigrationFiles.variables.migrationId
                ? `
      migrationId: ${fields.uploadMigrationFiles.variables.migrationId}
    `
                : ``}
  

    ${fields.uploadMigrationFiles.variables.posts
                ? `
      posts: ${fields.uploadMigrationFiles.variables.posts}
    `
                : ``}
  

    ${fields.uploadMigrationFiles.variables.spaces
                ? `
      spaces: ${fields.uploadMigrationFiles.variables.spaces}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${UploadedMigrationsGQLFields(fields.uploadMigrationFiles.fields)}
        }
      `
        : ``}
    

      ${fields.upsertExtraProperty
        ? `
        upsertExtraProperty
        ${((_173 = fields.upsertExtraProperty) === null || _173 === void 0 ? void 0 : _173.variables)
            ? `
          (
            
    ${fields.upsertExtraProperty.variables.input
                ? `
      input: ${fields.upsertExtraProperty.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ActionGQLFields(fields.upsertExtraProperty.fields)}
        }
      `
        : ``}
    

      ${fields.upsertTheme
        ? `
        upsertTheme
        ${((_174 = fields.upsertTheme) === null || _174 === void 0 ? void 0 : _174.variables)
            ? `
          (
            
    ${fields.upsertTheme.variables.input
                ? `
      input: ${fields.upsertTheme.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${NewThemeGQLFields(fields.upsertTheme.fields)}
        }
      `
        : ``}
    

      ${fields.verifyMember
        ? `
        verifyMember
        ${((_175 = fields.verifyMember) === null || _175 === void 0 ? void 0 : _175.variables)
            ? `
          (
            
    ${fields.verifyMember.variables.input
                ? `
      input: ${fields.verifyMember.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.verifyMember.fields)}
        }
      `
        : ``}
    
      `;
};
export const NativeFieldsTemplatesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        description
thumbnailId
title
      `;
};
export const NavigationItemGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        link
openInNewWindow
text
type
      `;
};
export const NavigationSlatesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            footer: 'basic',
            header: 'basic',
            sidebar1: 'basic',
            sidebar2: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.footer
        ? `
      footer {
        ${SlateGQLFields(fields.footer)}
      }
    `
        : ``}
  

    ${fields.header
        ? `
      header {
        ${SlateGQLFields(fields.header)}
      }
    `
        : ``}
  

    ${fields.sidebar1
        ? `
      sidebar1 {
        ${SlateGQLFields(fields.sidebar1)}
      }
    `
        : ``}
  

    ${fields.sidebar2
        ? `
      sidebar2 {
        ${SlateGQLFields(fields.sidebar2)}
      }
    `
        : ``}
  
      `;
};
export const NetworkGQLFields = (fields) => {
    var _a, _b, _c, _d, _e;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            activeSso: 'basic',
            activeTheme: 'basic',
            authMemberProps: 'basic',
            badges: 'basic',
            createdBy: 'basic',
            customSeoDetail: 'basic',
            defaultSpaces: 'basic',
            favicon: 'basic',
            footer: 'basic',
            landingPages: 'basic',
            limits: 'basic',
            logo: 'basic',
            mediaLimits: 'basic',
            mediaSettings: 'basic',
            memberFields: 'basic',
            navigationSlates: 'basic',
            notificationSettings: 'basic',
            owner: 'basic',
            roles: 'basic',
            settings: 'basic',
            shortcuts: 'basic',
            statusReason: 'basic',
            subscriptionPlan: 'basic',
            systemSpaces: 'basic',
            themes: 'basic',
            topNavigation: 'basic',
            usages: 'basic',
            whoCanInvite: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.activeSso
        ? `
      activeSso {
        ${ActiveSsoGQLFields(fields.activeSso)}
      }
    `
        : ``}
  

    ${fields.activeTheme
        ? `
      activeTheme {
        ${NewThemeGQLFields(fields.activeTheme)}
      }
    `
        : ``}
  
additionalSeatsCapacity
aliases

    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${NetworkAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
  
availableLocales

    ${fields.badges
        ? `
      badges {
        ${BadgeGQLFields(fields.badges)}
      }
    `
        : ``}
  
billingEmail
brandColor
companyName
createdAt

    ${fields.createdBy
        ? `
      createdBy {
        ${MemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
  
createdById

      ${fields.customCodes
        ? `
        customCodes
        ${((_a = fields.customCodes) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.customCodes.variables.anonymize
                ? `
      anonymize: ${fields.customCodes.variables.anonymize}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CustomCodeGQLFields(fields.customCodes.fields)}
        }
      `
        : ``}
    
customMemberCapacity

    ${fields.customSeoDetail
        ? `
      customSeoDetail {
        ${CustomSeoDetailGQLFields(fields.customSeoDetail)}
      }
    `
        : ``}
  

    ${fields.defaultSpaces
        ? `
      defaultSpaces {
        ${SpaceGQLFields(fields.defaultSpaces)}
      }
    `
        : ``}
  
description
domain
domainSubfolder

      ${fields.extraProperties
        ? `
        extraProperties
        ${((_b = fields.extraProperties) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.extraProperties.variables.keys
                ? `
      keys: ${fields.extraProperties.variables.keys}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ExtraPropertyGQLFields(fields.extraProperties.fields)}
        }
      `
        : ``}
    

    ${fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``}
  
faviconId

    ${fields.footer
        ? `
      footer {
        ${FooterGQLFields(fields.footer)}
      }
    `
        : ``}
  
hideDefaultAuthenticationForm
id
incidentEmails
industry

    ${fields.landingPages
        ? `
      landingPages {
        ${NetworkSettingsGQLFields(fields.landingPages)}
      }
    `
        : ``}
  

    ${fields.limits
        ? `
      limits {
        ${NetworkLimitsGQLFields(fields.limits)}
      }
    `
        : ``}
  
locale

    ${fields.logo
        ? `
      logo {
        ${MediaGQLFields(fields.logo)}
      }
    `
        : ``}
  
logoId

    ${fields.mediaLimits
        ? `
      mediaLimits {
        ${MediaLimitsGQLFields(fields.mediaLimits)}
      }
    `
        : ``}
  

    ${fields.mediaSettings
        ? `
      mediaSettings {
        ${MediaNetworkSettingsGQLFields(fields.mediaSettings)}
      }
    `
        : ``}
  
memberCapacity
memberCapacityDeclared

    ${fields.memberFields
        ? `
      memberFields {
        ${CustomFieldsSchemaGQLFields(fields.memberFields)}
      }
    `
        : ``}
  

      ${fields.members
        ? `
        members
        ${((_c = fields.members) === null || _c === void 0 ? void 0 : _c.variables)
            ? `
          (
            
    ${fields.members.variables.after
                ? `
      after: ${fields.members.variables.after}
    `
                : ``}
  

    ${fields.members.variables.before
                ? `
      before: ${fields.members.variables.before}
    `
                : ``}
  

    ${fields.members.variables.limit
                ? `
      limit: ${fields.members.variables.limit}
    `
                : ``}
  

    ${fields.members.variables.offset
                ? `
      offset: ${fields.members.variables.offset}
    `
                : ``}
  

    ${fields.members.variables.reverse
                ? `
      reverse: ${fields.members.variables.reverse}
    `
                : ``}
  

    ${fields.members.variables.status
                ? `
      status: ${fields.members.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedMemberGQLFields(fields.members.fields)}
        }
      `
        : ``}
    
membersCount
membership
name

    ${fields.navigationSlates
        ? `
      navigationSlates {
        ${NavigationSlatesGQLFields(fields.navigationSlates)}
      }
    `
        : ``}
  
newDomain

    ${fields.notificationSettings
        ? `
      notificationSettings {
        ${NotificationNetworkSettingsGQLFields(fields.notificationSettings)}
      }
    `
        : ``}
  
organizationId

    ${fields.owner
        ? `
      owner {
        ${MemberGQLFields(fields.owner)}
      }
    `
        : ``}
  
ownerId
passwordComplexity

      ${fields.postTypes
        ? `
        postTypes
        ${((_d = fields.postTypes) === null || _d === void 0 ? void 0 : _d.variables)
            ? `
          (
            
    ${fields.postTypes.variables.context
                ? `
      context: ${fields.postTypes.variables.context}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.postTypes.fields)}
        }
      `
        : ``}
    
privacyPolicyUrl
releaseChannel

    ${fields.roles
        ? `
      roles {
        ${RoleGQLFields(fields.roles)}
      }
    `
        : ``}
  
seatCapacityDeclared
seatsCapacity

    ${fields.settings
        ? `
      settings {
        ${SettingsGQLFields(fields.settings)}
      }
    `
        : ``}
  

    ${fields.shortcuts
        ? `
      shortcuts {
        ${ShortcutGQLFields(fields.shortcuts)}
      }
    `
        : ``}
  

      ${fields.spaces
        ? `
        spaces
        ${((_e = fields.spaces) === null || _e === void 0 ? void 0 : _e.variables)
            ? `
          (
            
    ${fields.spaces.variables.limit
                ? `
      limit: ${fields.spaces.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.spaces.fields)}
        }
      `
        : ``}
    
status
statusLocked

    ${fields.statusReason
        ? `
      statusReason {
        ${StatusReasonGQLFields(fields.statusReason)}
      }
    `
        : ``}
  

    ${fields.subscriptionPlan
        ? `
      subscriptionPlan {
        ${PlanGQLFields(fields.subscriptionPlan)}
      }
    `
        : ``}
  

    ${fields.systemSpaces
        ? `
      systemSpaces {
        ${SpaceGQLFields(fields.systemSpaces)}
      }
    `
        : ``}
  
termsOfServiceUrl

    ${fields.themes
        ? `
      themes {
        ${ThemesGQLFields(fields.themes)}
      }
    `
        : ``}
  

    ${fields.topNavigation
        ? `
      topNavigation {
        ${TopNavigationGQLFields(fields.topNavigation)}
      }
    `
        : ``}
  
tribeBranding

    ${fields.usages
        ? `
      usages {
        ${NetworkUsagesGQLFields(fields.usages)}
      }
    `
        : ``}
  
visibility

    ${fields.whoCanInvite
        ? `
      whoCanInvite {
        ${RoleGQLFields(fields.whoCanInvite)}
      }
    `
        : ``}
  
whoCanInviteIds
      `;
};
export const NetworkAuthMemberPropsGQLFields = (fields) => {
    var _a;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            permissions: 'basic',
        };
    }
    return `
        __typename
        context

    ${fields.permissions
        ? `
      permissions {
        ${ActionPermissionsGQLFields(fields.permissions)}
      }
    `
        : ``}
  
privateMessagingEnabled
scopes
totalUnreadPostsCount
        ${((_a = fields.totalUnreadPostsCount) === null || _a === void 0 ? void 0 : _a.variables)
        ? `
          (
            
    ${fields.totalUnreadPostsCount.variables.type
            ? `
      type: ${fields.totalUnreadPostsCount.variables.type}
    `
            : ``}
  
          )
        `
        : ``}
      
      `;
};
export const NetworkLimitsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            analyticsLimits: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.analyticsLimits
        ? `
      analyticsLimits {
        ${AnalyticsLimitsGQLFields(fields.analyticsLimits)}
      }
    `
        : ``}
  
fileSizeLimit
fileTypesLimit
imageSizeLimit
imageTypesLimit
      `;
};
export const NetworkPublicInfoGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            favicon: 'basic',
            jwtSsoAuthUrls: 'basic',
            logo: 'basic',
            systemSpaces: 'basic',
        };
    }
    return `
        __typename
        domain
domainSubfolder

    ${fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``}
  
faviconId
id

    ${fields.jwtSsoAuthUrls
        ? `
      jwtSsoAuthUrls {
        ${JwtSsoAuthUrlsGQLFields(fields.jwtSsoAuthUrls)}
      }
    `
        : ``}
  

    ${fields.logo
        ? `
      logo {
        ${MediaGQLFields(fields.logo)}
      }
    `
        : ``}
  
logoId
membership
name
status

    ${fields.systemSpaces
        ? `
      systemSpaces {
        ${SpaceGQLFields(fields.systemSpaces)}
      }
    `
        : ``}
  
visibility
      `;
};
export const NetworkSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        landingPageForGuest
landingPageForMember
landingPageForNewMember
      `;
};
export const NetworkUsagesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        fileStorageUsage
imageStorageUsage
      `;
};
export const NewThemeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            colors: 'basic',
            typography: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.colors
        ? `
      colors {
        ${ThemeColorsGQLFields(fields.colors)}
      }
    `
        : ``}
  
id
name

    ${fields.typography
        ? `
      typography {
        ${ThemeTokenGQLFields(fields.typography)}
      }
    `
        : ``}
  
      `;
};
export const NotificationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            actor: 'basic',
            meta: 'basic',
            object: 'basic',
            space: 'basic',
            target: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.actor
        ? `
      actor {
        ${PayloadGQLFields(fields.actor)}
      }
    `
        : ``}
  
createdAt
id

    ${fields.meta
        ? `
      meta {
        ${NotificationMetaGQLFields(fields.meta)}
      }
    `
        : ``}
  

    ${fields.object
        ? `
      object {
        ${PayloadGQLFields(fields.object)}
      }
    `
        : ``}
  
read

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  

    ${fields.target
        ? `
      target {
        ${PayloadGQLFields(fields.target)}
      }
    `
        : ``}
  
verb
      `;
};
export const NotificationEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${NotificationGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const NotificationMetaGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        body
fullTitle
reason
relativeUrl
textBody
textFullTitle
textTitle
title
url
      `;
};
export const NotificationNetworkSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        emailEnabled
emailFrom
emailNotificationEnabled
      `;
};
export const NotificationsCountGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        new
      `;
};
export const OAuthCodeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        code
      `;
};
export const OAuthTokensGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        accessToken
expiresIn
memberId
refreshToken
      `;
};
export const PageGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            entity: 'basic',
            seoDetail: 'basic',
            space: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.entity
        ? `
      entity {
        ${PageEntityGQLFields(fields.entity)}
      }
    `
        : ``}
  

    ${fields.seoDetail
        ? `
      seoDetail {
        ${PageSeoGQLFields(fields.seoDetail)}
      }
    `
        : ``}
  

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  
      `;
};
export const PageEntityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onCollection: 'basic',
            onMember: 'basic',
            onPost: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onCollection
        ? `
            ... on Collection {
              ${CollectionGQLFields(fields.onCollection)}
            }
          `
        : ``}
        

          ${fields.onMember
        ? `
            ... on Member {
              ${MemberGQLFields(fields.onMember)}
            }
          `
        : ``}
        

          ${fields.onPost
        ? `
            ... on Post {
              ${PostGQLFields(fields.onPost)}
            }
          `
        : ``}
        
      `;
};
export const PageInfoGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        endCursor
hasNextPage
      `;
};
export const PageSeoGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            additionalMeta: 'basic',
            thumbnail: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.additionalMeta
        ? `
      additionalMeta {
        ${PageTagGQLFields(fields.additionalMeta)}
      }
    `
        : ``}
  
description
jsonld

    ${fields.thumbnail
        ? `
      thumbnail {
        ${MediaGQLFields(fields.thumbnail)}
      }
    `
        : ``}
  
title
      `;
};
export const PageTagGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            properties: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.properties
        ? `
      properties {
        ${KeyValueGQLFields(fields.properties)}
      }
    `
        : ``}
  
type
      `;
};
export const PaginatedAppGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${AppEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${AppGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedAppInstallationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${AppInstallationEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${AppInstallationGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedDynamicBlockGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${DynamicBlockEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${DynamicBlockGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedEmailLogGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${EmailLogEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${EmailLogGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedExportGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${ExportEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${ExportGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedMemberGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${MemberEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${MemberGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedMemberInvitationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${MemberInvitationEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${MemberInvitationGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedModerationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${ModerationItemEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${ModerationItemGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedModerationItemReporterGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${ModerationItemReporterEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${ModerationItemReporterGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedNetworkGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${PluralNetworkEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${PluralNetworkGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedNotificationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${NotificationEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${NotificationGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedPluralMemberGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${PluralMemberEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${PluralMemberGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedPostGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${PostEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${PostGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedPostReactionParticipantGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${PostReactionParticipantEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${PostReactionParticipantGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedPostTypeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${PostTypeEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${PostTypeGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedSpaceGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${SpaceEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${SpaceGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedSpaceMemberGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${SpaceMemberEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${SpaceMemberGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedSpacePostTypeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${SpacePostTypeEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${SpacePostTypeGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedTagGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${TagEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${TagGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PaginatedTemplateGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            edges: 'basic',
            nodes: 'basic',
            pageInfo: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.edges
        ? `
      edges {
        ${TemplateEdgeGQLFields(fields.edges)}
      }
    `
        : ``}
  

    ${fields.nodes
        ? `
      nodes {
        ${TemplateGQLFields(fields.nodes)}
      }
    `
        : ``}
  

    ${fields.pageInfo
        ? `
      pageInfo {
        ${PageInfoGQLFields(fields.pageInfo)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const PasswordComplexityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        complex
      `;
};
export const PathPermissionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            isAuthorized: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.isAuthorized
        ? `
      isAuthorized {
        ${IsAuthorizedGQLFields(fields.isAuthorized)}
      }
    `
        : ``}
  
path
      `;
};
export const PayloadGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            media: 'basic',
            member: 'basic',
            post: 'basic',
            space: 'basic',
        };
    }
    return `
        __typename
        id

    ${fields.media
        ? `
      media {
        ${MediaGQLFields(fields.media)}
      }
    `
        : ``}
  

    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  
name

    ${fields.post
        ? `
      post {
        ${PostGQLFields(fields.post)}
      }
    `
        : ``}
  

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  
summary
type
      `;
};
export const PermissionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        createdAt
description
id
name
scopes
      `;
};
export const PermissionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            actions: 'basic',
            contextAwareActions: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.actions
        ? `
      actions {
        ${ActionPermissionsGQLFields(fields.actions)}
      }
    `
        : ``}
  

    ${fields.contextAwareActions
        ? `
      contextAwareActions {
        ${ContextPermissionsGQLFields(fields.contextAwareActions)}
      }
    `
        : ``}
  
      `;
};
export const PlanGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        createdAt
endDate
extendable
memberCapacity
name
renewDate
renewalType
seatCapacity
startDate
trial
      `;
};
export const PluralMemberGQLFields = (fields) => {
    var _a, _b;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            activeSession: 'basic',
            attributes: 'basic',
            authMemberProps: 'basic',
            badges: 'basic',
            banner: 'basic',
            blockedMembers: 'basic',
            fields: 'basic',
            network: 'basic',
            profilePicture: 'basic',
            role: 'basic',
            sessions: 'basic',
            settings: 'basic',
            shortcuts: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.activeSession
        ? `
      activeSession {
        ${MemberSessionGQLFields(fields.activeSession)}
      }
    `
        : ``}
  

    ${fields.attributes
        ? `
      attributes {
        ${MemberAttributesGQLFields(fields.attributes)}
      }
    `
        : ``}
  

    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${MemberAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
  

    ${fields.badges
        ? `
      badges {
        ${MemberBadgeGQLFields(fields.badges)}
      }
    `
        : ``}
  

    ${fields.banner
        ? `
      banner {
        ${MediaGQLFields(fields.banner)}
      }
    `
        : ``}
  
bannerId
blockedMemberIds

    ${fields.blockedMembers
        ? `
      blockedMembers {
        ${MemberGQLFields(fields.blockedMembers)}
      }
    `
        : ``}
  
createdAt
displayName
email
emailStatus
externalId

      ${fields.extraProperties
        ? `
        extraProperties
        ${((_a = fields.extraProperties) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.extraProperties.variables.keys
                ? `
      keys: ${fields.extraProperties.variables.keys}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ExtraPropertyGQLFields(fields.extraProperties.fields)}
        }
      `
        : ``}
    

    ${fields.fields
        ? `
      fields {
        ${CustomFieldGQLFields(fields.fields)}
      }
    `
        : ``}
  
flagged
id
lastSeen
lastSeenAt
locale
name

    ${fields.network
        ? `
      network {
        ${PluralNetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
networkId
newEmail
overrideTeammate

    ${fields.profilePicture
        ? `
      profilePicture {
        ${MediaGQLFields(fields.profilePicture)}
      }
    `
        : ``}
  
profilePictureId
relativeUrl

    ${fields.role
        ? `
      role {
        ${RoleGQLFields(fields.role)}
      }
    `
        : ``}
  
roleId
score

    ${fields.sessions
        ? `
      sessions {
        ${MemberSessionGQLFields(fields.sessions)}
      }
    `
        : ``}
  

    ${fields.settings
        ? `
      settings {
        ${MemberSettingsGQLFields(fields.settings)}
      }
    `
        : ``}
  

    ${fields.shortcuts
        ? `
      shortcuts {
        ${ShortcutGQLFields(fields.shortcuts)}
      }
    `
        : ``}
  

      ${fields.spaces
        ? `
        spaces
        ${((_b = fields.spaces) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.spaces.variables.limit
                ? `
      limit: ${fields.spaces.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.spaces.fields)}
        }
      `
        : ``}
    
status
tagline
teammate
updatedAt
url
username
verifiedAt
      `;
};
export const PluralMemberEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${PluralMemberGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const PluralNetworkGQLFields = (fields) => {
    var _a, _b, _c, _d, _e;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            activeSso: 'basic',
            activeTheme: 'basic',
            authMemberProps: 'basic',
            badges: 'basic',
            createdBy: 'basic',
            customSeoDetail: 'basic',
            defaultSpaces: 'basic',
            favicon: 'basic',
            footer: 'basic',
            globalFavicon: 'basic',
            globalLogo: 'basic',
            landingPages: 'basic',
            limits: 'basic',
            logo: 'basic',
            mediaLimits: 'basic',
            mediaSettings: 'basic',
            memberFields: 'basic',
            navigationSlates: 'basic',
            notificationSettings: 'basic',
            owner: 'basic',
            roles: 'basic',
            settings: 'basic',
            shortcuts: 'basic',
            statusReason: 'basic',
            subscriptionPlan: 'basic',
            systemSpaces: 'basic',
            themes: 'basic',
            topNavigation: 'basic',
            usages: 'basic',
            whoCanInvite: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.activeSso
        ? `
      activeSso {
        ${ActiveSsoGQLFields(fields.activeSso)}
      }
    `
        : ``}
  

    ${fields.activeTheme
        ? `
      activeTheme {
        ${NewThemeGQLFields(fields.activeTheme)}
      }
    `
        : ``}
  
additionalSeatsCapacity
aliases

    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${NetworkAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
  
availableLocales

    ${fields.badges
        ? `
      badges {
        ${BadgeGQLFields(fields.badges)}
      }
    `
        : ``}
  
billingEmail
brandColor
companyName
createdAt

    ${fields.createdBy
        ? `
      createdBy {
        ${MemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
  
createdById

      ${fields.customCodes
        ? `
        customCodes
        ${((_a = fields.customCodes) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.customCodes.variables.anonymize
                ? `
      anonymize: ${fields.customCodes.variables.anonymize}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CustomCodeGQLFields(fields.customCodes.fields)}
        }
      `
        : ``}
    
customMemberCapacity

    ${fields.customSeoDetail
        ? `
      customSeoDetail {
        ${CustomSeoDetailGQLFields(fields.customSeoDetail)}
      }
    `
        : ``}
  

    ${fields.defaultSpaces
        ? `
      defaultSpaces {
        ${SpaceGQLFields(fields.defaultSpaces)}
      }
    `
        : ``}
  
description
domain
domainSubfolder

      ${fields.extraProperties
        ? `
        extraProperties
        ${((_b = fields.extraProperties) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.extraProperties.variables.keys
                ? `
      keys: ${fields.extraProperties.variables.keys}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ExtraPropertyGQLFields(fields.extraProperties.fields)}
        }
      `
        : ``}
    

    ${fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``}
  
faviconId

    ${fields.footer
        ? `
      footer {
        ${FooterGQLFields(fields.footer)}
      }
    `
        : ``}
  

    ${fields.globalFavicon
        ? `
      globalFavicon {
        ${MediaGQLFields(fields.globalFavicon)}
      }
    `
        : ``}
  

    ${fields.globalLogo
        ? `
      globalLogo {
        ${MediaGQLFields(fields.globalLogo)}
      }
    `
        : ``}
  
hideDefaultAuthenticationForm
id
incidentEmails
industry

    ${fields.landingPages
        ? `
      landingPages {
        ${NetworkSettingsGQLFields(fields.landingPages)}
      }
    `
        : ``}
  

    ${fields.limits
        ? `
      limits {
        ${NetworkLimitsGQLFields(fields.limits)}
      }
    `
        : ``}
  
locale

    ${fields.logo
        ? `
      logo {
        ${MediaGQLFields(fields.logo)}
      }
    `
        : ``}
  
logoId

    ${fields.mediaLimits
        ? `
      mediaLimits {
        ${MediaLimitsGQLFields(fields.mediaLimits)}
      }
    `
        : ``}
  

    ${fields.mediaSettings
        ? `
      mediaSettings {
        ${MediaNetworkSettingsGQLFields(fields.mediaSettings)}
      }
    `
        : ``}
  
memberCapacity
memberCapacityDeclared

    ${fields.memberFields
        ? `
      memberFields {
        ${CustomFieldsSchemaGQLFields(fields.memberFields)}
      }
    `
        : ``}
  

      ${fields.members
        ? `
        members
        ${((_c = fields.members) === null || _c === void 0 ? void 0 : _c.variables)
            ? `
          (
            
    ${fields.members.variables.after
                ? `
      after: ${fields.members.variables.after}
    `
                : ``}
  

    ${fields.members.variables.before
                ? `
      before: ${fields.members.variables.before}
    `
                : ``}
  

    ${fields.members.variables.limit
                ? `
      limit: ${fields.members.variables.limit}
    `
                : ``}
  

    ${fields.members.variables.offset
                ? `
      offset: ${fields.members.variables.offset}
    `
                : ``}
  

    ${fields.members.variables.reverse
                ? `
      reverse: ${fields.members.variables.reverse}
    `
                : ``}
  

    ${fields.members.variables.status
                ? `
      status: ${fields.members.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedMemberGQLFields(fields.members.fields)}
        }
      `
        : ``}
    
membersCount
membership
name

    ${fields.navigationSlates
        ? `
      navigationSlates {
        ${NavigationSlatesGQLFields(fields.navigationSlates)}
      }
    `
        : ``}
  
newDomain

    ${fields.notificationSettings
        ? `
      notificationSettings {
        ${NotificationNetworkSettingsGQLFields(fields.notificationSettings)}
      }
    `
        : ``}
  
organizationId

    ${fields.owner
        ? `
      owner {
        ${MemberGQLFields(fields.owner)}
      }
    `
        : ``}
  
ownerId
passwordComplexity

      ${fields.postTypes
        ? `
        postTypes
        ${((_d = fields.postTypes) === null || _d === void 0 ? void 0 : _d.variables)
            ? `
          (
            
    ${fields.postTypes.variables.context
                ? `
      context: ${fields.postTypes.variables.context}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.postTypes.fields)}
        }
      `
        : ``}
    
privacyPolicyUrl
releaseChannel

    ${fields.roles
        ? `
      roles {
        ${RoleGQLFields(fields.roles)}
      }
    `
        : ``}
  
seatCapacityDeclared
seatsCapacity

    ${fields.settings
        ? `
      settings {
        ${SettingsGQLFields(fields.settings)}
      }
    `
        : ``}
  

    ${fields.shortcuts
        ? `
      shortcuts {
        ${ShortcutGQLFields(fields.shortcuts)}
      }
    `
        : ``}
  

      ${fields.spaces
        ? `
        spaces
        ${((_e = fields.spaces) === null || _e === void 0 ? void 0 : _e.variables)
            ? `
          (
            
    ${fields.spaces.variables.limit
                ? `
      limit: ${fields.spaces.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.spaces.fields)}
        }
      `
        : ``}
    
status
statusLocked

    ${fields.statusReason
        ? `
      statusReason {
        ${StatusReasonGQLFields(fields.statusReason)}
      }
    `
        : ``}
  

    ${fields.subscriptionPlan
        ? `
      subscriptionPlan {
        ${PlanGQLFields(fields.subscriptionPlan)}
      }
    `
        : ``}
  

    ${fields.systemSpaces
        ? `
      systemSpaces {
        ${SpaceGQLFields(fields.systemSpaces)}
      }
    `
        : ``}
  
termsOfServiceUrl

    ${fields.themes
        ? `
      themes {
        ${ThemesGQLFields(fields.themes)}
      }
    `
        : ``}
  

    ${fields.topNavigation
        ? `
      topNavigation {
        ${TopNavigationGQLFields(fields.topNavigation)}
      }
    `
        : ``}
  
tribeBranding

    ${fields.usages
        ? `
      usages {
        ${NetworkUsagesGQLFields(fields.usages)}
      }
    `
        : ``}
  
visibility

    ${fields.whoCanInvite
        ? `
      whoCanInvite {
        ${RoleGQLFields(fields.whoCanInvite)}
      }
    `
        : ``}
  
whoCanInviteIds
      `;
};
export const PluralNetworkEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${PluralNetworkGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const PostGQLFields = (fields) => {
    var _a, _b, _c;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            attachments: 'basic',
            authMemberProps: 'basic',
            createdBy: 'basic',
            customSeoDetail: 'basic',
            embeds: 'basic',
            fields: 'basic',
            images: 'basic',
            lastActivityDetail: 'basic',
            mappingFields: 'basic',
            mentions: 'basic',
            owner: 'basic',
            pinnedReplies: 'basic',
            postType: 'basic',
            reactions: 'basic',
            repliedTo: 'basic',
            repliedTos: 'basic',
            seoDetail: 'basic',
            shortcuts: 'basic',
            space: 'basic',
            tags: 'basic',
            thumbnail: 'basic',
            topRepliers: 'basic',
        };
    }
    return `
        __typename
        allowedEmojis
attachmentIds

    ${fields.attachments
        ? `
      attachments {
        ${FileGQLFields(fields.attachments)}
      }
    `
        : ``}
  

    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${PostAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
  

      ${fields.contentSummary
        ? `
        contentSummary
        ${((_a = fields.contentSummary) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.contentSummary.variables.format
                ? `
      format: ${fields.contentSummary.variables.format}
    `
                : ``}
  

    ${fields.contentSummary.variables.length
                ? `
      length: ${fields.contentSummary.variables.length}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostContentSummaryGQLFields(fields.contentSummary.fields)}
        }
      `
        : ``}
    
createdAt

    ${fields.createdBy
        ? `
      createdBy {
        ${SpaceMemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
  
createdById

    ${fields.customSeoDetail
        ? `
      customSeoDetail {
        ${CustomSeoDetailGQLFields(fields.customSeoDetail)}
      }
    `
        : ``}
  
description
embedIds

    ${fields.embeds
        ? `
      embeds {
        ${EmbedGQLFields(fields.embeds)}
      }
    `
        : ``}
  

    ${fields.fields
        ? `
      fields {
        ${CustomFieldGQLFields(fields.fields)}
      }
    `
        : ``}
  
followersCount
forbiddenEmojis
hasMoreContent
id
imageIds

    ${fields.images
        ? `
      images {
        ${MediaGQLFields(fields.images)}
      }
    `
        : ``}
  
isAnonymous
isHidden
language
lastActivityAt

    ${fields.lastActivityDetail
        ? `
      lastActivityDetail {
        ${PostLastActivityDetailGQLFields(fields.lastActivityDetail)}
      }
    `
        : ``}
  
locked

    ${fields.mappingFields
        ? `
      mappingFields {
        ${PostMappingFieldGQLFields(fields.mappingFields)}
      }
    `
        : ``}
  
mentionedMembers

    ${fields.mentions
        ? `
      mentions {
        ${MemberGQLFields(fields.mentions)}
      }
    `
        : ``}
  
negativeReactions
negativeReactionsCount
networkId

    ${fields.owner
        ? `
      owner {
        ${SpaceMemberGQLFields(fields.owner)}
      }
    `
        : ``}
  
ownerId
pinnedInto

    ${fields.pinnedReplies
        ? `
      pinnedReplies {
        ${PostGQLFields(fields.pinnedReplies)}
      }
    `
        : ``}
  
positiveReactions
positiveReactionsCount

    ${fields.postType
        ? `
      postType {
        ${PostTypeGQLFields(fields.postType)}
      }
    `
        : ``}
  
postTypeId
primaryReactionType
publishedAt

    ${fields.reactions
        ? `
      reactions {
        ${PostReactionDetailGQLFields(fields.reactions)}
      }
    `
        : ``}
  
reactionsCount
relativeUrl

    ${fields.repliedTo
        ? `
      repliedTo {
        ${PostGQLFields(fields.repliedTo)}
      }
    `
        : ``}
  
repliedToId
repliedToIds

    ${fields.repliedTos
        ? `
      repliedTos {
        ${PostGQLFields(fields.repliedTos)}
      }
    `
        : ``}
  

      ${fields.replies
        ? `
        replies
        ${((_b = fields.replies) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.replies.variables.after
                ? `
      after: ${fields.replies.variables.after}
    `
                : ``}
  

    ${fields.replies.variables.before
                ? `
      before: ${fields.replies.variables.before}
    `
                : ``}
  

    ${fields.replies.variables.excludePins
                ? `
      excludePins: ${fields.replies.variables.excludePins}
    `
                : ``}
  

    ${fields.replies.variables.limit
                ? `
      limit: ${fields.replies.variables.limit}
    `
                : ``}
  

    ${fields.replies.variables.offset
                ? `
      offset: ${fields.replies.variables.offset}
    `
                : ``}
  

    ${fields.replies.variables.orderBy
                ? `
      orderBy: ${fields.replies.variables.orderBy}
    `
                : ``}
  

    ${fields.replies.variables.orderByString
                ? `
      orderByString: ${fields.replies.variables.orderByString}
    `
                : ``}
  

    ${fields.replies.variables.reverse
                ? `
      reverse: ${fields.replies.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.replies.fields)}
        }
      `
        : ``}
    
repliesCount

    ${fields.seoDetail
        ? `
      seoDetail {
        ${PostSeoDetailGQLFields(fields.seoDetail)}
      }
    `
        : ``}
  
shortContent
        ${((_c = fields.shortContent) === null || _c === void 0 ? void 0 : _c.variables)
        ? `
          (
            
    ${fields.shortContent.variables.format
            ? `
      format: ${fields.shortContent.variables.format}
    `
            : ``}
  

    ${fields.shortContent.variables.length
            ? `
      length: ${fields.shortContent.variables.length}
    `
            : ``}
  
          )
        `
        : ``}
      

    ${fields.shortcuts
        ? `
      shortcuts {
        ${ShortcutGQLFields(fields.shortcuts)}
      }
    `
        : ``}
  
singleChoiceReactions
slug

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  
spaceId
status
tagIds

    ${fields.tags
        ? `
      tags {
        ${TagGQLFields(fields.tags)}
      }
    `
        : ``}
  

    ${fields.thumbnail
        ? `
      thumbnail {
        ${MediaGQLFields(fields.thumbnail)}
      }
    `
        : ``}
  
thumbnailId
title

    ${fields.topRepliers
        ? `
      topRepliers {
        ${PostTopReplierGQLFields(fields.topRepliers)}
      }
    `
        : ``}
  
topicIds
totalRepliesCount
updatedAt
url
      `;
};
export const PostAuthMemberPropsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            availableReplyTypes: 'basic',
            permissions: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.availableReplyTypes
        ? `
      availableReplyTypes {
        ${PostTypeGQLFields(fields.availableReplyTypes)}
      }
    `
        : ``}
  
canReact
context
memberPostNotificationSettingsEnabled

    ${fields.permissions
        ? `
      permissions {
        ${ActionPermissionsGQLFields(fields.permissions)}
      }
    `
        : ``}
  
scopes
      `;
};
export const PostContentSummaryGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        hasMoreContent
summary
      `;
};
export const PostEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${PostGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const PostLastActivityDetailGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            entity: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.entity
        ? `
      entity {
        ${PostLastActivityEntityGQLFields(fields.entity)}
      }
    `
        : ``}
  
entityId
entityType
      `;
};
export const PostLastActivityEntityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onPost: 'basic',
            onPostReactionParticipant: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onPost
        ? `
            ... on Post {
              ${PostGQLFields(fields.onPost)}
            }
          `
        : ``}
        

          ${fields.onPostReactionParticipant
        ? `
            ... on PostReactionParticipant {
              ${PostReactionParticipantGQLFields(fields.onPostReactionParticipant)}
            }
          `
        : ``}
        
      `;
};
export const PostMappingFieldGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
type
value
      `;
};
export const PostReactionDetailGQLFields = (fields) => {
    var _a;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        count

      ${fields.participants
        ? `
        participants
        ${((_a = fields.participants) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.participants.variables.limit
                ? `
      limit: ${fields.participants.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostReactionParticipantGQLFields(fields.participants.fields)}
        }
      `
        : ``}
    
reacted
reaction
      `;
};
export const PostReactionParticipantGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            participant: 'basic',
            reaction: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.participant
        ? `
      participant {
        ${MemberGQLFields(fields.participant)}
      }
    `
        : ``}
  

    ${fields.reaction
        ? `
      reaction {
        ${PostReactionDetailGQLFields(fields.reaction)}
      }
    `
        : ``}
  
      `;
};
export const PostReactionParticipantEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${PostReactionParticipantGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const PostSeoDetailGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        description
image
title
      `;
};
export const PostTopReplierGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  
repliesCount
      `;
};
export const PostTypeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            actions: 'basic',
            authMemberProps: 'basic',
            customReactions: 'basic',
            icon: 'basic',
            mappings: 'basic',
            nativeFieldsTemplates: 'basic',
            postFields: 'basic',
            recommendationsSettings: 'basic',
            slate: 'basic',
            validReplyTypes: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.actions
        ? `
      actions {
        ${PostTypeActionGQLFields(fields.actions)}
      }
    `
        : ``}
  
allowedEmojis

    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${PostTypeAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
  
context
createdAt

    ${fields.customReactions
        ? `
      customReactions {
        ${CustomReactionGQLFields(fields.customReactions)}
      }
    `
        : ``}
  
description
excludedNativeShortcuts
forbiddenEmojis

    ${fields.icon
        ? `
      icon {
        ${MediaGQLFields(fields.icon)}
      }
    `
        : ``}
  
iconId
id
languageTemplate

    ${fields.mappings
        ? `
      mappings {
        ${PostTypeMappingGQLFields(fields.mappings)}
      }
    `
        : ``}
  
name

    ${fields.nativeFieldsTemplates
        ? `
      nativeFieldsTemplates {
        ${NativeFieldsTemplatesGQLFields(fields.nativeFieldsTemplates)}
      }
    `
        : ``}
  
negativeReactions
pluralName
positiveReactions

    ${fields.postFields
        ? `
      postFields {
        ${CustomFieldsSchemaGQLFields(fields.postFields)}
      }
    `
        : ``}
  
primaryReactionType

    ${fields.recommendationsSettings
        ? `
      recommendationsSettings {
        ${PostTypeRecommendationSettingsGQLFields(fields.recommendationsSettings)}
      }
    `
        : ``}
  
shortContentTemplate
singleChoiceReactions

    ${fields.slate
        ? `
      slate {
        ${SlateGQLFields(fields.slate)}
      }
    `
        : ``}
  
slug
titleTemplate
updatedAt

    ${fields.validReplyTypes
        ? `
      validReplyTypes {
        ${PostTypeGQLFields(fields.validReplyTypes)}
      }
    `
        : ``}
  
      `;
};
export const PostTypeActionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        props
shortcutKey
      `;
};
export const PostTypeAuthMemberPropsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            availableSpaces: 'basic',
            permissions: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.availableSpaces
        ? `
      availableSpaces {
        ${SpaceGQLFields(fields.availableSpaces)}
      }
    `
        : ``}
  
context

    ${fields.permissions
        ? `
      permissions {
        ${ActionPermissionsGQLFields(fields.permissions)}
      }
    `
        : ``}
  
scopes
      `;
};
export const PostTypeEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${PostTypeGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const PostTypeMappingGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        default
description
field
isMainContent
isSearchable
key
required
title
type
      `;
};
export const PostTypeRecommendationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        fields
sourceSelf
sourceSpaces
      `;
};
export const PriceGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        currency
formattedValue
value
      `;
};
export const PrivateMessagingSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        membersCanTurnOffPrivateMessaging
membersCanUsePrivateMessaging
privateMessagingEnabled
      `;
};
export const ProductGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            prices: 'basic',
        };
    }
    return `
        __typename
        description
features
name

    ${fields.prices
        ? `
      prices {
        ${ProductPriceGQLFields(fields.prices)}
      }
    `
        : ``}
  
seatCapacity
      `;
};
export const ProductPriceGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            additionalSeatPrice: 'basic',
            planPrice: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.additionalSeatPrice
        ? `
      additionalSeatPrice {
        ${PriceGQLFields(fields.additionalSeatPrice)}
      }
    `
        : ``}
  

    ${fields.planPrice
        ? `
      planPrice {
        ${PriceGQLFields(fields.planPrice)}
      }
    `
        : ``}
  
renewalType
      `;
};
export const QueryGQLFields = (fields) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            accessGroups: 'basic',
            authMember: 'basic',
            billingDetails: 'basic',
            cancelSubscription: 'basic',
            getAuthMember: 'basic',
            getGroups: 'basic',
            getMemberInvitationLink: 'basic',
            getModerationSetting: 'basic',
            getNetwork: 'basic',
            getNetworkPublicInfo: 'basic',
            getNotificationsCount: 'basic',
            getRoles: 'basic',
            globalEventTypes: 'basic',
            invoices: 'basic',
            massActionRequestInProgress: 'basic',
            memberInvitationLink: 'basic',
            moderationSettings: 'basic',
            network: 'basic',
            networkPublicInfo: 'basic',
            notificationsCount: 'basic',
            permissions: 'basic',
            products: 'basic',
            systemSpaces: 'basic',
            vatTypes: 'basic',
        };
    }
    return `
        __typename
        
      ${fields.accessGroup
        ? `
        accessGroup
        ${((_a = fields.accessGroup) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.accessGroup.variables.id
                ? `
      id: ${fields.accessGroup.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AccessGroupGQLFields(fields.accessGroup.fields)}
        }
      `
        : ``}
    

    ${fields.accessGroups
        ? `
      accessGroups {
        ${AccessGroupGQLFields(fields.accessGroups)}
      }
    `
        : ``}
  

      ${fields.activityLogs
        ? `
        activityLogs
        ${((_b = fields.activityLogs) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.activityLogs.variables.query
                ? `
      query: ${fields.activityLogs.variables.query}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ReportRecordGQLFields(fields.activityLogs.fields)}
        }
      `
        : ``}
    

      ${fields.analytics
        ? `
        analytics
        ${((_c = fields.analytics) === null || _c === void 0 ? void 0 : _c.variables)
            ? `
          (
            
    ${fields.analytics.variables.queries
                ? `
      queries: ${fields.analytics.variables.queries}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AnalyticsResponseGQLFields(fields.analytics.fields)}
        }
      `
        : ``}
    

      ${fields.app
        ? `
        app
        ${((_d = fields.app) === null || _d === void 0 ? void 0 : _d.variables)
            ? `
          (
            
    ${fields.app.variables.clientId
                ? `
      clientId: ${fields.app.variables.clientId}
    `
                : ``}
  

    ${fields.app.variables.id
                ? `
      id: ${fields.app.variables.id}
    `
                : ``}
  

    ${fields.app.variables.redirectUri
                ? `
      redirectUri: ${fields.app.variables.redirectUri}
    `
                : ``}
  

    ${fields.app.variables.slug
                ? `
      slug: ${fields.app.variables.slug}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.app.fields)}
        }
      `
        : ``}
    

      ${fields.apps
        ? `
        apps
        ${((_e = fields.apps) === null || _e === void 0 ? void 0 : _e.variables)
            ? `
          (
            
    ${fields.apps.variables.after
                ? `
      after: ${fields.apps.variables.after}
    `
                : ``}
  

    ${fields.apps.variables.before
                ? `
      before: ${fields.apps.variables.before}
    `
                : ``}
  

    ${fields.apps.variables.limit
                ? `
      limit: ${fields.apps.variables.limit}
    `
                : ``}
  

    ${fields.apps.variables.offset
                ? `
      offset: ${fields.apps.variables.offset}
    `
                : ``}
  

    ${fields.apps.variables.reverse
                ? `
      reverse: ${fields.apps.variables.reverse}
    `
                : ``}
  

    ${fields.apps.variables.standing
                ? `
      standing: ${fields.apps.variables.standing}
    `
                : ``}
  

    ${fields.apps.variables.status
                ? `
      status: ${fields.apps.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppGQLFields(fields.apps.fields)}
        }
      `
        : ``}
    

    ${fields.authMember
        ? `
      authMember {
        ${MemberGQLFields(fields.authMember)}
      }
    `
        : ``}
  

      ${fields.authMemberAppInstallation
        ? `
        authMemberAppInstallation
        ${((_f = fields.authMemberAppInstallation) === null || _f === void 0 ? void 0 : _f.variables)
            ? `
          (
            
    ${fields.authMemberAppInstallation.variables.appId
                ? `
      appId: ${fields.authMemberAppInstallation.variables.appId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppInstallationGQLFields(fields.authMemberAppInstallation.fields)}
        }
      `
        : ``}
    

      ${fields.authMemberAppInstallations
        ? `
        authMemberAppInstallations
        ${((_g = fields.authMemberAppInstallations) === null || _g === void 0 ? void 0 : _g.variables)
            ? `
          (
            
    ${fields.authMemberAppInstallations.variables.after
                ? `
      after: ${fields.authMemberAppInstallations.variables.after}
    `
                : ``}
  

    ${fields.authMemberAppInstallations.variables.before
                ? `
      before: ${fields.authMemberAppInstallations.variables.before}
    `
                : ``}
  

    ${fields.authMemberAppInstallations.variables.limit
                ? `
      limit: ${fields.authMemberAppInstallations.variables.limit}
    `
                : ``}
  

    ${fields.authMemberAppInstallations.variables.offset
                ? `
      offset: ${fields.authMemberAppInstallations.variables.offset}
    `
                : ``}
  

    ${fields.authMemberAppInstallations.variables.reverse
                ? `
      reverse: ${fields.authMemberAppInstallations.variables.reverse}
    `
                : ``}
  

    ${fields.authMemberAppInstallations.variables.status
                ? `
      status: ${fields.authMemberAppInstallations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppInstallationGQLFields(fields.authMemberAppInstallations.fields)}
        }
      `
        : ``}
    

      ${fields.availableDynamicBlocks
        ? `
        availableDynamicBlocks
        ${((_h = fields.availableDynamicBlocks) === null || _h === void 0 ? void 0 : _h.variables)
            ? `
          (
            
    ${fields.availableDynamicBlocks.variables.context
                ? `
      context: ${fields.availableDynamicBlocks.variables.context}
    `
                : ``}
  

    ${fields.availableDynamicBlocks.variables.size
                ? `
      size: ${fields.availableDynamicBlocks.variables.size}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DynamicBlockGQLFields(fields.availableDynamicBlocks.fields)}
        }
      `
        : ``}
    

      ${fields.baskets
        ? `
        baskets
        ${((_j = fields.baskets) === null || _j === void 0 ? void 0 : _j.variables)
            ? `
          (
            
    ${fields.baskets.variables.input
                ? `
      input: ${fields.baskets.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${BasketGQLFields(fields.baskets.fields)}
        }
      `
        : ``}
    

    ${fields.billingDetails
        ? `
      billingDetails {
        ${BillingDetailsGQLFields(fields.billingDetails)}
      }
    `
        : ``}
  

    ${fields.cancelSubscription
        ? `
      cancelSubscription {
        ${ActionGQLFields(fields.cancelSubscription)}
      }
    `
        : ``}
  

      ${fields.checkDomainAvailability
        ? `
        checkDomainAvailability
        ${((_k = fields.checkDomainAvailability) === null || _k === void 0 ? void 0 : _k.variables)
            ? `
          (
            
    ${fields.checkDomainAvailability.variables.input
                ? `
      input: ${fields.checkDomainAvailability.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DomainAvailabilityGQLFields(fields.checkDomainAvailability.fields)}
        }
      `
        : ``}
    

      ${fields.checkEmailAvailability
        ? `
        checkEmailAvailability
        ${((_l = fields.checkEmailAvailability) === null || _l === void 0 ? void 0 : _l.variables)
            ? `
          (
            
    ${fields.checkEmailAvailability.variables.email
                ? `
      email: ${fields.checkEmailAvailability.variables.email}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmailAvailabilityGQLFields(fields.checkEmailAvailability.fields)}
        }
      `
        : ``}
    

      ${fields.checkInvitationLinkValidity
        ? `
        checkInvitationLinkValidity
        ${((_m = fields.checkInvitationLinkValidity) === null || _m === void 0 ? void 0 : _m.variables)
            ? `
          (
            
    ${fields.checkInvitationLinkValidity.variables.invitationLinkId
                ? `
      invitationLinkId: ${fields.checkInvitationLinkValidity.variables.invitationLinkId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationLinkGQLFields(fields.checkInvitationLinkValidity.fields)}
        }
      `
        : ``}
    

      ${fields.checkMemberInvitationValidity
        ? `
        checkMemberInvitationValidity
        ${((_o = fields.checkMemberInvitationValidity) === null || _o === void 0 ? void 0 : _o.variables)
            ? `
          (
            
    ${fields.checkMemberInvitationValidity.variables.token
                ? `
      token: ${fields.checkMemberInvitationValidity.variables.token}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationGQLFields(fields.checkMemberInvitationValidity.fields)}
        }
      `
        : ``}
    

      ${fields.checkNewDomainStatus
        ? `
        checkNewDomainStatus
        ${((_p = fields.checkNewDomainStatus) === null || _p === void 0 ? void 0 : _p.variables)
            ? `
          (
            
    ${fields.checkNewDomainStatus.variables.domain
                ? `
      domain: ${fields.checkNewDomainStatus.variables.domain}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DomainTransferStatusGQLFields(fields.checkNewDomainStatus.fields)}
        }
      `
        : ``}
    

      ${fields.checkPasswordComplexity
        ? `
        checkPasswordComplexity
        ${((_q = fields.checkPasswordComplexity) === null || _q === void 0 ? void 0 : _q.variables)
            ? `
          (
            
    ${fields.checkPasswordComplexity.variables.password
                ? `
      password: ${fields.checkPasswordComplexity.variables.password}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PasswordComplexityGQLFields(fields.checkPasswordComplexity.fields)}
        }
      `
        : ``}
    

      ${fields.checkUsernameAvailability
        ? `
        checkUsernameAvailability
        ${((_r = fields.checkUsernameAvailability) === null || _r === void 0 ? void 0 : _r.variables)
            ? `
          (
            
    ${fields.checkUsernameAvailability.variables.username
                ? `
      username: ${fields.checkUsernameAvailability.variables.username}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${UsernameAvailabilityGQLFields(fields.checkUsernameAvailability.fields)}
        }
      `
        : ``}
    

      ${fields.collection
        ? `
        collection
        ${((_s = fields.collection) === null || _s === void 0 ? void 0 : _s.variables)
            ? `
          (
            
    ${fields.collection.variables.id
                ? `
      id: ${fields.collection.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CollectionGQLFields(fields.collection.fields)}
        }
      `
        : ``}
    

      ${fields.collections
        ? `
        collections
        ${((_t = fields.collections) === null || _t === void 0 ? void 0 : _t.variables)
            ? `
          (
            
    ${fields.collections.variables.orderBy
                ? `
      orderBy: ${fields.collections.variables.orderBy}
    `
                : ``}
  

    ${fields.collections.variables.reverse
                ? `
      reverse: ${fields.collections.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CollectionGQLFields(fields.collections.fields)}
        }
      `
        : ``}
    

      ${fields.domainAvailability
        ? `
        domainAvailability
        ${((_u = fields.domainAvailability) === null || _u === void 0 ? void 0 : _u.variables)
            ? `
          (
            
    ${fields.domainAvailability.variables.input
                ? `
      input: ${fields.domainAvailability.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DomainAvailabilityGQLFields(fields.domainAvailability.fields)}
        }
      `
        : ``}
    

      ${fields.dynamicBlock
        ? `
        dynamicBlock
        ${((_v = fields.dynamicBlock) === null || _v === void 0 ? void 0 : _v.variables)
            ? `
          (
            
    ${fields.dynamicBlock.variables.blockId
                ? `
      blockId: ${fields.dynamicBlock.variables.blockId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DynamicBlockGQLFields(fields.dynamicBlock.fields)}
        }
      `
        : ``}
    

      ${fields.dynamicBlockByKey
        ? `
        dynamicBlockByKey
        ${((_w = fields.dynamicBlockByKey) === null || _w === void 0 ? void 0 : _w.variables)
            ? `
          (
            
    ${fields.dynamicBlockByKey.variables.appId
                ? `
      appId: ${fields.dynamicBlockByKey.variables.appId}
    `
                : ``}
  

    ${fields.dynamicBlockByKey.variables.key
                ? `
      key: ${fields.dynamicBlockByKey.variables.key}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DynamicBlockGQLFields(fields.dynamicBlockByKey.fields)}
        }
      `
        : ``}
    

      ${fields.dynamicBlocks
        ? `
        dynamicBlocks
        ${((_x = fields.dynamicBlocks) === null || _x === void 0 ? void 0 : _x.variables)
            ? `
          (
            
    ${fields.dynamicBlocks.variables.after
                ? `
      after: ${fields.dynamicBlocks.variables.after}
    `
                : ``}
  

    ${fields.dynamicBlocks.variables.appIds
                ? `
      appIds: ${fields.dynamicBlocks.variables.appIds}
    `
                : ``}
  

    ${fields.dynamicBlocks.variables.before
                ? `
      before: ${fields.dynamicBlocks.variables.before}
    `
                : ``}
  

    ${fields.dynamicBlocks.variables.contexts
                ? `
      contexts: ${fields.dynamicBlocks.variables.contexts}
    `
                : ``}
  

    ${fields.dynamicBlocks.variables.limit
                ? `
      limit: ${fields.dynamicBlocks.variables.limit}
    `
                : ``}
  

    ${fields.dynamicBlocks.variables.offset
                ? `
      offset: ${fields.dynamicBlocks.variables.offset}
    `
                : ``}
  

    ${fields.dynamicBlocks.variables.reverse
                ? `
      reverse: ${fields.dynamicBlocks.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedDynamicBlockGQLFields(fields.dynamicBlocks.fields)}
        }
      `
        : ``}
    

      ${fields.emailAvailability
        ? `
        emailAvailability
        ${((_y = fields.emailAvailability) === null || _y === void 0 ? void 0 : _y.variables)
            ? `
          (
            
    ${fields.emailAvailability.variables.email
                ? `
      email: ${fields.emailAvailability.variables.email}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmailAvailabilityGQLFields(fields.emailAvailability.fields)}
        }
      `
        : ``}
    

      ${fields.emailLogs
        ? `
        emailLogs
        ${((_z = fields.emailLogs) === null || _z === void 0 ? void 0 : _z.variables)
            ? `
          (
            
    ${fields.emailLogs.variables.after
                ? `
      after: ${fields.emailLogs.variables.after}
    `
                : ``}
  

    ${fields.emailLogs.variables.limit
                ? `
      limit: ${fields.emailLogs.variables.limit}
    `
                : ``}
  

    ${fields.emailLogs.variables.recipient
                ? `
      recipient: ${fields.emailLogs.variables.recipient}
    `
                : ``}
  

    ${fields.emailLogs.variables.reverse
                ? `
      reverse: ${fields.emailLogs.variables.reverse}
    `
                : ``}
  

    ${fields.emailLogs.variables.statuses
                ? `
      statuses: ${fields.emailLogs.variables.statuses}
    `
                : ``}
  

    ${fields.emailLogs.variables.types
                ? `
      types: ${fields.emailLogs.variables.types}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedEmailLogGQLFields(fields.emailLogs.fields)}
        }
      `
        : ``}
    

      ${fields.embed
        ? `
        embed
        ${((_0 = fields.embed) === null || _0 === void 0 ? void 0 : _0.variables)
            ? `
          (
            
    ${fields.embed.variables.input
                ? `
      input: ${fields.embed.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmbedGQLFields(fields.embed.fields)}
        }
      `
        : ``}
    

      ${fields.exploreSpaces
        ? `
        exploreSpaces
        ${((_1 = fields.exploreSpaces) === null || _1 === void 0 ? void 0 : _1.variables)
            ? `
          (
            
    ${fields.exploreSpaces.variables.after
                ? `
      after: ${fields.exploreSpaces.variables.after}
    `
                : ``}
  

    ${fields.exploreSpaces.variables.before
                ? `
      before: ${fields.exploreSpaces.variables.before}
    `
                : ``}
  

    ${fields.exploreSpaces.variables.collectionId
                ? `
      collectionId: ${fields.exploreSpaces.variables.collectionId}
    `
                : ``}
  

    ${fields.exploreSpaces.variables.limit
                ? `
      limit: ${fields.exploreSpaces.variables.limit}
    `
                : ``}
  

    ${fields.exploreSpaces.variables.offset
                ? `
      offset: ${fields.exploreSpaces.variables.offset}
    `
                : ``}
  

    ${fields.exploreSpaces.variables.reverse
                ? `
      reverse: ${fields.exploreSpaces.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.exploreSpaces.fields)}
        }
      `
        : ``}
    

      ${fields.exportMemberRequest
        ? `
        exportMemberRequest
        ${((_2 = fields.exportMemberRequest) === null || _2 === void 0 ? void 0 : _2.variables)
            ? `
          (
            
    ${fields.exportMemberRequest.variables.id
                ? `
      id: ${fields.exportMemberRequest.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ExportGQLFields(fields.exportMemberRequest.fields)}
        }
      `
        : ``}
    

      ${fields.exportMemberRequests
        ? `
        exportMemberRequests
        ${((_3 = fields.exportMemberRequests) === null || _3 === void 0 ? void 0 : _3.variables)
            ? `
          (
            
    ${fields.exportMemberRequests.variables.after
                ? `
      after: ${fields.exportMemberRequests.variables.after}
    `
                : ``}
  

    ${fields.exportMemberRequests.variables.before
                ? `
      before: ${fields.exportMemberRequests.variables.before}
    `
                : ``}
  

    ${fields.exportMemberRequests.variables.limit
                ? `
      limit: ${fields.exportMemberRequests.variables.limit}
    `
                : ``}
  

    ${fields.exportMemberRequests.variables.offset
                ? `
      offset: ${fields.exportMemberRequests.variables.offset}
    `
                : ``}
  

    ${fields.exportMemberRequests.variables.orderBy
                ? `
      orderBy: ${fields.exportMemberRequests.variables.orderBy}
    `
                : ``}
  

    ${fields.exportMemberRequests.variables.query
                ? `
      query: ${fields.exportMemberRequests.variables.query}
    `
                : ``}
  

    ${fields.exportMemberRequests.variables.reverse
                ? `
      reverse: ${fields.exportMemberRequests.variables.reverse}
    `
                : ``}
  

    ${fields.exportMemberRequests.variables.statuses
                ? `
      statuses: ${fields.exportMemberRequests.variables.statuses}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedExportGQLFields(fields.exportMemberRequests.fields)}
        }
      `
        : ``}
    

      ${fields.extraProperties
        ? `
        extraProperties
        ${((_4 = fields.extraProperties) === null || _4 === void 0 ? void 0 : _4.variables)
            ? `
          (
            
    ${fields.extraProperties.variables.entityId
                ? `
      entityId: ${fields.extraProperties.variables.entityId}
    `
                : ``}
  

    ${fields.extraProperties.variables.entityType
                ? `
      entityType: ${fields.extraProperties.variables.entityType}
    `
                : ``}
  

    ${fields.extraProperties.variables.keys
                ? `
      keys: ${fields.extraProperties.variables.keys}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ExtraPropertyGQLFields(fields.extraProperties.fields)}
        }
      `
        : ``}
    

      ${fields.feed
        ? `
        feed
        ${((_5 = fields.feed) === null || _5 === void 0 ? void 0 : _5.variables)
            ? `
          (
            
    ${fields.feed.variables.after
                ? `
      after: ${fields.feed.variables.after}
    `
                : ``}
  

    ${fields.feed.variables.before
                ? `
      before: ${fields.feed.variables.before}
    `
                : ``}
  

    ${fields.feed.variables.filterBy
                ? `
      filterBy: ${fields.feed.variables.filterBy}
    `
                : ``}
  

    ${fields.feed.variables.limit
                ? `
      limit: ${fields.feed.variables.limit}
    `
                : ``}
  

    ${fields.feed.variables.offset
                ? `
      offset: ${fields.feed.variables.offset}
    `
                : ``}
  

    ${fields.feed.variables.onlyMemberSpaces
                ? `
      onlyMemberSpaces: ${fields.feed.variables.onlyMemberSpaces}
    `
                : ``}
  

    ${fields.feed.variables.orderBy
                ? `
      orderBy: ${fields.feed.variables.orderBy}
    `
                : ``}
  

    ${fields.feed.variables.orderByString
                ? `
      orderByString: ${fields.feed.variables.orderByString}
    `
                : ``}
  

    ${fields.feed.variables.postTypeIds
                ? `
      postTypeIds: ${fields.feed.variables.postTypeIds}
    `
                : ``}
  

    ${fields.feed.variables.reverse
                ? `
      reverse: ${fields.feed.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.feed.fields)}
        }
      `
        : ``}
    

      ${fields.getAppById
        ? `
        getAppById
        ${((_6 = fields.getAppById) === null || _6 === void 0 ? void 0 : _6.variables)
            ? `
          (
            
    ${fields.getAppById.variables.id
                ? `
      id: ${fields.getAppById.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.getAppById.fields)}
        }
      `
        : ``}
    

      ${fields.getAppBySlug
        ? `
        getAppBySlug
        ${((_7 = fields.getAppBySlug) === null || _7 === void 0 ? void 0 : _7.variables)
            ? `
          (
            
    ${fields.getAppBySlug.variables.slug
                ? `
      slug: ${fields.getAppBySlug.variables.slug}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.getAppBySlug.fields)}
        }
      `
        : ``}
    
getAppNetworkSettings
        ${((_8 = fields.getAppNetworkSettings) === null || _8 === void 0 ? void 0 : _8.variables)
        ? `
          (
            
    ${fields.getAppNetworkSettings.variables.appId
            ? `
      appId: ${fields.getAppNetworkSettings.variables.appId}
    `
            : ``}
  
          )
        `
        : ``}
      
getAppSpaceSettings
        ${((_9 = fields.getAppSpaceSettings) === null || _9 === void 0 ? void 0 : _9.variables)
        ? `
          (
            
    ${fields.getAppSpaceSettings.variables.appId
            ? `
      appId: ${fields.getAppSpaceSettings.variables.appId}
    `
            : ``}
  

    ${fields.getAppSpaceSettings.variables.spaceId
            ? `
      spaceId: ${fields.getAppSpaceSettings.variables.spaceId}
    `
            : ``}
  
          )
        `
        : ``}
      

      ${fields.getApps
        ? `
        getApps
        ${((_10 = fields.getApps) === null || _10 === void 0 ? void 0 : _10.variables)
            ? `
          (
            
    ${fields.getApps.variables.after
                ? `
      after: ${fields.getApps.variables.after}
    `
                : ``}
  

    ${fields.getApps.variables.before
                ? `
      before: ${fields.getApps.variables.before}
    `
                : ``}
  

    ${fields.getApps.variables.limit
                ? `
      limit: ${fields.getApps.variables.limit}
    `
                : ``}
  

    ${fields.getApps.variables.offset
                ? `
      offset: ${fields.getApps.variables.offset}
    `
                : ``}
  

    ${fields.getApps.variables.reverse
                ? `
      reverse: ${fields.getApps.variables.reverse}
    `
                : ``}
  

    ${fields.getApps.variables.status
                ? `
      status: ${fields.getApps.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppGQLFields(fields.getApps.fields)}
        }
      `
        : ``}
    

    ${fields.getAuthMember
        ? `
      getAuthMember {
        ${MemberGQLFields(fields.getAuthMember)}
      }
    `
        : ``}
  

      ${fields.getEmbed
        ? `
        getEmbed
        ${((_11 = fields.getEmbed) === null || _11 === void 0 ? void 0 : _11.variables)
            ? `
          (
            
    ${fields.getEmbed.variables.input
                ? `
      input: ${fields.getEmbed.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmbedGQLFields(fields.getEmbed.fields)}
        }
      `
        : ``}
    

      ${fields.getFeed
        ? `
        getFeed
        ${((_12 = fields.getFeed) === null || _12 === void 0 ? void 0 : _12.variables)
            ? `
          (
            
    ${fields.getFeed.variables.after
                ? `
      after: ${fields.getFeed.variables.after}
    `
                : ``}
  

    ${fields.getFeed.variables.before
                ? `
      before: ${fields.getFeed.variables.before}
    `
                : ``}
  

    ${fields.getFeed.variables.filterBy
                ? `
      filterBy: ${fields.getFeed.variables.filterBy}
    `
                : ``}
  

    ${fields.getFeed.variables.limit
                ? `
      limit: ${fields.getFeed.variables.limit}
    `
                : ``}
  

    ${fields.getFeed.variables.offset
                ? `
      offset: ${fields.getFeed.variables.offset}
    `
                : ``}
  

    ${fields.getFeed.variables.onlyMemberSpaces
                ? `
      onlyMemberSpaces: ${fields.getFeed.variables.onlyMemberSpaces}
    `
                : ``}
  

    ${fields.getFeed.variables.orderBy
                ? `
      orderBy: ${fields.getFeed.variables.orderBy}
    `
                : ``}
  

    ${fields.getFeed.variables.postTypeIds
                ? `
      postTypeIds: ${fields.getFeed.variables.postTypeIds}
    `
                : ``}
  

    ${fields.getFeed.variables.reverse
                ? `
      reverse: ${fields.getFeed.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.getFeed.fields)}
        }
      `
        : ``}
    

      ${fields.getGroup
        ? `
        getGroup
        ${((_13 = fields.getGroup) === null || _13 === void 0 ? void 0 : _13.variables)
            ? `
          (
            
    ${fields.getGroup.variables.groupId
                ? `
      groupId: ${fields.getGroup.variables.groupId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${CollectionGQLFields(fields.getGroup.fields)}
        }
      `
        : ``}
    

    ${fields.getGroups
        ? `
      getGroups {
        ${CollectionGQLFields(fields.getGroups)}
      }
    `
        : ``}
  

      ${fields.getMedia
        ? `
        getMedia
        ${((_14 = fields.getMedia) === null || _14 === void 0 ? void 0 : _14.variables)
            ? `
          (
            
    ${fields.getMedia.variables.mediaId
                ? `
      mediaId: ${fields.getMedia.variables.mediaId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MediaGQLFields(fields.getMedia.fields)}
        }
      `
        : ``}
    

      ${fields.getMember
        ? `
        getMember
        ${((_15 = fields.getMember) === null || _15 === void 0 ? void 0 : _15.variables)
            ? `
          (
            
    ${fields.getMember.variables.memberId
                ? `
      memberId: ${fields.getMember.variables.memberId}
    `
                : ``}
  

    ${fields.getMember.variables.username
                ? `
      username: ${fields.getMember.variables.username}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberGQLFields(fields.getMember.fields)}
        }
      `
        : ``}
    

      ${fields.getMemberAppInstallations
        ? `
        getMemberAppInstallations
        ${((_16 = fields.getMemberAppInstallations) === null || _16 === void 0 ? void 0 : _16.variables)
            ? `
          (
            
    ${fields.getMemberAppInstallations.variables.after
                ? `
      after: ${fields.getMemberAppInstallations.variables.after}
    `
                : ``}
  

    ${fields.getMemberAppInstallations.variables.before
                ? `
      before: ${fields.getMemberAppInstallations.variables.before}
    `
                : ``}
  

    ${fields.getMemberAppInstallations.variables.limit
                ? `
      limit: ${fields.getMemberAppInstallations.variables.limit}
    `
                : ``}
  

    ${fields.getMemberAppInstallations.variables.offset
                ? `
      offset: ${fields.getMemberAppInstallations.variables.offset}
    `
                : ``}
  

    ${fields.getMemberAppInstallations.variables.reverse
                ? `
      reverse: ${fields.getMemberAppInstallations.variables.reverse}
    `
                : ``}
  

    ${fields.getMemberAppInstallations.variables.status
                ? `
      status: ${fields.getMemberAppInstallations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppInstallationGQLFields(fields.getMemberAppInstallations.fields)}
        }
      `
        : ``}
    

      ${fields.getMemberInvitation
        ? `
        getMemberInvitation
        ${((_17 = fields.getMemberInvitation) === null || _17 === void 0 ? void 0 : _17.variables)
            ? `
          (
            
    ${fields.getMemberInvitation.variables.id
                ? `
      id: ${fields.getMemberInvitation.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationGQLFields(fields.getMemberInvitation.fields)}
        }
      `
        : ``}
    

    ${fields.getMemberInvitationLink
        ? `
      getMemberInvitationLink {
        ${MemberInvitationLinkGQLFields(fields.getMemberInvitationLink)}
      }
    `
        : ``}
  

      ${fields.getMemberInvitations
        ? `
        getMemberInvitations
        ${((_18 = fields.getMemberInvitations) === null || _18 === void 0 ? void 0 : _18.variables)
            ? `
          (
            
    ${fields.getMemberInvitations.variables.after
                ? `
      after: ${fields.getMemberInvitations.variables.after}
    `
                : ``}
  

    ${fields.getMemberInvitations.variables.before
                ? `
      before: ${fields.getMemberInvitations.variables.before}
    `
                : ``}
  

    ${fields.getMemberInvitations.variables.limit
                ? `
      limit: ${fields.getMemberInvitations.variables.limit}
    `
                : ``}
  

    ${fields.getMemberInvitations.variables.offset
                ? `
      offset: ${fields.getMemberInvitations.variables.offset}
    `
                : ``}
  

    ${fields.getMemberInvitations.variables.query
                ? `
      query: ${fields.getMemberInvitations.variables.query}
    `
                : ``}
  

    ${fields.getMemberInvitations.variables.reverse
                ? `
      reverse: ${fields.getMemberInvitations.variables.reverse}
    `
                : ``}
  

    ${fields.getMemberInvitations.variables.roleIds
                ? `
      roleIds: ${fields.getMemberInvitations.variables.roleIds}
    `
                : ``}
  

    ${fields.getMemberInvitations.variables.status
                ? `
      status: ${fields.getMemberInvitations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedMemberInvitationGQLFields(fields.getMemberInvitations.fields)}
        }
      `
        : ``}
    

      ${fields.getMemberNetworkNotificationSettings
        ? `
        getMemberNetworkNotificationSettings
        ${((_19 = fields.getMemberNetworkNotificationSettings) === null || _19 === void 0 ? void 0 : _19.variables)
            ? `
          (
            
    ${fields.getMemberNetworkNotificationSettings.variables.memberId
                ? `
      memberId: ${fields.getMemberNetworkNotificationSettings.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberNetworkNotificationSettingsGQLFields(fields.getMemberNetworkNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.getMemberNotificationSettings
        ? `
        getMemberNotificationSettings
        ${((_20 = fields.getMemberNotificationSettings) === null || _20 === void 0 ? void 0 : _20.variables)
            ? `
          (
            
    ${fields.getMemberNotificationSettings.variables.memberId
                ? `
      memberId: ${fields.getMemberNotificationSettings.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberNotificationSettingsGQLFields(fields.getMemberNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.getMemberPosts
        ? `
        getMemberPosts
        ${((_21 = fields.getMemberPosts) === null || _21 === void 0 ? void 0 : _21.variables)
            ? `
          (
            
    ${fields.getMemberPosts.variables.after
                ? `
      after: ${fields.getMemberPosts.variables.after}
    `
                : ``}
  

    ${fields.getMemberPosts.variables.before
                ? `
      before: ${fields.getMemberPosts.variables.before}
    `
                : ``}
  

    ${fields.getMemberPosts.variables.limit
                ? `
      limit: ${fields.getMemberPosts.variables.limit}
    `
                : ``}
  

    ${fields.getMemberPosts.variables.memberId
                ? `
      memberId: ${fields.getMemberPosts.variables.memberId}
    `
                : ``}
  

    ${fields.getMemberPosts.variables.offset
                ? `
      offset: ${fields.getMemberPosts.variables.offset}
    `
                : ``}
  

    ${fields.getMemberPosts.variables.reverse
                ? `
      reverse: ${fields.getMemberPosts.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.getMemberPosts.fields)}
        }
      `
        : ``}
    

      ${fields.getMemberSpaceNotificationSettings
        ? `
        getMemberSpaceNotificationSettings
        ${((_22 = fields.getMemberSpaceNotificationSettings) === null || _22 === void 0 ? void 0 : _22.variables)
            ? `
          (
            
    ${fields.getMemberSpaceNotificationSettings.variables.memberId
                ? `
      memberId: ${fields.getMemberSpaceNotificationSettings.variables.memberId}
    `
                : ``}
  

    ${fields.getMemberSpaceNotificationSettings.variables.spaceId
                ? `
      spaceId: ${fields.getMemberSpaceNotificationSettings.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberSpaceNotificationSettingsGQLFields(fields.getMemberSpaceNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.getMemberSpaces
        ? `
        getMemberSpaces
        ${((_23 = fields.getMemberSpaces) === null || _23 === void 0 ? void 0 : _23.variables)
            ? `
          (
            
    ${fields.getMemberSpaces.variables.after
                ? `
      after: ${fields.getMemberSpaces.variables.after}
    `
                : ``}
  

    ${fields.getMemberSpaces.variables.before
                ? `
      before: ${fields.getMemberSpaces.variables.before}
    `
                : ``}
  

    ${fields.getMemberSpaces.variables.groupId
                ? `
      groupId: ${fields.getMemberSpaces.variables.groupId}
    `
                : ``}
  

    ${fields.getMemberSpaces.variables.limit
                ? `
      limit: ${fields.getMemberSpaces.variables.limit}
    `
                : ``}
  

    ${fields.getMemberSpaces.variables.memberId
                ? `
      memberId: ${fields.getMemberSpaces.variables.memberId}
    `
                : ``}
  

    ${fields.getMemberSpaces.variables.offset
                ? `
      offset: ${fields.getMemberSpaces.variables.offset}
    `
                : ``}
  

    ${fields.getMemberSpaces.variables.reverse
                ? `
      reverse: ${fields.getMemberSpaces.variables.reverse}
    `
                : ``}
  

    ${fields.getMemberSpaces.variables.roleIds
                ? `
      roleIds: ${fields.getMemberSpaces.variables.roleIds}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceMemberGQLFields(fields.getMemberSpaces.fields)}
        }
      `
        : ``}
    

      ${fields.getMembers
        ? `
        getMembers
        ${((_24 = fields.getMembers) === null || _24 === void 0 ? void 0 : _24.variables)
            ? `
          (
            
    ${fields.getMembers.variables.after
                ? `
      after: ${fields.getMembers.variables.after}
    `
                : ``}
  

    ${fields.getMembers.variables.before
                ? `
      before: ${fields.getMembers.variables.before}
    `
                : ``}
  

    ${fields.getMembers.variables.limit
                ? `
      limit: ${fields.getMembers.variables.limit}
    `
                : ``}
  

    ${fields.getMembers.variables.offset
                ? `
      offset: ${fields.getMembers.variables.offset}
    `
                : ``}
  

    ${fields.getMembers.variables.query
                ? `
      query: ${fields.getMembers.variables.query}
    `
                : ``}
  

    ${fields.getMembers.variables.reverse
                ? `
      reverse: ${fields.getMembers.variables.reverse}
    `
                : ``}
  

    ${fields.getMembers.variables.roleIds
                ? `
      roleIds: ${fields.getMembers.variables.roleIds}
    `
                : ``}
  

    ${fields.getMembers.variables.status
                ? `
      status: ${fields.getMembers.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedMemberGQLFields(fields.getMembers.fields)}
        }
      `
        : ``}
    

      ${fields.getModerationById
        ? `
        getModerationById
        ${((_25 = fields.getModerationById) === null || _25 === void 0 ? void 0 : _25.variables)
            ? `
          (
            
    ${fields.getModerationById.variables.moderationId
                ? `
      moderationId: ${fields.getModerationById.variables.moderationId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ModerationItemGQLFields(fields.getModerationById.fields)}
        }
      `
        : ``}
    

      ${fields.getModerationReporters
        ? `
        getModerationReporters
        ${((_26 = fields.getModerationReporters) === null || _26 === void 0 ? void 0 : _26.variables)
            ? `
          (
            
    ${fields.getModerationReporters.variables.after
                ? `
      after: ${fields.getModerationReporters.variables.after}
    `
                : ``}
  

    ${fields.getModerationReporters.variables.before
                ? `
      before: ${fields.getModerationReporters.variables.before}
    `
                : ``}
  

    ${fields.getModerationReporters.variables.limit
                ? `
      limit: ${fields.getModerationReporters.variables.limit}
    `
                : ``}
  

    ${fields.getModerationReporters.variables.moderationId
                ? `
      moderationId: ${fields.getModerationReporters.variables.moderationId}
    `
                : ``}
  

    ${fields.getModerationReporters.variables.offset
                ? `
      offset: ${fields.getModerationReporters.variables.offset}
    `
                : ``}
  

    ${fields.getModerationReporters.variables.reverse
                ? `
      reverse: ${fields.getModerationReporters.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedModerationItemReporterGQLFields(fields.getModerationReporters.fields)}
        }
      `
        : ``}
    

    ${fields.getModerationSetting
        ? `
      getModerationSetting {
        ${ModerationSettingsGQLFields(fields.getModerationSetting)}
      }
    `
        : ``}
  

      ${fields.getModerations
        ? `
        getModerations
        ${((_27 = fields.getModerations) === null || _27 === void 0 ? void 0 : _27.variables)
            ? `
          (
            
    ${fields.getModerations.variables.after
                ? `
      after: ${fields.getModerations.variables.after}
    `
                : ``}
  

    ${fields.getModerations.variables.before
                ? `
      before: ${fields.getModerations.variables.before}
    `
                : ``}
  

    ${fields.getModerations.variables.entityId
                ? `
      entityId: ${fields.getModerations.variables.entityId}
    `
                : ``}
  

    ${fields.getModerations.variables.entityType
                ? `
      entityType: ${fields.getModerations.variables.entityType}
    `
                : ``}
  

    ${fields.getModerations.variables.flaggedBy
                ? `
      flaggedBy: ${fields.getModerations.variables.flaggedBy}
    `
                : ``}
  

    ${fields.getModerations.variables.limit
                ? `
      limit: ${fields.getModerations.variables.limit}
    `
                : ``}
  

    ${fields.getModerations.variables.offset
                ? `
      offset: ${fields.getModerations.variables.offset}
    `
                : ``}
  

    ${fields.getModerations.variables.reverse
                ? `
      reverse: ${fields.getModerations.variables.reverse}
    `
                : ``}
  

    ${fields.getModerations.variables.spaceId
                ? `
      spaceId: ${fields.getModerations.variables.spaceId}
    `
                : ``}
  

    ${fields.getModerations.variables.status
                ? `
      status: ${fields.getModerations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedModerationGQLFields(fields.getModerations.fields)}
        }
      `
        : ``}
    

    ${fields.getNetwork
        ? `
      getNetwork {
        ${NetworkGQLFields(fields.getNetwork)}
      }
    `
        : ``}
  

      ${fields.getNetworkAppInstallations
        ? `
        getNetworkAppInstallations
        ${((_28 = fields.getNetworkAppInstallations) === null || _28 === void 0 ? void 0 : _28.variables)
            ? `
          (
            
    ${fields.getNetworkAppInstallations.variables.after
                ? `
      after: ${fields.getNetworkAppInstallations.variables.after}
    `
                : ``}
  

    ${fields.getNetworkAppInstallations.variables.before
                ? `
      before: ${fields.getNetworkAppInstallations.variables.before}
    `
                : ``}
  

    ${fields.getNetworkAppInstallations.variables.limit
                ? `
      limit: ${fields.getNetworkAppInstallations.variables.limit}
    `
                : ``}
  

    ${fields.getNetworkAppInstallations.variables.offset
                ? `
      offset: ${fields.getNetworkAppInstallations.variables.offset}
    `
                : ``}
  

    ${fields.getNetworkAppInstallations.variables.reverse
                ? `
      reverse: ${fields.getNetworkAppInstallations.variables.reverse}
    `
                : ``}
  

    ${fields.getNetworkAppInstallations.variables.status
                ? `
      status: ${fields.getNetworkAppInstallations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppInstallationGQLFields(fields.getNetworkAppInstallations.fields)}
        }
      `
        : ``}
    

      ${fields.getNetworkApps
        ? `
        getNetworkApps
        ${((_29 = fields.getNetworkApps) === null || _29 === void 0 ? void 0 : _29.variables)
            ? `
          (
            
    ${fields.getNetworkApps.variables.status
                ? `
      status: ${fields.getNetworkApps.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.getNetworkApps.fields)}
        }
      `
        : ``}
    

    ${fields.getNetworkPublicInfo
        ? `
      getNetworkPublicInfo {
        ${NetworkPublicInfoGQLFields(fields.getNetworkPublicInfo)}
      }
    `
        : ``}
  

      ${fields.getNetworks
        ? `
        getNetworks
        ${((_30 = fields.getNetworks) === null || _30 === void 0 ? void 0 : _30.variables)
            ? `
          (
            
    ${fields.getNetworks.variables.after
                ? `
      after: ${fields.getNetworks.variables.after}
    `
                : ``}
  

    ${fields.getNetworks.variables.before
                ? `
      before: ${fields.getNetworks.variables.before}
    `
                : ``}
  

    ${fields.getNetworks.variables.limit
                ? `
      limit: ${fields.getNetworks.variables.limit}
    `
                : ``}
  

    ${fields.getNetworks.variables.offset
                ? `
      offset: ${fields.getNetworks.variables.offset}
    `
                : ``}
  

    ${fields.getNetworks.variables.query
                ? `
      query: ${fields.getNetworks.variables.query}
    `
                : ``}
  

    ${fields.getNetworks.variables.reverse
                ? `
      reverse: ${fields.getNetworks.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedNetworkGQLFields(fields.getNetworks.fields)}
        }
      `
        : ``}
    

      ${fields.getNotifications
        ? `
        getNotifications
        ${((_31 = fields.getNotifications) === null || _31 === void 0 ? void 0 : _31.variables)
            ? `
          (
            
    ${fields.getNotifications.variables.after
                ? `
      after: ${fields.getNotifications.variables.after}
    `
                : ``}
  

    ${fields.getNotifications.variables.limit
                ? `
      limit: ${fields.getNotifications.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedNotificationGQLFields(fields.getNotifications.fields)}
        }
      `
        : ``}
    

    ${fields.getNotificationsCount
        ? `
      getNotificationsCount {
        ${NotificationsCountGQLFields(fields.getNotificationsCount)}
      }
    `
        : ``}
  

      ${fields.getPost
        ? `
        getPost
        ${((_32 = fields.getPost) === null || _32 === void 0 ? void 0 : _32.variables)
            ? `
          (
            
    ${fields.getPost.variables.postId
                ? `
      postId: ${fields.getPost.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.getPost.fields)}
        }
      `
        : ``}
    

      ${fields.getPostAppInstallations
        ? `
        getPostAppInstallations
        ${((_33 = fields.getPostAppInstallations) === null || _33 === void 0 ? void 0 : _33.variables)
            ? `
          (
            
    ${fields.getPostAppInstallations.variables.after
                ? `
      after: ${fields.getPostAppInstallations.variables.after}
    `
                : ``}
  

    ${fields.getPostAppInstallations.variables.before
                ? `
      before: ${fields.getPostAppInstallations.variables.before}
    `
                : ``}
  

    ${fields.getPostAppInstallations.variables.limit
                ? `
      limit: ${fields.getPostAppInstallations.variables.limit}
    `
                : ``}
  

    ${fields.getPostAppInstallations.variables.offset
                ? `
      offset: ${fields.getPostAppInstallations.variables.offset}
    `
                : ``}
  

    ${fields.getPostAppInstallations.variables.postId
                ? `
      postId: ${fields.getPostAppInstallations.variables.postId}
    `
                : ``}
  

    ${fields.getPostAppInstallations.variables.reverse
                ? `
      reverse: ${fields.getPostAppInstallations.variables.reverse}
    `
                : ``}
  

    ${fields.getPostAppInstallations.variables.status
                ? `
      status: ${fields.getPostAppInstallations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppInstallationGQLFields(fields.getPostAppInstallations.fields)}
        }
      `
        : ``}
    

      ${fields.getPostReactionParticipants
        ? `
        getPostReactionParticipants
        ${((_34 = fields.getPostReactionParticipants) === null || _34 === void 0 ? void 0 : _34.variables)
            ? `
          (
            
    ${fields.getPostReactionParticipants.variables.after
                ? `
      after: ${fields.getPostReactionParticipants.variables.after}
    `
                : ``}
  

    ${fields.getPostReactionParticipants.variables.before
                ? `
      before: ${fields.getPostReactionParticipants.variables.before}
    `
                : ``}
  

    ${fields.getPostReactionParticipants.variables.limit
                ? `
      limit: ${fields.getPostReactionParticipants.variables.limit}
    `
                : ``}
  

    ${fields.getPostReactionParticipants.variables.offset
                ? `
      offset: ${fields.getPostReactionParticipants.variables.offset}
    `
                : ``}
  

    ${fields.getPostReactionParticipants.variables.postId
                ? `
      postId: ${fields.getPostReactionParticipants.variables.postId}
    `
                : ``}
  

    ${fields.getPostReactionParticipants.variables.reaction
                ? `
      reaction: ${fields.getPostReactionParticipants.variables.reaction}
    `
                : ``}
  

    ${fields.getPostReactionParticipants.variables.reverse
                ? `
      reverse: ${fields.getPostReactionParticipants.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostReactionParticipantGQLFields(fields.getPostReactionParticipants.fields)}
        }
      `
        : ``}
    

      ${fields.getPosts
        ? `
        getPosts
        ${((_35 = fields.getPosts) === null || _35 === void 0 ? void 0 : _35.variables)
            ? `
          (
            
    ${fields.getPosts.variables.after
                ? `
      after: ${fields.getPosts.variables.after}
    `
                : ``}
  

    ${fields.getPosts.variables.before
                ? `
      before: ${fields.getPosts.variables.before}
    `
                : ``}
  

    ${fields.getPosts.variables.excludePins
                ? `
      excludePins: ${fields.getPosts.variables.excludePins}
    `
                : ``}
  

    ${fields.getPosts.variables.filterBy
                ? `
      filterBy: ${fields.getPosts.variables.filterBy}
    `
                : ``}
  

    ${fields.getPosts.variables.limit
                ? `
      limit: ${fields.getPosts.variables.limit}
    `
                : ``}
  

    ${fields.getPosts.variables.offset
                ? `
      offset: ${fields.getPosts.variables.offset}
    `
                : ``}
  

    ${fields.getPosts.variables.orderBy
                ? `
      orderBy: ${fields.getPosts.variables.orderBy}
    `
                : ``}
  

    ${fields.getPosts.variables.postTypeIds
                ? `
      postTypeIds: ${fields.getPosts.variables.postTypeIds}
    `
                : ``}
  

    ${fields.getPosts.variables.reverse
                ? `
      reverse: ${fields.getPosts.variables.reverse}
    `
                : ``}
  

    ${fields.getPosts.variables.spaceIds
                ? `
      spaceIds: ${fields.getPosts.variables.spaceIds}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.getPosts.fields)}
        }
      `
        : ``}
    

      ${fields.getRedirectUrl
        ? `
        getRedirectUrl
        ${((_36 = fields.getRedirectUrl) === null || _36 === void 0 ? void 0 : _36.variables)
            ? `
          (
            
    ${fields.getRedirectUrl.variables.url
                ? `
      url: ${fields.getRedirectUrl.variables.url}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${RedirectGQLFields(fields.getRedirectUrl.fields)}
        }
      `
        : ``}
    

      ${fields.getReplies
        ? `
        getReplies
        ${((_37 = fields.getReplies) === null || _37 === void 0 ? void 0 : _37.variables)
            ? `
          (
            
    ${fields.getReplies.variables.after
                ? `
      after: ${fields.getReplies.variables.after}
    `
                : ``}
  

    ${fields.getReplies.variables.before
                ? `
      before: ${fields.getReplies.variables.before}
    `
                : ``}
  

    ${fields.getReplies.variables.excludePins
                ? `
      excludePins: ${fields.getReplies.variables.excludePins}
    `
                : ``}
  

    ${fields.getReplies.variables.limit
                ? `
      limit: ${fields.getReplies.variables.limit}
    `
                : ``}
  

    ${fields.getReplies.variables.offset
                ? `
      offset: ${fields.getReplies.variables.offset}
    `
                : ``}
  

    ${fields.getReplies.variables.orderBy
                ? `
      orderBy: ${fields.getReplies.variables.orderBy}
    `
                : ``}
  

    ${fields.getReplies.variables.postId
                ? `
      postId: ${fields.getReplies.variables.postId}
    `
                : ``}
  

    ${fields.getReplies.variables.reverse
                ? `
      reverse: ${fields.getReplies.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.getReplies.fields)}
        }
      `
        : ``}
    

      ${fields.getReport
        ? `
        getReport
        ${((_38 = fields.getReport) === null || _38 === void 0 ? void 0 : _38.variables)
            ? `
          (
            
    ${fields.getReport.variables.input
                ? `
      input: ${fields.getReport.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ReportGQLFields(fields.getReport.fields)}
        }
      `
        : ``}
    

    ${fields.getRoles
        ? `
      getRoles {
        ${RoleGQLFields(fields.getRoles)}
      }
    `
        : ``}
  

      ${fields.getScopes
        ? `
        getScopes
        ${((_39 = fields.getScopes) === null || _39 === void 0 ? void 0 : _39.variables)
            ? `
          (
            
    ${fields.getScopes.variables.contexts
                ? `
      contexts: ${fields.getScopes.variables.contexts}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ScopesGQLFields(fields.getScopes.fields)}
        }
      `
        : ``}
    

      ${fields.getSpace
        ? `
        getSpace
        ${((_40 = fields.getSpace) === null || _40 === void 0 ? void 0 : _40.variables)
            ? `
          (
            
    ${fields.getSpace.variables.spaceId
                ? `
      spaceId: ${fields.getSpace.variables.spaceId}
    `
                : ``}
  

    ${fields.getSpace.variables.spaceSlug
                ? `
      spaceSlug: ${fields.getSpace.variables.spaceSlug}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.getSpace.fields)}
        }
      `
        : ``}
    

      ${fields.getSpaceAppInstallations
        ? `
        getSpaceAppInstallations
        ${((_41 = fields.getSpaceAppInstallations) === null || _41 === void 0 ? void 0 : _41.variables)
            ? `
          (
            
    ${fields.getSpaceAppInstallations.variables.after
                ? `
      after: ${fields.getSpaceAppInstallations.variables.after}
    `
                : ``}
  

    ${fields.getSpaceAppInstallations.variables.before
                ? `
      before: ${fields.getSpaceAppInstallations.variables.before}
    `
                : ``}
  

    ${fields.getSpaceAppInstallations.variables.limit
                ? `
      limit: ${fields.getSpaceAppInstallations.variables.limit}
    `
                : ``}
  

    ${fields.getSpaceAppInstallations.variables.offset
                ? `
      offset: ${fields.getSpaceAppInstallations.variables.offset}
    `
                : ``}
  

    ${fields.getSpaceAppInstallations.variables.reverse
                ? `
      reverse: ${fields.getSpaceAppInstallations.variables.reverse}
    `
                : ``}
  

    ${fields.getSpaceAppInstallations.variables.spaceId
                ? `
      spaceId: ${fields.getSpaceAppInstallations.variables.spaceId}
    `
                : ``}
  

    ${fields.getSpaceAppInstallations.variables.status
                ? `
      status: ${fields.getSpaceAppInstallations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppInstallationGQLFields(fields.getSpaceAppInstallations.fields)}
        }
      `
        : ``}
    

      ${fields.getSpaceMembers
        ? `
        getSpaceMembers
        ${((_42 = fields.getSpaceMembers) === null || _42 === void 0 ? void 0 : _42.variables)
            ? `
          (
            
    ${fields.getSpaceMembers.variables.after
                ? `
      after: ${fields.getSpaceMembers.variables.after}
    `
                : ``}
  

    ${fields.getSpaceMembers.variables.before
                ? `
      before: ${fields.getSpaceMembers.variables.before}
    `
                : ``}
  

    ${fields.getSpaceMembers.variables.limit
                ? `
      limit: ${fields.getSpaceMembers.variables.limit}
    `
                : ``}
  

    ${fields.getSpaceMembers.variables.offset
                ? `
      offset: ${fields.getSpaceMembers.variables.offset}
    `
                : ``}
  

    ${fields.getSpaceMembers.variables.reverse
                ? `
      reverse: ${fields.getSpaceMembers.variables.reverse}
    `
                : ``}
  

    ${fields.getSpaceMembers.variables.roleIds
                ? `
      roleIds: ${fields.getSpaceMembers.variables.roleIds}
    `
                : ``}
  

    ${fields.getSpaceMembers.variables.spaceId
                ? `
      spaceId: ${fields.getSpaceMembers.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceMemberGQLFields(fields.getSpaceMembers.fields)}
        }
      `
        : ``}
    

      ${fields.getSpaceMembershipRequestForMember
        ? `
        getSpaceMembershipRequestForMember
        ${((_43 = fields.getSpaceMembershipRequestForMember) === null || _43 === void 0 ? void 0 : _43.variables)
            ? `
          (
            
    ${fields.getSpaceMembershipRequestForMember.variables.status
                ? `
      status: ${fields.getSpaceMembershipRequestForMember.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceJoinRequestGQLFields(fields.getSpaceMembershipRequestForMember.fields)}
        }
      `
        : ``}
    

      ${fields.getSpaceMembershipRequests
        ? `
        getSpaceMembershipRequests
        ${((_44 = fields.getSpaceMembershipRequests) === null || _44 === void 0 ? void 0 : _44.variables)
            ? `
          (
            
    ${fields.getSpaceMembershipRequests.variables.spaceId
                ? `
      spaceId: ${fields.getSpaceMembershipRequests.variables.spaceId}
    `
                : ``}
  

    ${fields.getSpaceMembershipRequests.variables.status
                ? `
      status: ${fields.getSpaceMembershipRequests.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceJoinRequestGQLFields(fields.getSpaceMembershipRequests.fields)}
        }
      `
        : ``}
    

      ${fields.getSpacePinnedPosts
        ? `
        getSpacePinnedPosts
        ${((_45 = fields.getSpacePinnedPosts) === null || _45 === void 0 ? void 0 : _45.variables)
            ? `
          (
            
    ${fields.getSpacePinnedPosts.variables.spaceId
                ? `
      spaceId: ${fields.getSpacePinnedPosts.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.getSpacePinnedPosts.fields)}
        }
      `
        : ``}
    

      ${fields.getSpaceReport
        ? `
        getSpaceReport
        ${((_46 = fields.getSpaceReport) === null || _46 === void 0 ? void 0 : _46.variables)
            ? `
          (
            
    ${fields.getSpaceReport.variables.input
                ? `
      input: ${fields.getSpaceReport.variables.input}
    `
                : ``}
  

    ${fields.getSpaceReport.variables.spaceId
                ? `
      spaceId: ${fields.getSpaceReport.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ReportGQLFields(fields.getSpaceReport.fields)}
        }
      `
        : ``}
    

      ${fields.getSpaceRoles
        ? `
        getSpaceRoles
        ${((_47 = fields.getSpaceRoles) === null || _47 === void 0 ? void 0 : _47.variables)
            ? `
          (
            
    ${fields.getSpaceRoles.variables.spaceId
                ? `
      spaceId: ${fields.getSpaceRoles.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceRoleGQLFields(fields.getSpaceRoles.fields)}
        }
      `
        : ``}
    

      ${fields.getSpaces
        ? `
        getSpaces
        ${((_48 = fields.getSpaces) === null || _48 === void 0 ? void 0 : _48.variables)
            ? `
          (
            
    ${fields.getSpaces.variables.after
                ? `
      after: ${fields.getSpaces.variables.after}
    `
                : ``}
  

    ${fields.getSpaces.variables.before
                ? `
      before: ${fields.getSpaces.variables.before}
    `
                : ``}
  

    ${fields.getSpaces.variables.limit
                ? `
      limit: ${fields.getSpaces.variables.limit}
    `
                : ``}
  

    ${fields.getSpaces.variables.memberId
                ? `
      memberId: ${fields.getSpaces.variables.memberId}
    `
                : ``}
  

    ${fields.getSpaces.variables.offset
                ? `
      offset: ${fields.getSpaces.variables.offset}
    `
                : ``}
  

    ${fields.getSpaces.variables.query
                ? `
      query: ${fields.getSpaces.variables.query}
    `
                : ``}
  

    ${fields.getSpaces.variables.reverse
                ? `
      reverse: ${fields.getSpaces.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.getSpaces.fields)}
        }
      `
        : ``}
    

      ${fields.getSsoMemberships
        ? `
        getSsoMemberships
        ${((_49 = fields.getSsoMemberships) === null || _49 === void 0 ? void 0 : _49.variables)
            ? `
          (
            
    ${fields.getSsoMemberships.variables.memberId
                ? `
      memberId: ${fields.getSsoMemberships.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SsoMembershipGQLFields(fields.getSsoMemberships.fields)}
        }
      `
        : ``}
    

      ${fields.getSupportNetworkTokens
        ? `
        getSupportNetworkTokens
        ${((_50 = fields.getSupportNetworkTokens) === null || _50 === void 0 ? void 0 : _50.variables)
            ? `
          (
            
    ${fields.getSupportNetworkTokens.variables.input
                ? `
      input: ${fields.getSupportNetworkTokens.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SupportLimitedAuthTokenGQLFields(fields.getSupportNetworkTokens.fields)}
        }
      `
        : ``}
    

      ${fields.getTokens
        ? `
        getTokens
        ${((_51 = fields.getTokens) === null || _51 === void 0 ? void 0 : _51.variables)
            ? `
          (
            
    ${fields.getTokens.variables.networkDomain
                ? `
      networkDomain: ${fields.getTokens.variables.networkDomain}
    `
                : ``}
  

    ${fields.getTokens.variables.networkId
                ? `
      networkId: ${fields.getTokens.variables.networkId}
    `
                : ``}
  

    ${fields.getTokens.variables.otp
                ? `
      otp: ${fields.getTokens.variables.otp}
    `
                : ``}
  

    ${fields.getTokens.variables.refreshToken
                ? `
      refreshToken: ${fields.getTokens.variables.refreshToken}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.getTokens.fields)}
        }
      `
        : ``}
    

      ${fields.globalApp
        ? `
        globalApp
        ${((_52 = fields.globalApp) === null || _52 === void 0 ? void 0 : _52.variables)
            ? `
          (
            
    ${fields.globalApp.variables.id
                ? `
      id: ${fields.globalApp.variables.id}
    `
                : ``}
  

    ${fields.globalApp.variables.slug
                ? `
      slug: ${fields.globalApp.variables.slug}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.globalApp.fields)}
        }
      `
        : ``}
    

      ${fields.globalAppCollaborators
        ? `
        globalAppCollaborators
        ${((_53 = fields.globalAppCollaborators) === null || _53 === void 0 ? void 0 : _53.variables)
            ? `
          (
            
    ${fields.globalAppCollaborators.variables.appId
                ? `
      appId: ${fields.globalAppCollaborators.variables.appId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppCollaboratorGQLFields(fields.globalAppCollaborators.fields)}
        }
      `
        : ``}
    

      ${fields.globalAppPublications
        ? `
        globalAppPublications
        ${((_54 = fields.globalAppPublications) === null || _54 === void 0 ? void 0 : _54.variables)
            ? `
          (
            
    ${fields.globalAppPublications.variables.appId
                ? `
      appId: ${fields.globalAppPublications.variables.appId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppPublicationGQLFields(fields.globalAppPublications.fields)}
        }
      `
        : ``}
    

      ${fields.globalAppSettings
        ? `
        globalAppSettings
        ${((_55 = fields.globalAppSettings) === null || _55 === void 0 ? void 0 : _55.variables)
            ? `
          (
            
    ${fields.globalAppSettings.variables.context
                ? `
      context: ${fields.globalAppSettings.variables.context}
    `
                : ``}
  

    ${fields.globalAppSettings.variables.entityId
                ? `
      entityId: ${fields.globalAppSettings.variables.entityId}
    `
                : ``}
  

    ${fields.globalAppSettings.variables.networkId
                ? `
      networkId: ${fields.globalAppSettings.variables.networkId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppSettingGQLFields(fields.globalAppSettings.fields)}
        }
      `
        : ``}
    

      ${fields.globalApps
        ? `
        globalApps
        ${((_56 = fields.globalApps) === null || _56 === void 0 ? void 0 : _56.variables)
            ? `
          (
            
    ${fields.globalApps.variables.after
                ? `
      after: ${fields.globalApps.variables.after}
    `
                : ``}
  

    ${fields.globalApps.variables.before
                ? `
      before: ${fields.globalApps.variables.before}
    `
                : ``}
  

    ${fields.globalApps.variables.limit
                ? `
      limit: ${fields.globalApps.variables.limit}
    `
                : ``}
  

    ${fields.globalApps.variables.offset
                ? `
      offset: ${fields.globalApps.variables.offset}
    `
                : ``}
  

    ${fields.globalApps.variables.reverse
                ? `
      reverse: ${fields.globalApps.variables.reverse}
    `
                : ``}
  

    ${fields.globalApps.variables.standing
                ? `
      standing: ${fields.globalApps.variables.standing}
    `
                : ``}
  

    ${fields.globalApps.variables.status
                ? `
      status: ${fields.globalApps.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppGQLFields(fields.globalApps.fields)}
        }
      `
        : ``}
    

      ${fields.globalEmbed
        ? `
        globalEmbed
        ${((_57 = fields.globalEmbed) === null || _57 === void 0 ? void 0 : _57.variables)
            ? `
          (
            
    ${fields.globalEmbed.variables.input
                ? `
      input: ${fields.globalEmbed.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${EmbedGQLFields(fields.globalEmbed.fields)}
        }
      `
        : ``}
    

    ${fields.globalEventTypes
        ? `
      globalEventTypes {
        ${EventTypeGQLFields(fields.globalEventTypes)}
      }
    `
        : ``}
  

      ${fields.globalMedia
        ? `
        globalMedia
        ${((_58 = fields.globalMedia) === null || _58 === void 0 ? void 0 : _58.variables)
            ? `
          (
            
    ${fields.globalMedia.variables.id
                ? `
      id: ${fields.globalMedia.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MediaGQLFields(fields.globalMedia.fields)}
        }
      `
        : ``}
    

      ${fields.globalNetworks
        ? `
        globalNetworks
        ${((_59 = fields.globalNetworks) === null || _59 === void 0 ? void 0 : _59.variables)
            ? `
          (
            
    ${fields.globalNetworks.variables.after
                ? `
      after: ${fields.globalNetworks.variables.after}
    `
                : ``}
  

    ${fields.globalNetworks.variables.before
                ? `
      before: ${fields.globalNetworks.variables.before}
    `
                : ``}
  

    ${fields.globalNetworks.variables.limit
                ? `
      limit: ${fields.globalNetworks.variables.limit}
    `
                : ``}
  

    ${fields.globalNetworks.variables.offset
                ? `
      offset: ${fields.globalNetworks.variables.offset}
    `
                : ``}
  

    ${fields.globalNetworks.variables.query
                ? `
      query: ${fields.globalNetworks.variables.query}
    `
                : ``}
  

    ${fields.globalNetworks.variables.reverse
                ? `
      reverse: ${fields.globalNetworks.variables.reverse}
    `
                : ``}
  

    ${fields.globalNetworks.variables.roleType
                ? `
      roleType: ${fields.globalNetworks.variables.roleType}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedNetworkGQLFields(fields.globalNetworks.fields)}
        }
      `
        : ``}
    

      ${fields.globalToken
        ? `
        globalToken
        ${((_60 = fields.globalToken) === null || _60 === void 0 ? void 0 : _60.variables)
            ? `
          (
            
    ${fields.globalToken.variables.input
                ? `
      input: ${fields.globalToken.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${GlobalTokenGQLFields(fields.globalToken.fields)}
        }
      `
        : ``}
    

      ${fields.impersonateLoginToNetwork
        ? `
        impersonateLoginToNetwork
        ${((_61 = fields.impersonateLoginToNetwork) === null || _61 === void 0 ? void 0 : _61.variables)
            ? `
          (
            
    ${fields.impersonateLoginToNetwork.variables.input
                ? `
      input: ${fields.impersonateLoginToNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthInfoWithOtpGQLFields(fields.impersonateLoginToNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.invitationLinkValidity
        ? `
        invitationLinkValidity
        ${((_62 = fields.invitationLinkValidity) === null || _62 === void 0 ? void 0 : _62.variables)
            ? `
          (
            
    ${fields.invitationLinkValidity.variables.id
                ? `
      id: ${fields.invitationLinkValidity.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationLinkGQLFields(fields.invitationLinkValidity.fields)}
        }
      `
        : ``}
    

    ${fields.invoices
        ? `
      invoices {
        ${InvoiceGQLFields(fields.invoices)}
      }
    `
        : ``}
  

      ${fields.leaderboard
        ? `
        leaderboard
        ${((_63 = fields.leaderboard) === null || _63 === void 0 ? void 0 : _63.variables)
            ? `
          (
            
    ${fields.leaderboard.variables.input
                ? `
      input: ${fields.leaderboard.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberGQLFields(fields.leaderboard.fields)}
        }
      `
        : ``}
    

      ${fields.leaderboardWithScores
        ? `
        leaderboardWithScores
        ${((_64 = fields.leaderboardWithScores) === null || _64 === void 0 ? void 0 : _64.variables)
            ? `
          (
            
    ${fields.leaderboardWithScores.variables.includeAuthMember
                ? `
      includeAuthMember: ${fields.leaderboardWithScores.variables.includeAuthMember}
    `
                : ``}
  

    ${fields.leaderboardWithScores.variables.input
                ? `
      input: ${fields.leaderboardWithScores.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${LeaderboardItemGQLFields(fields.leaderboardWithScores.fields)}
        }
      `
        : ``}
    

      ${fields.limitedToken
        ? `
        limitedToken
        ${((_65 = fields.limitedToken) === null || _65 === void 0 ? void 0 : _65.variables)
            ? `
          (
            
    ${fields.limitedToken.variables.context
                ? `
      context: ${fields.limitedToken.variables.context}
    `
                : ``}
  

    ${fields.limitedToken.variables.entityId
                ? `
      entityId: ${fields.limitedToken.variables.entityId}
    `
                : ``}
  

    ${fields.limitedToken.variables.impersonateMemberId
                ? `
      impersonateMemberId: ${fields.limitedToken.variables.impersonateMemberId}
    `
                : ``}
  

    ${fields.limitedToken.variables.networkId
                ? `
      networkId: ${fields.limitedToken.variables.networkId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppTokenGQLFields(fields.limitedToken.fields)}
        }
      `
        : ``}
    

      ${fields.loginNetwork
        ? `
        loginNetwork
        ${((_66 = fields.loginNetwork) === null || _66 === void 0 ? void 0 : _66.variables)
            ? `
          (
            
    ${fields.loginNetwork.variables.input
                ? `
      input: ${fields.loginNetwork.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginNetwork.fields)}
        }
      `
        : ``}
    

      ${fields.loginNetworkWithGlobalToken
        ? `
        loginNetworkWithGlobalToken
        ${((_67 = fields.loginNetworkWithGlobalToken) === null || _67 === void 0 ? void 0 : _67.variables)
            ? `
          (
            
    ${fields.loginNetworkWithGlobalToken.variables.input
                ? `
      input: ${fields.loginNetworkWithGlobalToken.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginNetworkWithGlobalToken.fields)}
        }
      `
        : ``}
    

      ${fields.loginNetworkWithPassword
        ? `
        loginNetworkWithPassword
        ${((_68 = fields.loginNetworkWithPassword) === null || _68 === void 0 ? void 0 : _68.variables)
            ? `
          (
            
    ${fields.loginNetworkWithPassword.variables.input
                ? `
      input: ${fields.loginNetworkWithPassword.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginNetworkWithPassword.fields)}
        }
      `
        : ``}
    

      ${fields.loginSupportWithSso
        ? `
        loginSupportWithSso
        ${((_69 = fields.loginSupportWithSso) === null || _69 === void 0 ? void 0 : _69.variables)
            ? `
          (
            
    ${fields.loginSupportWithSso.variables.input
                ? `
      input: ${fields.loginSupportWithSso.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SupportSsoUrlGQLFields(fields.loginSupportWithSso.fields)}
        }
      `
        : ``}
    

      ${fields.loginSupportWithSsoCode
        ? `
        loginSupportWithSsoCode
        ${((_70 = fields.loginSupportWithSsoCode) === null || _70 === void 0 ? void 0 : _70.variables)
            ? `
          (
            
    ${fields.loginSupportWithSsoCode.variables.input
                ? `
      input: ${fields.loginSupportWithSsoCode.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SupportAuthTokenGQLFields(fields.loginSupportWithSsoCode.fields)}
        }
      `
        : ``}
    

      ${fields.loginWithSso
        ? `
        loginWithSso
        ${((_71 = fields.loginWithSso) === null || _71 === void 0 ? void 0 : _71.variables)
            ? `
          (
            
    ${fields.loginWithSso.variables.input
                ? `
      input: ${fields.loginWithSso.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SsoUrlGQLFields(fields.loginWithSso.fields)}
        }
      `
        : ``}
    

      ${fields.loginWithSsoCode
        ? `
        loginWithSsoCode
        ${((_72 = fields.loginWithSsoCode) === null || _72 === void 0 ? void 0 : _72.variables)
            ? `
          (
            
    ${fields.loginWithSsoCode.variables.input
                ? `
      input: ${fields.loginWithSsoCode.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.loginWithSsoCode.fields)}
        }
      `
        : ``}
    

      ${fields.massActionRequest
        ? `
        massActionRequest
        ${((_73 = fields.massActionRequest) === null || _73 === void 0 ? void 0 : _73.variables)
            ? `
          (
            
    ${fields.massActionRequest.variables.id
                ? `
      id: ${fields.massActionRequest.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MassActionRequestGQLFields(fields.massActionRequest.fields)}
        }
      `
        : ``}
    

    ${fields.massActionRequestInProgress
        ? `
      massActionRequestInProgress {
        ${MassActionRequestGQLFields(fields.massActionRequestInProgress)}
      }
    `
        : ``}
  

      ${fields.media
        ? `
        media
        ${((_74 = fields.media) === null || _74 === void 0 ? void 0 : _74.variables)
            ? `
          (
            
    ${fields.media.variables.id
                ? `
      id: ${fields.media.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MediaGQLFields(fields.media.fields)}
        }
      `
        : ``}
    

      ${fields.member
        ? `
        member
        ${((_75 = fields.member) === null || _75 === void 0 ? void 0 : _75.variables)
            ? `
          (
            
    ${fields.member.variables.id
                ? `
      id: ${fields.member.variables.id}
    `
                : ``}
  

    ${fields.member.variables.username
                ? `
      username: ${fields.member.variables.username}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberGQLFields(fields.member.fields)}
        }
      `
        : ``}
    

      ${fields.memberInvitation
        ? `
        memberInvitation
        ${((_76 = fields.memberInvitation) === null || _76 === void 0 ? void 0 : _76.variables)
            ? `
          (
            
    ${fields.memberInvitation.variables.id
                ? `
      id: ${fields.memberInvitation.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationGQLFields(fields.memberInvitation.fields)}
        }
      `
        : ``}
    

    ${fields.memberInvitationLink
        ? `
      memberInvitationLink {
        ${MemberInvitationLinkGQLFields(fields.memberInvitationLink)}
      }
    `
        : ``}
  

      ${fields.memberInvitationValidity
        ? `
        memberInvitationValidity
        ${((_77 = fields.memberInvitationValidity) === null || _77 === void 0 ? void 0 : _77.variables)
            ? `
          (
            
    ${fields.memberInvitationValidity.variables.token
                ? `
      token: ${fields.memberInvitationValidity.variables.token}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberInvitationGQLFields(fields.memberInvitationValidity.fields)}
        }
      `
        : ``}
    

      ${fields.memberInvitations
        ? `
        memberInvitations
        ${((_78 = fields.memberInvitations) === null || _78 === void 0 ? void 0 : _78.variables)
            ? `
          (
            
    ${fields.memberInvitations.variables.after
                ? `
      after: ${fields.memberInvitations.variables.after}
    `
                : ``}
  

    ${fields.memberInvitations.variables.before
                ? `
      before: ${fields.memberInvitations.variables.before}
    `
                : ``}
  

    ${fields.memberInvitations.variables.filterBy
                ? `
      filterBy: ${fields.memberInvitations.variables.filterBy}
    `
                : ``}
  

    ${fields.memberInvitations.variables.limit
                ? `
      limit: ${fields.memberInvitations.variables.limit}
    `
                : ``}
  

    ${fields.memberInvitations.variables.offset
                ? `
      offset: ${fields.memberInvitations.variables.offset}
    `
                : ``}
  

    ${fields.memberInvitations.variables.query
                ? `
      query: ${fields.memberInvitations.variables.query}
    `
                : ``}
  

    ${fields.memberInvitations.variables.reverse
                ? `
      reverse: ${fields.memberInvitations.variables.reverse}
    `
                : ``}
  

    ${fields.memberInvitations.variables.roleIds
                ? `
      roleIds: ${fields.memberInvitations.variables.roleIds}
    `
                : ``}
  

    ${fields.memberInvitations.variables.status
                ? `
      status: ${fields.memberInvitations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedMemberInvitationGQLFields(fields.memberInvitations.fields)}
        }
      `
        : ``}
    

      ${fields.memberNotificationSettings
        ? `
        memberNotificationSettings
        ${((_79 = fields.memberNotificationSettings) === null || _79 === void 0 ? void 0 : _79.variables)
            ? `
          (
            
    ${fields.memberNotificationSettings.variables.id
                ? `
      id: ${fields.memberNotificationSettings.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberNotificationSettingsGQLFields(fields.memberNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.memberPostNotificationSettings
        ? `
        memberPostNotificationSettings
        ${((_80 = fields.memberPostNotificationSettings) === null || _80 === void 0 ? void 0 : _80.variables)
            ? `
          (
            
    ${fields.memberPostNotificationSettings.variables.memberId
                ? `
      memberId: ${fields.memberPostNotificationSettings.variables.memberId}
    `
                : ``}
  

    ${fields.memberPostNotificationSettings.variables.postId
                ? `
      postId: ${fields.memberPostNotificationSettings.variables.postId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberPostNotificationSettingsGQLFields(fields.memberPostNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.memberPosts
        ? `
        memberPosts
        ${((_81 = fields.memberPosts) === null || _81 === void 0 ? void 0 : _81.variables)
            ? `
          (
            
    ${fields.memberPosts.variables.after
                ? `
      after: ${fields.memberPosts.variables.after}
    `
                : ``}
  

    ${fields.memberPosts.variables.before
                ? `
      before: ${fields.memberPosts.variables.before}
    `
                : ``}
  

    ${fields.memberPosts.variables.hasParent
                ? `
      hasParent: ${fields.memberPosts.variables.hasParent}
    `
                : ``}
  

    ${fields.memberPosts.variables.limit
                ? `
      limit: ${fields.memberPosts.variables.limit}
    `
                : ``}
  

    ${fields.memberPosts.variables.memberId
                ? `
      memberId: ${fields.memberPosts.variables.memberId}
    `
                : ``}
  

    ${fields.memberPosts.variables.offset
                ? `
      offset: ${fields.memberPosts.variables.offset}
    `
                : ``}
  

    ${fields.memberPosts.variables.reverse
                ? `
      reverse: ${fields.memberPosts.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.memberPosts.fields)}
        }
      `
        : ``}
    

      ${fields.memberScore
        ? `
        memberScore
        ${((_82 = fields.memberScore) === null || _82 === void 0 ? void 0 : _82.variables)
            ? `
          (
            
    ${fields.memberScore.variables.input
                ? `
      input: ${fields.memberScore.variables.input}
    `
                : ``}
  

    ${fields.memberScore.variables.spaceId
                ? `
      spaceId: ${fields.memberScore.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ReportGQLFields(fields.memberScore.fields)}
        }
      `
        : ``}
    

      ${fields.memberSpaceMembershipRequest
        ? `
        memberSpaceMembershipRequest
        ${((_83 = fields.memberSpaceMembershipRequest) === null || _83 === void 0 ? void 0 : _83.variables)
            ? `
          (
            
    ${fields.memberSpaceMembershipRequest.variables.status
                ? `
      status: ${fields.memberSpaceMembershipRequest.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceJoinRequestGQLFields(fields.memberSpaceMembershipRequest.fields)}
        }
      `
        : ``}
    

      ${fields.memberSpaces
        ? `
        memberSpaces
        ${((_84 = fields.memberSpaces) === null || _84 === void 0 ? void 0 : _84.variables)
            ? `
          (
            
    ${fields.memberSpaces.variables.after
                ? `
      after: ${fields.memberSpaces.variables.after}
    `
                : ``}
  

    ${fields.memberSpaces.variables.before
                ? `
      before: ${fields.memberSpaces.variables.before}
    `
                : ``}
  

    ${fields.memberSpaces.variables.collectionId
                ? `
      collectionId: ${fields.memberSpaces.variables.collectionId}
    `
                : ``}
  

    ${fields.memberSpaces.variables.limit
                ? `
      limit: ${fields.memberSpaces.variables.limit}
    `
                : ``}
  

    ${fields.memberSpaces.variables.memberId
                ? `
      memberId: ${fields.memberSpaces.variables.memberId}
    `
                : ``}
  

    ${fields.memberSpaces.variables.offset
                ? `
      offset: ${fields.memberSpaces.variables.offset}
    `
                : ``}
  

    ${fields.memberSpaces.variables.reverse
                ? `
      reverse: ${fields.memberSpaces.variables.reverse}
    `
                : ``}
  

    ${fields.memberSpaces.variables.roleIds
                ? `
      roleIds: ${fields.memberSpaces.variables.roleIds}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceMemberGQLFields(fields.memberSpaces.fields)}
        }
      `
        : ``}
    

      ${fields.members
        ? `
        members
        ${((_85 = fields.members) === null || _85 === void 0 ? void 0 : _85.variables)
            ? `
          (
            
    ${fields.members.variables.after
                ? `
      after: ${fields.members.variables.after}
    `
                : ``}
  

    ${fields.members.variables.before
                ? `
      before: ${fields.members.variables.before}
    `
                : ``}
  

    ${fields.members.variables.filterBy
                ? `
      filterBy: ${fields.members.variables.filterBy}
    `
                : ``}
  

    ${fields.members.variables.limit
                ? `
      limit: ${fields.members.variables.limit}
    `
                : ``}
  

    ${fields.members.variables.offset
                ? `
      offset: ${fields.members.variables.offset}
    `
                : ``}
  

    ${fields.members.variables.orderBy
                ? `
      orderBy: ${fields.members.variables.orderBy}
    `
                : ``}
  

    ${fields.members.variables.query
                ? `
      query: ${fields.members.variables.query}
    `
                : ``}
  

    ${fields.members.variables.reverse
                ? `
      reverse: ${fields.members.variables.reverse}
    `
                : ``}
  

    ${fields.members.variables.roleIds
                ? `
      roleIds: ${fields.members.variables.roleIds}
    `
                : ``}
  

    ${fields.members.variables.status
                ? `
      status: ${fields.members.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedMemberGQLFields(fields.members.fields)}
        }
      `
        : ``}
    

      ${fields.membersByIds
        ? `
        membersByIds
        ${((_86 = fields.membersByIds) === null || _86 === void 0 ? void 0 : _86.variables)
            ? `
          (
            
    ${fields.membersByIds.variables.ids
                ? `
      ids: ${fields.membersByIds.variables.ids}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${MemberGQLFields(fields.membersByIds.fields)}
        }
      `
        : ``}
    
migrationSampleFile
        ${((_87 = fields.migrationSampleFile) === null || _87 === void 0 ? void 0 : _87.variables)
        ? `
          (
            
    ${fields.migrationSampleFile.variables.type
            ? `
      type: ${fields.migrationSampleFile.variables.type}
    `
            : ``}
  
          )
        `
        : ``}
      

      ${fields.moderationItem
        ? `
        moderationItem
        ${((_88 = fields.moderationItem) === null || _88 === void 0 ? void 0 : _88.variables)
            ? `
          (
            
    ${fields.moderationItem.variables.id
                ? `
      id: ${fields.moderationItem.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ModerationItemGQLFields(fields.moderationItem.fields)}
        }
      `
        : ``}
    

      ${fields.moderationItemReporters
        ? `
        moderationItemReporters
        ${((_89 = fields.moderationItemReporters) === null || _89 === void 0 ? void 0 : _89.variables)
            ? `
          (
            
    ${fields.moderationItemReporters.variables.after
                ? `
      after: ${fields.moderationItemReporters.variables.after}
    `
                : ``}
  

    ${fields.moderationItemReporters.variables.before
                ? `
      before: ${fields.moderationItemReporters.variables.before}
    `
                : ``}
  

    ${fields.moderationItemReporters.variables.limit
                ? `
      limit: ${fields.moderationItemReporters.variables.limit}
    `
                : ``}
  

    ${fields.moderationItemReporters.variables.moderationId
                ? `
      moderationId: ${fields.moderationItemReporters.variables.moderationId}
    `
                : ``}
  

    ${fields.moderationItemReporters.variables.offset
                ? `
      offset: ${fields.moderationItemReporters.variables.offset}
    `
                : ``}
  

    ${fields.moderationItemReporters.variables.reverse
                ? `
      reverse: ${fields.moderationItemReporters.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedModerationItemReporterGQLFields(fields.moderationItemReporters.fields)}
        }
      `
        : ``}
    

      ${fields.moderationItems
        ? `
        moderationItems
        ${((_90 = fields.moderationItems) === null || _90 === void 0 ? void 0 : _90.variables)
            ? `
          (
            
    ${fields.moderationItems.variables.after
                ? `
      after: ${fields.moderationItems.variables.after}
    `
                : ``}
  

    ${fields.moderationItems.variables.before
                ? `
      before: ${fields.moderationItems.variables.before}
    `
                : ``}
  

    ${fields.moderationItems.variables.entityId
                ? `
      entityId: ${fields.moderationItems.variables.entityId}
    `
                : ``}
  

    ${fields.moderationItems.variables.entityType
                ? `
      entityType: ${fields.moderationItems.variables.entityType}
    `
                : ``}
  

    ${fields.moderationItems.variables.flaggedBy
                ? `
      flaggedBy: ${fields.moderationItems.variables.flaggedBy}
    `
                : ``}
  

    ${fields.moderationItems.variables.limit
                ? `
      limit: ${fields.moderationItems.variables.limit}
    `
                : ``}
  

    ${fields.moderationItems.variables.offset
                ? `
      offset: ${fields.moderationItems.variables.offset}
    `
                : ``}
  

    ${fields.moderationItems.variables.reverse
                ? `
      reverse: ${fields.moderationItems.variables.reverse}
    `
                : ``}
  

    ${fields.moderationItems.variables.spaceId
                ? `
      spaceId: ${fields.moderationItems.variables.spaceId}
    `
                : ``}
  

    ${fields.moderationItems.variables.status
                ? `
      status: ${fields.moderationItems.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedModerationGQLFields(fields.moderationItems.fields)}
        }
      `
        : ``}
    

    ${fields.moderationSettings
        ? `
      moderationSettings {
        ${ModerationSettingsGQLFields(fields.moderationSettings)}
      }
    `
        : ``}
  

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  

      ${fields.networkAppInstallations
        ? `
        networkAppInstallations
        ${((_91 = fields.networkAppInstallations) === null || _91 === void 0 ? void 0 : _91.variables)
            ? `
          (
            
    ${fields.networkAppInstallations.variables.after
                ? `
      after: ${fields.networkAppInstallations.variables.after}
    `
                : ``}
  

    ${fields.networkAppInstallations.variables.before
                ? `
      before: ${fields.networkAppInstallations.variables.before}
    `
                : ``}
  

    ${fields.networkAppInstallations.variables.limit
                ? `
      limit: ${fields.networkAppInstallations.variables.limit}
    `
                : ``}
  

    ${fields.networkAppInstallations.variables.offset
                ? `
      offset: ${fields.networkAppInstallations.variables.offset}
    `
                : ``}
  

    ${fields.networkAppInstallations.variables.reverse
                ? `
      reverse: ${fields.networkAppInstallations.variables.reverse}
    `
                : ``}
  

    ${fields.networkAppInstallations.variables.status
                ? `
      status: ${fields.networkAppInstallations.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppInstallationGQLFields(fields.networkAppInstallations.fields)}
        }
      `
        : ``}
    

      ${fields.networkApps
        ? `
        networkApps
        ${((_92 = fields.networkApps) === null || _92 === void 0 ? void 0 : _92.variables)
            ? `
          (
            
    ${fields.networkApps.variables.status
                ? `
      status: ${fields.networkApps.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AppGQLFields(fields.networkApps.fields)}
        }
      `
        : ``}
    

    ${fields.networkPublicInfo
        ? `
      networkPublicInfo {
        ${NetworkPublicInfoGQLFields(fields.networkPublicInfo)}
      }
    `
        : ``}
  

      ${fields.networks
        ? `
        networks
        ${((_93 = fields.networks) === null || _93 === void 0 ? void 0 : _93.variables)
            ? `
          (
            
    ${fields.networks.variables.after
                ? `
      after: ${fields.networks.variables.after}
    `
                : ``}
  

    ${fields.networks.variables.before
                ? `
      before: ${fields.networks.variables.before}
    `
                : ``}
  

    ${fields.networks.variables.limit
                ? `
      limit: ${fields.networks.variables.limit}
    `
                : ``}
  

    ${fields.networks.variables.offset
                ? `
      offset: ${fields.networks.variables.offset}
    `
                : ``}
  

    ${fields.networks.variables.query
                ? `
      query: ${fields.networks.variables.query}
    `
                : ``}
  

    ${fields.networks.variables.reverse
                ? `
      reverse: ${fields.networks.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedNetworkGQLFields(fields.networks.fields)}
        }
      `
        : ``}
    

      ${fields.networksMembers
        ? `
        networksMembers
        ${((_94 = fields.networksMembers) === null || _94 === void 0 ? void 0 : _94.variables)
            ? `
          (
            
    ${fields.networksMembers.variables.after
                ? `
      after: ${fields.networksMembers.variables.after}
    `
                : ``}
  

    ${fields.networksMembers.variables.before
                ? `
      before: ${fields.networksMembers.variables.before}
    `
                : ``}
  

    ${fields.networksMembers.variables.limit
                ? `
      limit: ${fields.networksMembers.variables.limit}
    `
                : ``}
  

    ${fields.networksMembers.variables.offset
                ? `
      offset: ${fields.networksMembers.variables.offset}
    `
                : ``}
  

    ${fields.networksMembers.variables.query
                ? `
      query: ${fields.networksMembers.variables.query}
    `
                : ``}
  

    ${fields.networksMembers.variables.reverse
                ? `
      reverse: ${fields.networksMembers.variables.reverse}
    `
                : ``}
  

    ${fields.networksMembers.variables.roleType
                ? `
      roleType: ${fields.networksMembers.variables.roleType}
    `
                : ``}
  

    ${fields.networksMembers.variables.status
                ? `
      status: ${fields.networksMembers.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPluralMemberGQLFields(fields.networksMembers.fields)}
        }
      `
        : ``}
    

      ${fields.newDomainStatus
        ? `
        newDomainStatus
        ${((_95 = fields.newDomainStatus) === null || _95 === void 0 ? void 0 : _95.variables)
            ? `
          (
            
    ${fields.newDomainStatus.variables.domain
                ? `
      domain: ${fields.newDomainStatus.variables.domain}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${DomainTransferStatusGQLFields(fields.newDomainStatus.fields)}
        }
      `
        : ``}
    

      ${fields.notifications
        ? `
        notifications
        ${((_96 = fields.notifications) === null || _96 === void 0 ? void 0 : _96.variables)
            ? `
          (
            
    ${fields.notifications.variables.after
                ? `
      after: ${fields.notifications.variables.after}
    `
                : ``}
  

    ${fields.notifications.variables.limit
                ? `
      limit: ${fields.notifications.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedNotificationGQLFields(fields.notifications.fields)}
        }
      `
        : ``}
    

    ${fields.notificationsCount
        ? `
      notificationsCount {
        ${NotificationsCountGQLFields(fields.notificationsCount)}
      }
    `
        : ``}
  

      ${fields.oAuthCode
        ? `
        oAuthCode
        ${((_97 = fields.oAuthCode) === null || _97 === void 0 ? void 0 : _97.variables)
            ? `
          (
            
    ${fields.oAuthCode.variables.input
                ? `
      input: ${fields.oAuthCode.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${OAuthCodeGQLFields(fields.oAuthCode.fields)}
        }
      `
        : ``}
    

      ${fields.oAuthTokens
        ? `
        oAuthTokens
        ${((_98 = fields.oAuthTokens) === null || _98 === void 0 ? void 0 : _98.variables)
            ? `
          (
            
    ${fields.oAuthTokens.variables.input
                ? `
      input: ${fields.oAuthTokens.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${OAuthTokensGQLFields(fields.oAuthTokens.fields)}
        }
      `
        : ``}
    

      ${fields.page
        ? `
        page
        ${((_99 = fields.page) === null || _99 === void 0 ? void 0 : _99.variables)
            ? `
          (
            
    ${fields.page.variables.path
                ? `
      path: ${fields.page.variables.path}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PageGQLFields(fields.page.fields)}
        }
      `
        : ``}
    

      ${fields.passwordComplexity
        ? `
        passwordComplexity
        ${((_100 = fields.passwordComplexity) === null || _100 === void 0 ? void 0 : _100.variables)
            ? `
          (
            
    ${fields.passwordComplexity.variables.password
                ? `
      password: ${fields.passwordComplexity.variables.password}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PasswordComplexityGQLFields(fields.passwordComplexity.fields)}
        }
      `
        : ``}
    

      ${fields.permission
        ? `
        permission
        ${((_101 = fields.permission) === null || _101 === void 0 ? void 0 : _101.variables)
            ? `
          (
            
    ${fields.permission.variables.id
                ? `
      id: ${fields.permission.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PermissionGQLFields(fields.permission.fields)}
        }
      `
        : ``}
    

    ${fields.permissions
        ? `
      permissions {
        ${PermissionGQLFields(fields.permissions)}
      }
    `
        : ``}
  

      ${fields.post
        ? `
        post
        ${((_102 = fields.post) === null || _102 === void 0 ? void 0 : _102.variables)
            ? `
          (
            
    ${fields.post.variables.id
                ? `
      id: ${fields.post.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.post.fields)}
        }
      `
        : ``}
    

      ${fields.postModerationItems
        ? `
        postModerationItems
        ${((_103 = fields.postModerationItems) === null || _103 === void 0 ? void 0 : _103.variables)
            ? `
          (
            
    ${fields.postModerationItems.variables.after
                ? `
      after: ${fields.postModerationItems.variables.after}
    `
                : ``}
  

    ${fields.postModerationItems.variables.before
                ? `
      before: ${fields.postModerationItems.variables.before}
    `
                : ``}
  

    ${fields.postModerationItems.variables.entityId
                ? `
      entityId: ${fields.postModerationItems.variables.entityId}
    `
                : ``}
  

    ${fields.postModerationItems.variables.flaggedBy
                ? `
      flaggedBy: ${fields.postModerationItems.variables.flaggedBy}
    `
                : ``}
  

    ${fields.postModerationItems.variables.limit
                ? `
      limit: ${fields.postModerationItems.variables.limit}
    `
                : ``}
  

    ${fields.postModerationItems.variables.offset
                ? `
      offset: ${fields.postModerationItems.variables.offset}
    `
                : ``}
  

    ${fields.postModerationItems.variables.reverse
                ? `
      reverse: ${fields.postModerationItems.variables.reverse}
    `
                : ``}
  

    ${fields.postModerationItems.variables.spaceId
                ? `
      spaceId: ${fields.postModerationItems.variables.spaceId}
    `
                : ``}
  

    ${fields.postModerationItems.variables.status
                ? `
      status: ${fields.postModerationItems.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedModerationGQLFields(fields.postModerationItems.fields)}
        }
      `
        : ``}
    

      ${fields.postReactionParticipants
        ? `
        postReactionParticipants
        ${((_104 = fields.postReactionParticipants) === null || _104 === void 0 ? void 0 : _104.variables)
            ? `
          (
            
    ${fields.postReactionParticipants.variables.after
                ? `
      after: ${fields.postReactionParticipants.variables.after}
    `
                : ``}
  

    ${fields.postReactionParticipants.variables.before
                ? `
      before: ${fields.postReactionParticipants.variables.before}
    `
                : ``}
  

    ${fields.postReactionParticipants.variables.limit
                ? `
      limit: ${fields.postReactionParticipants.variables.limit}
    `
                : ``}
  

    ${fields.postReactionParticipants.variables.offset
                ? `
      offset: ${fields.postReactionParticipants.variables.offset}
    `
                : ``}
  

    ${fields.postReactionParticipants.variables.postId
                ? `
      postId: ${fields.postReactionParticipants.variables.postId}
    `
                : ``}
  

    ${fields.postReactionParticipants.variables.reaction
                ? `
      reaction: ${fields.postReactionParticipants.variables.reaction}
    `
                : ``}
  

    ${fields.postReactionParticipants.variables.reverse
                ? `
      reverse: ${fields.postReactionParticipants.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostReactionParticipantGQLFields(fields.postReactionParticipants.fields)}
        }
      `
        : ``}
    

      ${fields.postType
        ? `
        postType
        ${((_105 = fields.postType) === null || _105 === void 0 ? void 0 : _105.variables)
            ? `
          (
            
    ${fields.postType.variables.id
                ? `
      id: ${fields.postType.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostTypeGQLFields(fields.postType.fields)}
        }
      `
        : ``}
    

      ${fields.postTypes
        ? `
        postTypes
        ${((_106 = fields.postTypes) === null || _106 === void 0 ? void 0 : _106.variables)
            ? `
          (
            
    ${fields.postTypes.variables.after
                ? `
      after: ${fields.postTypes.variables.after}
    `
                : ``}
  

    ${fields.postTypes.variables.before
                ? `
      before: ${fields.postTypes.variables.before}
    `
                : ``}
  

    ${fields.postTypes.variables.context
                ? `
      context: ${fields.postTypes.variables.context}
    `
                : ``}
  

    ${fields.postTypes.variables.limit
                ? `
      limit: ${fields.postTypes.variables.limit}
    `
                : ``}
  

    ${fields.postTypes.variables.offset
                ? `
      offset: ${fields.postTypes.variables.offset}
    `
                : ``}
  

    ${fields.postTypes.variables.query
                ? `
      query: ${fields.postTypes.variables.query}
    `
                : ``}
  

    ${fields.postTypes.variables.reverse
                ? `
      reverse: ${fields.postTypes.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostTypeGQLFields(fields.postTypes.fields)}
        }
      `
        : ``}
    

      ${fields.posts
        ? `
        posts
        ${((_107 = fields.posts) === null || _107 === void 0 ? void 0 : _107.variables)
            ? `
          (
            
    ${fields.posts.variables.after
                ? `
      after: ${fields.posts.variables.after}
    `
                : ``}
  

    ${fields.posts.variables.before
                ? `
      before: ${fields.posts.variables.before}
    `
                : ``}
  

    ${fields.posts.variables.excludePins
                ? `
      excludePins: ${fields.posts.variables.excludePins}
    `
                : ``}
  

    ${fields.posts.variables.filterBy
                ? `
      filterBy: ${fields.posts.variables.filterBy}
    `
                : ``}
  

    ${fields.posts.variables.limit
                ? `
      limit: ${fields.posts.variables.limit}
    `
                : ``}
  

    ${fields.posts.variables.offset
                ? `
      offset: ${fields.posts.variables.offset}
    `
                : ``}
  

    ${fields.posts.variables.orderBy
                ? `
      orderBy: ${fields.posts.variables.orderBy}
    `
                : ``}
  

    ${fields.posts.variables.orderByString
                ? `
      orderByString: ${fields.posts.variables.orderByString}
    `
                : ``}
  

    ${fields.posts.variables.postTypeIds
                ? `
      postTypeIds: ${fields.posts.variables.postTypeIds}
    `
                : ``}
  

    ${fields.posts.variables.reverse
                ? `
      reverse: ${fields.posts.variables.reverse}
    `
                : ``}
  

    ${fields.posts.variables.spaceIds
                ? `
      spaceIds: ${fields.posts.variables.spaceIds}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.posts.fields)}
        }
      `
        : ``}
    

      ${fields.postsByIds
        ? `
        postsByIds
        ${((_108 = fields.postsByIds) === null || _108 === void 0 ? void 0 : _108.variables)
            ? `
          (
            
    ${fields.postsByIds.variables.ids
                ? `
      ids: ${fields.postsByIds.variables.ids}
    `
                : ``}
  

    ${fields.postsByIds.variables.statuses
                ? `
      statuses: ${fields.postsByIds.variables.statuses}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.postsByIds.fields)}
        }
      `
        : ``}
    

      ${fields.privateMessage
        ? `
        privateMessage
        ${((_109 = fields.privateMessage) === null || _109 === void 0 ? void 0 : _109.variables)
            ? `
          (
            
    ${fields.privateMessage.variables.input
                ? `
      input: ${fields.privateMessage.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.privateMessage.fields)}
        }
      `
        : ``}
    

    ${fields.products
        ? `
      products {
        ${ProductGQLFields(fields.products)}
      }
    `
        : ``}
  

      ${fields.redirect
        ? `
        redirect
        ${((_110 = fields.redirect) === null || _110 === void 0 ? void 0 : _110.variables)
            ? `
          (
            
    ${fields.redirect.variables.url
                ? `
      url: ${fields.redirect.variables.url}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${RedirectGQLFields(fields.redirect.fields)}
        }
      `
        : ``}
    

      ${fields.replies
        ? `
        replies
        ${((_111 = fields.replies) === null || _111 === void 0 ? void 0 : _111.variables)
            ? `
          (
            
    ${fields.replies.variables.after
                ? `
      after: ${fields.replies.variables.after}
    `
                : ``}
  

    ${fields.replies.variables.before
                ? `
      before: ${fields.replies.variables.before}
    `
                : ``}
  

    ${fields.replies.variables.excludePins
                ? `
      excludePins: ${fields.replies.variables.excludePins}
    `
                : ``}
  

    ${fields.replies.variables.limit
                ? `
      limit: ${fields.replies.variables.limit}
    `
                : ``}
  

    ${fields.replies.variables.offset
                ? `
      offset: ${fields.replies.variables.offset}
    `
                : ``}
  

    ${fields.replies.variables.orderBy
                ? `
      orderBy: ${fields.replies.variables.orderBy}
    `
                : ``}
  

    ${fields.replies.variables.postId
                ? `
      postId: ${fields.replies.variables.postId}
    `
                : ``}
  

    ${fields.replies.variables.reverse
                ? `
      reverse: ${fields.replies.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.replies.fields)}
        }
      `
        : ``}
    

      ${fields.report
        ? `
        report
        ${((_112 = fields.report) === null || _112 === void 0 ? void 0 : _112.variables)
            ? `
          (
            
    ${fields.report.variables.input
                ? `
      input: ${fields.report.variables.input}
    `
                : ``}
  

    ${fields.report.variables.spaceId
                ? `
      spaceId: ${fields.report.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ReportGQLFields(fields.report.fields)}
        }
      `
        : ``}
    

      ${fields.roles
        ? `
        roles
        ${((_113 = fields.roles) === null || _113 === void 0 ? void 0 : _113.variables)
            ? `
          (
            
    ${fields.roles.variables.orderBy
                ? `
      orderBy: ${fields.roles.variables.orderBy}
    `
                : ``}
  

    ${fields.roles.variables.reverse
                ? `
      reverse: ${fields.roles.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${RoleGQLFields(fields.roles.fields)}
        }
      `
        : ``}
    

      ${fields.scopes
        ? `
        scopes
        ${((_114 = fields.scopes) === null || _114 === void 0 ? void 0 : _114.variables)
            ? `
          (
            
    ${fields.scopes.variables.contexts
                ? `
      contexts: ${fields.scopes.variables.contexts}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${ScopesGQLFields(fields.scopes.fields)}
        }
      `
        : ``}
    

      ${fields.search
        ? `
        search
        ${((_115 = fields.search) === null || _115 === void 0 ? void 0 : _115.variables)
            ? `
          (
            
    ${fields.search.variables.input
                ? `
      input: ${fields.search.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SearchResultGQLFields(fields.search.fields)}
        }
      `
        : ``}
    

      ${fields.space
        ? `
        space
        ${((_116 = fields.space) === null || _116 === void 0 ? void 0 : _116.variables)
            ? `
          (
            
    ${fields.space.variables.id
                ? `
      id: ${fields.space.variables.id}
    `
                : ``}
  

    ${fields.space.variables.path
                ? `
      path: ${fields.space.variables.path}
    `
                : ``}
  

    ${fields.space.variables.slug
                ? `
      slug: ${fields.space.variables.slug}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.space.fields)}
        }
      `
        : ``}
    

      ${fields.spaceDefaultNotificationSettings
        ? `
        spaceDefaultNotificationSettings
        ${((_117 = fields.spaceDefaultNotificationSettings) === null || _117 === void 0 ? void 0 : _117.variables)
            ? `
          (
            
    ${fields.spaceDefaultNotificationSettings.variables.spaceId
                ? `
      spaceId: ${fields.spaceDefaultNotificationSettings.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceDefaultNotificationSettingsGQLFields(fields.spaceDefaultNotificationSettings.fields)}
        }
      `
        : ``}
    

      ${fields.spaceMember
        ? `
        spaceMember
        ${((_118 = fields.spaceMember) === null || _118 === void 0 ? void 0 : _118.variables)
            ? `
          (
            
    ${fields.spaceMember.variables.memberId
                ? `
      memberId: ${fields.spaceMember.variables.memberId}
    `
                : ``}
  

    ${fields.spaceMember.variables.spaceId
                ? `
      spaceId: ${fields.spaceMember.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceMemberGQLFields(fields.spaceMember.fields)}
        }
      `
        : ``}
    

      ${fields.spaceMembers
        ? `
        spaceMembers
        ${((_119 = fields.spaceMembers) === null || _119 === void 0 ? void 0 : _119.variables)
            ? `
          (
            
    ${fields.spaceMembers.variables.after
                ? `
      after: ${fields.spaceMembers.variables.after}
    `
                : ``}
  

    ${fields.spaceMembers.variables.before
                ? `
      before: ${fields.spaceMembers.variables.before}
    `
                : ``}
  

    ${fields.spaceMembers.variables.limit
                ? `
      limit: ${fields.spaceMembers.variables.limit}
    `
                : ``}
  

    ${fields.spaceMembers.variables.offset
                ? `
      offset: ${fields.spaceMembers.variables.offset}
    `
                : ``}
  

    ${fields.spaceMembers.variables.orderBy
                ? `
      orderBy: ${fields.spaceMembers.variables.orderBy}
    `
                : ``}
  

    ${fields.spaceMembers.variables.reverse
                ? `
      reverse: ${fields.spaceMembers.variables.reverse}
    `
                : ``}
  

    ${fields.spaceMembers.variables.roleIds
                ? `
      roleIds: ${fields.spaceMembers.variables.roleIds}
    `
                : ``}
  

    ${fields.spaceMembers.variables.spaceId
                ? `
      spaceId: ${fields.spaceMembers.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceMemberGQLFields(fields.spaceMembers.fields)}
        }
      `
        : ``}
    

      ${fields.spaceMembershipRequests
        ? `
        spaceMembershipRequests
        ${((_120 = fields.spaceMembershipRequests) === null || _120 === void 0 ? void 0 : _120.variables)
            ? `
          (
            
    ${fields.spaceMembershipRequests.variables.spaceId
                ? `
      spaceId: ${fields.spaceMembershipRequests.variables.spaceId}
    `
                : ``}
  

    ${fields.spaceMembershipRequests.variables.status
                ? `
      status: ${fields.spaceMembershipRequests.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceJoinRequestGQLFields(fields.spaceMembershipRequests.fields)}
        }
      `
        : ``}
    

      ${fields.spacePinnedPosts
        ? `
        spacePinnedPosts
        ${((_121 = fields.spacePinnedPosts) === null || _121 === void 0 ? void 0 : _121.variables)
            ? `
          (
            
    ${fields.spacePinnedPosts.variables.spaceId
                ? `
      spaceId: ${fields.spacePinnedPosts.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PostGQLFields(fields.spacePinnedPosts.fields)}
        }
      `
        : ``}
    

      ${fields.spacePostType
        ? `
        spacePostType
        ${((_122 = fields.spacePostType) === null || _122 === void 0 ? void 0 : _122.variables)
            ? `
          (
            
    ${fields.spacePostType.variables.postTypeId
                ? `
      postTypeId: ${fields.spacePostType.variables.postTypeId}
    `
                : ``}
  

    ${fields.spacePostType.variables.spaceId
                ? `
      spaceId: ${fields.spacePostType.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpacePostTypeGQLFields(fields.spacePostType.fields)}
        }
      `
        : ``}
    

      ${fields.spacePostTypes
        ? `
        spacePostTypes
        ${((_123 = fields.spacePostTypes) === null || _123 === void 0 ? void 0 : _123.variables)
            ? `
          (
            
    ${fields.spacePostTypes.variables.after
                ? `
      after: ${fields.spacePostTypes.variables.after}
    `
                : ``}
  

    ${fields.spacePostTypes.variables.before
                ? `
      before: ${fields.spacePostTypes.variables.before}
    `
                : ``}
  

    ${fields.spacePostTypes.variables.context
                ? `
      context: ${fields.spacePostTypes.variables.context}
    `
                : ``}
  

    ${fields.spacePostTypes.variables.limit
                ? `
      limit: ${fields.spacePostTypes.variables.limit}
    `
                : ``}
  

    ${fields.spacePostTypes.variables.offset
                ? `
      offset: ${fields.spacePostTypes.variables.offset}
    `
                : ``}
  

    ${fields.spacePostTypes.variables.reverse
                ? `
      reverse: ${fields.spacePostTypes.variables.reverse}
    `
                : ``}
  

    ${fields.spacePostTypes.variables.spaceId
                ? `
      spaceId: ${fields.spacePostTypes.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpacePostTypeGQLFields(fields.spacePostTypes.fields)}
        }
      `
        : ``}
    

      ${fields.spaceRoles
        ? `
        spaceRoles
        ${((_124 = fields.spaceRoles) === null || _124 === void 0 ? void 0 : _124.variables)
            ? `
          (
            
    ${fields.spaceRoles.variables.orderBy
                ? `
      orderBy: ${fields.spaceRoles.variables.orderBy}
    `
                : ``}
  

    ${fields.spaceRoles.variables.reverse
                ? `
      reverse: ${fields.spaceRoles.variables.reverse}
    `
                : ``}
  

    ${fields.spaceRoles.variables.spaceId
                ? `
      spaceId: ${fields.spaceRoles.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceRoleGQLFields(fields.spaceRoles.fields)}
        }
      `
        : ``}
    

      ${fields.spaces
        ? `
        spaces
        ${((_125 = fields.spaces) === null || _125 === void 0 ? void 0 : _125.variables)
            ? `
          (
            
    ${fields.spaces.variables.after
                ? `
      after: ${fields.spaces.variables.after}
    `
                : ``}
  

    ${fields.spaces.variables.before
                ? `
      before: ${fields.spaces.variables.before}
    `
                : ``}
  

    ${fields.spaces.variables.collectionId
                ? `
      collectionId: ${fields.spaces.variables.collectionId}
    `
                : ``}
  

    ${fields.spaces.variables.limit
                ? `
      limit: ${fields.spaces.variables.limit}
    `
                : ``}
  

    ${fields.spaces.variables.memberId
                ? `
      memberId: ${fields.spaces.variables.memberId}
    `
                : ``}
  

    ${fields.spaces.variables.offset
                ? `
      offset: ${fields.spaces.variables.offset}
    `
                : ``}
  

    ${fields.spaces.variables.orderBy
                ? `
      orderBy: ${fields.spaces.variables.orderBy}
    `
                : ``}
  

    ${fields.spaces.variables.query
                ? `
      query: ${fields.spaces.variables.query}
    `
                : ``}
  

    ${fields.spaces.variables.reverse
                ? `
      reverse: ${fields.spaces.variables.reverse}
    `
                : ``}
  

    ${fields.spaces.variables.type
                ? `
      type: ${fields.spaces.variables.type}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceGQLFields(fields.spaces.fields)}
        }
      `
        : ``}
    

      ${fields.spacesByIds
        ? `
        spacesByIds
        ${((_126 = fields.spacesByIds) === null || _126 === void 0 ? void 0 : _126.variables)
            ? `
          (
            
    ${fields.spacesByIds.variables.ids
                ? `
      ids: ${fields.spacesByIds.variables.ids}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.spacesByIds.fields)}
        }
      `
        : ``}
    

      ${fields.spacesBySlugs
        ? `
        spacesBySlugs
        ${((_127 = fields.spacesBySlugs) === null || _127 === void 0 ? void 0 : _127.variables)
            ? `
          (
            
    ${fields.spacesBySlugs.variables.slugs
                ? `
      slugs: ${fields.spacesBySlugs.variables.slugs}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SpaceGQLFields(fields.spacesBySlugs.fields)}
        }
      `
        : ``}
    

      ${fields.ssoMemberships
        ? `
        ssoMemberships
        ${((_128 = fields.ssoMemberships) === null || _128 === void 0 ? void 0 : _128.variables)
            ? `
          (
            
    ${fields.ssoMemberships.variables.memberId
                ? `
      memberId: ${fields.ssoMemberships.variables.memberId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SsoMembershipGQLFields(fields.ssoMemberships.fields)}
        }
      `
        : ``}
    

      ${fields.ssoUrl
        ? `
        ssoUrl
        ${((_129 = fields.ssoUrl) === null || _129 === void 0 ? void 0 : _129.variables)
            ? `
          (
            
    ${fields.ssoUrl.variables.input
                ? `
      input: ${fields.ssoUrl.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SsoUrlGQLFields(fields.ssoUrl.fields)}
        }
      `
        : ``}
    

      ${fields.ssos
        ? `
        ssos
        ${((_130 = fields.ssos) === null || _130 === void 0 ? void 0 : _130.variables)
            ? `
          (
            
    ${fields.ssos.variables.status
                ? `
      status: ${fields.ssos.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SsoGQLFields(fields.ssos.fields)}
        }
      `
        : ``}
    

      ${fields.subscription
        ? `
        subscription
        ${((_131 = fields.subscription) === null || _131 === void 0 ? void 0 : _131.variables)
            ? `
          (
            
    ${fields.subscription.variables.input
                ? `
      input: ${fields.subscription.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SubscriptionGQLFields(fields.subscription.fields)}
        }
      `
        : ``}
    

      ${fields.supportNetworkTokens
        ? `
        supportNetworkTokens
        ${((_132 = fields.supportNetworkTokens) === null || _132 === void 0 ? void 0 : _132.variables)
            ? `
          (
            
    ${fields.supportNetworkTokens.variables.networkId
                ? `
      networkId: ${fields.supportNetworkTokens.variables.networkId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SupportLimitedAuthTokenGQLFields(fields.supportNetworkTokens.fields)}
        }
      `
        : ``}
    

      ${fields.supportSsoUrl
        ? `
        supportSsoUrl
        ${((_133 = fields.supportSsoUrl) === null || _133 === void 0 ? void 0 : _133.variables)
            ? `
          (
            
    ${fields.supportSsoUrl.variables.input
                ? `
      input: ${fields.supportSsoUrl.variables.input}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${SupportSsoUrlGQLFields(fields.supportSsoUrl.fields)}
        }
      `
        : ``}
    

    ${fields.systemSpaces
        ? `
      systemSpaces {
        ${SpaceGQLFields(fields.systemSpaces)}
      }
    `
        : ``}
  

      ${fields.tagPosts
        ? `
        tagPosts
        ${((_134 = fields.tagPosts) === null || _134 === void 0 ? void 0 : _134.variables)
            ? `
          (
            
    ${fields.tagPosts.variables.after
                ? `
      after: ${fields.tagPosts.variables.after}
    `
                : ``}
  

    ${fields.tagPosts.variables.before
                ? `
      before: ${fields.tagPosts.variables.before}
    `
                : ``}
  

    ${fields.tagPosts.variables.limit
                ? `
      limit: ${fields.tagPosts.variables.limit}
    `
                : ``}
  

    ${fields.tagPosts.variables.offset
                ? `
      offset: ${fields.tagPosts.variables.offset}
    `
                : ``}
  

    ${fields.tagPosts.variables.reverse
                ? `
      reverse: ${fields.tagPosts.variables.reverse}
    `
                : ``}
  

    ${fields.tagPosts.variables.spaceId
                ? `
      spaceId: ${fields.tagPosts.variables.spaceId}
    `
                : ``}
  

    ${fields.tagPosts.variables.tagId
                ? `
      tagId: ${fields.tagPosts.variables.tagId}
    `
                : ``}
  

    ${fields.tagPosts.variables.tagSlug
                ? `
      tagSlug: ${fields.tagPosts.variables.tagSlug}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.tagPosts.fields)}
        }
      `
        : ``}
    

      ${fields.tags
        ? `
        tags
        ${((_135 = fields.tags) === null || _135 === void 0 ? void 0 : _135.variables)
            ? `
          (
            
    ${fields.tags.variables.after
                ? `
      after: ${fields.tags.variables.after}
    `
                : ``}
  

    ${fields.tags.variables.before
                ? `
      before: ${fields.tags.variables.before}
    `
                : ``}
  

    ${fields.tags.variables.ids
                ? `
      ids: ${fields.tags.variables.ids}
    `
                : ``}
  

    ${fields.tags.variables.limit
                ? `
      limit: ${fields.tags.variables.limit}
    `
                : ``}
  

    ${fields.tags.variables.offset
                ? `
      offset: ${fields.tags.variables.offset}
    `
                : ``}
  

    ${fields.tags.variables.orderBy
                ? `
      orderBy: ${fields.tags.variables.orderBy}
    `
                : ``}
  

    ${fields.tags.variables.query
                ? `
      query: ${fields.tags.variables.query}
    `
                : ``}
  

    ${fields.tags.variables.reverse
                ? `
      reverse: ${fields.tags.variables.reverse}
    `
                : ``}
  

    ${fields.tags.variables.spaceId
                ? `
      spaceId: ${fields.tags.variables.spaceId}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedTagGQLFields(fields.tags.fields)}
        }
      `
        : ``}
    

      ${fields.templateRequest
        ? `
        templateRequest
        ${((_136 = fields.templateRequest) === null || _136 === void 0 ? void 0 : _136.variables)
            ? `
          (
            
    ${fields.templateRequest.variables.id
                ? `
      id: ${fields.templateRequest.variables.id}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${TemplateRequestGQLFields(fields.templateRequest.fields)}
        }
      `
        : ``}
    

      ${fields.templates
        ? `
        templates
        ${((_137 = fields.templates) === null || _137 === void 0 ? void 0 : _137.variables)
            ? `
          (
            
    ${fields.templates.variables.after
                ? `
      after: ${fields.templates.variables.after}
    `
                : ``}
  

    ${fields.templates.variables.before
                ? `
      before: ${fields.templates.variables.before}
    `
                : ``}
  

    ${fields.templates.variables.entityTypes
                ? `
      entityTypes: ${fields.templates.variables.entityTypes}
    `
                : ``}
  

    ${fields.templates.variables.limit
                ? `
      limit: ${fields.templates.variables.limit}
    `
                : ``}
  

    ${fields.templates.variables.offset
                ? `
      offset: ${fields.templates.variables.offset}
    `
                : ``}
  

    ${fields.templates.variables.reverse
                ? `
      reverse: ${fields.templates.variables.reverse}
    `
                : ``}
  

    ${fields.templates.variables.status
                ? `
      status: ${fields.templates.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedTemplateGQLFields(fields.templates.fields)}
        }
      `
        : ``}
    

      ${fields.tokens
        ? `
        tokens
        ${((_138 = fields.tokens) === null || _138 === void 0 ? void 0 : _138.variables)
            ? `
          (
            
    ${fields.tokens.variables.networkDomain
                ? `
      networkDomain: ${fields.tokens.variables.networkDomain}
    `
                : ``}
  

    ${fields.tokens.variables.networkId
                ? `
      networkId: ${fields.tokens.variables.networkId}
    `
                : ``}
  

    ${fields.tokens.variables.otp
                ? `
      otp: ${fields.tokens.variables.otp}
    `
                : ``}
  

    ${fields.tokens.variables.refreshToken
                ? `
      refreshToken: ${fields.tokens.variables.refreshToken}
    `
                : ``}
  

    ${fields.tokens.variables.ssoToken
                ? `
      ssoToken: ${fields.tokens.variables.ssoToken}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${AuthTokenGQLFields(fields.tokens.fields)}
        }
      `
        : ``}
    
translateMarkup
        ${((_139 = fields.translateMarkup) === null || _139 === void 0 ? void 0 : _139.variables)
        ? `
          (
            
    ${fields.translateMarkup.variables.format
            ? `
      format: ${fields.translateMarkup.variables.format}
    `
            : ``}
  

    ${fields.translateMarkup.variables.input
            ? `
      input: ${fields.translateMarkup.variables.input}
    `
            : ``}
  

    ${fields.translateMarkup.variables.markups
            ? `
      markups: ${fields.translateMarkup.variables.markups}
    `
            : ``}
  
          )
        `
        : ``}
      

      ${fields.usernameAvailability
        ? `
        usernameAvailability
        ${((_140 = fields.usernameAvailability) === null || _140 === void 0 ? void 0 : _140.variables)
            ? `
          (
            
    ${fields.usernameAvailability.variables.username
                ? `
      username: ${fields.usernameAvailability.variables.username}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${UsernameAvailabilityGQLFields(fields.usernameAvailability.fields)}
        }
      `
        : ``}
    

    ${fields.vatTypes
        ? `
      vatTypes {
        ${VatTypeInfoGQLFields(fields.vatTypes)}
      }
    `
        : ``}
  
      `;
};
export const RedirectGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        resolvedUrl
url
      `;
};
export const ReportGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            data: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.data
        ? `
      data {
        ${ReportDataGQLFields(fields.data)}
      }
    `
        : ``}
  
description
endDate
previousValue
slug
startDate
title
tooltip
value
      `;
};
export const ReportDataGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            previousValue: 'basic',
            value: 'basic',
        };
    }
    return `
        __typename
        description
key

    ${fields.previousValue
        ? `
      previousValue {
        ${ReportDataValueGQLFields(fields.previousValue)}
      }
    `
        : ``}
  
type

    ${fields.value
        ? `
      value {
        ${ReportDataValueGQLFields(fields.value)}
      }
    `
        : ``}
  
      `;
};
export const ReportDataValueGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onChartData: 'basic',
            onEntityReport: 'basic',
            onIntValue: 'basic',
            onStringValue: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onChartData
        ? `
            ... on ChartData {
              ${ChartDataGQLFields(fields.onChartData)}
            }
          `
        : ``}
        

          ${fields.onEntityReport
        ? `
            ... on EntityReport {
              ${EntityReportGQLFields(fields.onEntityReport)}
            }
          `
        : ``}
        

          ${fields.onIntValue
        ? `
            ... on IntValue {
              ${IntValueGQLFields(fields.onIntValue)}
            }
          `
        : ``}
        

          ${fields.onStringValue
        ? `
            ... on StringValue {
              ${StringValueGQLFields(fields.onStringValue)}
            }
          `
        : ``}
        
      `;
};
export const ReportEntitiesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            actor: 'basic',
            app: 'basic',
            member: 'basic',
            network: 'basic',
            person: 'basic',
            post: 'basic',
            space: 'basic',
            tag: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.actor
        ? `
      actor {
        ${MemberGQLFields(fields.actor)}
      }
    `
        : ``}
  

    ${fields.app
        ? `
      app {
        ${AppGQLFields(fields.app)}
      }
    `
        : ``}
  

    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  

    ${fields.person
        ? `
      person {
        ${MemberGQLFields(fields.person)}
      }
    `
        : ``}
  

    ${fields.post
        ? `
      post {
        ${PostGQLFields(fields.post)}
      }
    `
        : ``}
  

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  

    ${fields.tag
        ? `
      tag {
        ${TagGQLFields(fields.tag)}
      }
    `
        : ``}
  
      `;
};
export const ReportPayloadGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
value
      `;
};
export const ReportRecordGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            entities: 'basic',
            payload: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.entities
        ? `
      entities {
        ${ReportEntitiesGQLFields(fields.entities)}
      }
    `
        : ``}
  

    ${fields.payload
        ? `
      payload {
        ${ReportPayloadGQLFields(fields.payload)}
      }
    `
        : ``}
  
      `;
};
export const ReportableEntityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onMember: 'basic',
            onPost: 'basic',
            onSpace: 'basic',
            onTag: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onMember
        ? `
            ... on Member {
              ${MemberGQLFields(fields.onMember)}
            }
          `
        : ``}
        

          ${fields.onPost
        ? `
            ... on Post {
              ${PostGQLFields(fields.onPost)}
            }
          `
        : ``}
        

          ${fields.onSpace
        ? `
            ... on Space {
              ${SpaceGQLFields(fields.onSpace)}
            }
          `
        : ``}
        

          ${fields.onTag
        ? `
            ... on Tag {
              ${TagGQLFields(fields.onTag)}
            }
          `
        : ``}
        
      `;
};
export const RoleGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        description
id
name
scopes
type
visible
      `;
};
export const ScopesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            contextAwareScopes: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.contextAwareScopes
        ? `
      contextAwareScopes {
        ${ContextScopesGQLFields(fields.contextAwareScopes)}
      }
    `
        : ``}
  
scopes
      `;
};
export const SearchEntityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            by: 'basic',
            in: 'basic',
            media: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.by
        ? `
      by {
        ${ByGQLFields(fields.by)}
      }
    `
        : ``}
  
content
created
entityId
entityType
id

    ${fields.in
        ? `
      in {
        ${InGQLFields(fields.in)}
      }
    `
        : ``}
  

    ${fields.media
        ? `
      media {
        ${MediaGQLFields(fields.media)}
      }
    `
        : ``}
  
subtitle
tags
title
url
      `;
};
export const SearchEntityGroupGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            hits: 'basic',
        };
    }
    return `
        __typename
        entityType

    ${fields.hits
        ? `
      hits {
        ${SearchEntityGQLFields(fields.hits)}
      }
    `
        : ``}
  
      `;
};
export const SearchResultGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            hits: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.hits
        ? `
      hits {
        ${SearchEntityGroupGQLFields(fields.hits)}
      }
    `
        : ``}
  
totalCount
      `;
};
export const SettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            contentTranslation: 'basic',
            memberPermissions: 'basic',
            privateMessaging: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.contentTranslation
        ? `
      contentTranslation {
        ${ContentTranslationSettingsGQLFields(fields.contentTranslation)}
      }
    `
        : ``}
  
emailEnabled
emailFrom
emailNotificationEnabled
fileSizeLimit
fileTypesLimit
imageSizeLimit
imageTypesLimit

    ${fields.memberPermissions
        ? `
      memberPermissions {
        ${MembersPermissionSettingsGQLFields(fields.memberPermissions)}
      }
    `
        : ``}
  
membersCanTurnOffPrivateMessaging
membersCanUsePrivateMessaging

    ${fields.privateMessaging
        ? `
      privateMessaging {
        ${PrivateMessagingSettingsGQLFields(fields.privateMessaging)}
      }
    `
        : ``}
  
privateMessagingEnabled
      `;
};
export const ShortcutGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            app: 'basic',
            favicon: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.app
        ? `
      app {
        ${AppGQLFields(fields.app)}
      }
    `
        : ``}
  
appId
description

    ${fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``}
  
faviconId
key
name
      `;
};
export const SignedUrlGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            urls: 'basic',
        };
    }
    return `
        __typename
        fields
mediaDownloadUrl
mediaId
mediaUrl
signedUrl

    ${fields.urls
        ? `
      urls {
        ${MediaUrlsGQLFields(fields.urls)}
      }
    `
        : ``}
  
      `;
};
export const SlateGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            blocks: 'basic',
            restrictions: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.blocks
        ? `
      blocks {
        ${BlockGQLFields(fields.blocks)}
      }
    `
        : ``}
  
id

    ${fields.restrictions
        ? `
      restrictions {
        ${SlateRestrictionsGQLFields(fields.restrictions)}
      }
    `
        : ``}
  
rootBlock
      `;
};
export const SlateRestrictionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        lockedChildrenBlocks
nonEditableBlocks
nonRemovableBlocks
      `;
};
export const SpaceGQLFields = (fields) => {
    var _a, _b, _c, _d;
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            address: 'basic',
            authMemberProps: 'basic',
            banner: 'basic',
            collection: 'basic',
            createdBy: 'basic',
            customSeoDetail: 'basic',
            highlightedTags: 'basic',
            image: 'basic',
            network: 'basic',
            pinnedPosts: 'basic',
            roles: 'basic',
            seoDetail: 'basic',
            shortcuts: 'basic',
            slate: 'basic',
            tagFilter: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.address
        ? `
      address {
        ${SpaceAddressGQLFields(fields.address)}
      }
    `
        : ``}
  

    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${SpaceAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
  

    ${fields.banner
        ? `
      banner {
        ${MediaGQLFields(fields.banner)}
      }
    `
        : ``}
  
bannerId

    ${fields.collection
        ? `
      collection {
        ${CollectionGQLFields(fields.collection)}
      }
    `
        : ``}
  
createdAt

    ${fields.createdBy
        ? `
      createdBy {
        ${MemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
  
createdById
customOrderingIndexInGroup

    ${fields.customSeoDetail
        ? `
      customSeoDetail {
        ${CustomSeoDetailGQLFields(fields.customSeoDetail)}
      }
    `
        : ``}
  
description
groupId
hidden
highlightedTagIds

    ${fields.highlightedTags
        ? `
      highlightedTags {
        ${HighlightedTagGQLFields(fields.highlightedTags)}
      }
    `
        : ``}
  
id

    ${fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``}
  
imageId

      ${fields.installedApps
        ? `
        installedApps
        ${((_a = fields.installedApps) === null || _a === void 0 ? void 0 : _a.variables)
            ? `
          (
            
    ${fields.installedApps.variables.after
                ? `
      after: ${fields.installedApps.variables.after}
    `
                : ``}
  

    ${fields.installedApps.variables.before
                ? `
      before: ${fields.installedApps.variables.before}
    `
                : ``}
  

    ${fields.installedApps.variables.limit
                ? `
      limit: ${fields.installedApps.variables.limit}
    `
                : ``}
  

    ${fields.installedApps.variables.offset
                ? `
      offset: ${fields.installedApps.variables.offset}
    `
                : ``}
  

    ${fields.installedApps.variables.reverse
                ? `
      reverse: ${fields.installedApps.variables.reverse}
    `
                : ``}
  

    ${fields.installedApps.variables.status
                ? `
      status: ${fields.installedApps.variables.status}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedAppInstallationGQLFields(fields.installedApps.fields)}
        }
      `
        : ``}
    
inviteOnly
layout

      ${fields.members
        ? `
        members
        ${((_b = fields.members) === null || _b === void 0 ? void 0 : _b.variables)
            ? `
          (
            
    ${fields.members.variables.limit
                ? `
      limit: ${fields.members.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedSpaceMemberGQLFields(fields.members.fields)}
        }
      `
        : ``}
    
membersCount
name

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
networkId
nonAdminsCanInvite

    ${fields.pinnedPosts
        ? `
      pinnedPosts {
        ${PostGQLFields(fields.pinnedPosts)}
      }
    `
        : ``}
  

      ${fields.posts
        ? `
        posts
        ${((_c = fields.posts) === null || _c === void 0 ? void 0 : _c.variables)
            ? `
          (
            
    ${fields.posts.variables.excludePins
                ? `
      excludePins: ${fields.posts.variables.excludePins}
    `
                : ``}
  

    ${fields.posts.variables.limit
                ? `
      limit: ${fields.posts.variables.limit}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedPostGQLFields(fields.posts.fields)}
        }
      `
        : ``}
    
postsCount
private
relativeUrl

    ${fields.roles
        ? `
      roles {
        ${SpaceRoleGQLFields(fields.roles)}
      }
    `
        : ``}
  

    ${fields.seoDetail
        ? `
      seoDetail {
        ${SpaceSeoDetailGQLFields(fields.seoDetail)}
      }
    `
        : ``}
  

    ${fields.shortcuts
        ? `
      shortcuts {
        ${ShortcutGQLFields(fields.shortcuts)}
      }
    `
        : ``}
  

    ${fields.slate
        ? `
      slate {
        ${SlateGQLFields(fields.slate)}
      }
    `
        : ``}
  
slug

    ${fields.tagFilter
        ? `
      tagFilter {
        ${TagFilterGQLFields(fields.tagFilter)}
      }
    `
        : ``}
  

      ${fields.tags
        ? `
        tags
        ${((_d = fields.tags) === null || _d === void 0 ? void 0 : _d.variables)
            ? `
          (
            
    ${fields.tags.variables.after
                ? `
      after: ${fields.tags.variables.after}
    `
                : ``}
  

    ${fields.tags.variables.before
                ? `
      before: ${fields.tags.variables.before}
    `
                : ``}
  

    ${fields.tags.variables.limit
                ? `
      limit: ${fields.tags.variables.limit}
    `
                : ``}
  

    ${fields.tags.variables.offset
                ? `
      offset: ${fields.tags.variables.offset}
    `
                : ``}
  

    ${fields.tags.variables.orderBy
                ? `
      orderBy: ${fields.tags.variables.orderBy}
    `
                : ``}
  

    ${fields.tags.variables.query
                ? `
      query: ${fields.tags.variables.query}
    `
                : ``}
  

    ${fields.tags.variables.reverse
                ? `
      reverse: ${fields.tags.variables.reverse}
    `
                : ``}
  
          )
        `
            : ``}
       {
          ${PaginatedTagGQLFields(fields.tags.fields)}
        }
      `
        : ``}
    
type
url
whoCanPost
whoCanReact
whoCanReply
      `;
};
export const SpaceAddressGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        editable
exact
path
      `;
};
export const SpaceAuthMemberPropsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            availablePostTypes: 'basic',
            permissions: 'basic',
            spaceMember: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.availablePostTypes
        ? `
      availablePostTypes {
        ${PostTypeGQLFields(fields.availablePostTypes)}
      }
    `
        : ``}
  
context
lastReadAt
membershipStatus

    ${fields.permissions
        ? `
      permissions {
        ${ActionPermissionsGQLFields(fields.permissions)}
      }
    `
        : ``}
  
scopes

    ${fields.spaceMember
        ? `
      spaceMember {
        ${SpaceMemberGQLFields(fields.spaceMember)}
      }
    `
        : ``}
  
unreadPostsCount
      `;
};
export const SpaceDefaultNotificationSettingsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        channel
enabled
isDefault
preference
sameAsDefault
      `;
};
export const SpaceEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${SpaceGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const SpaceJoinRequestGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
        };
    }
    return `
        __typename
        id

    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  
spaceId
status
      `;
};
export const SpaceMemberGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
            role: 'basic',
            space: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  

    ${fields.role
        ? `
      role {
        ${SpaceRoleGQLFields(fields.role)}
      }
    `
        : ``}
  

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  
      `;
};
export const SpaceMemberEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${SpaceMemberGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const SpacePostTypeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            postType: 'basic',
            space: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.postType
        ? `
      postType {
        ${PostTypeGQLFields(fields.postType)}
      }
    `
        : ``}
  
postTypeId

    ${fields.space
        ? `
      space {
        ${SpaceGQLFields(fields.space)}
      }
    `
        : ``}
  
spaceId
whoCanPost
whoCanReact
whoCanReply
      `;
};
export const SpacePostTypeEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${SpacePostTypeGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const SpaceRoleGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            network: 'basic',
        };
    }
    return `
        __typename
        description
id
name

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
scopes
type
      `;
};
export const SpaceSeoDetailGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            image: 'basic',
        };
    }
    return `
        __typename
        description

    ${fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``}
  
title
      `;
};
export const SsoGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        allowSignUp
authorizationUrl
buttonText
clientId
clientSecret
defaultRelayState
idpUrl
logoutUrl
name
provider
scopes
settingsUrl
signUpUrl
status
tokenUrl
type
userProfileUrl
      `;
};
export const SsoMembershipGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        id
memberId
ssoType
      `;
};
export const SsoUrlGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        url
      `;
};
export const StatusReasonGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        changedAt
changedBy
changedById
reason
      `;
};
export const StringValueGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        string
      `;
};
export const SubscriptionGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        createdAt
id
status
updatedAt
      `;
};
export const SupportAuthTokenGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        accessToken
refreshToken
      `;
};
export const SupportLimitedAuthTokenGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            member: 'basic',
        };
    }
    return `
        __typename
        accessToken

    ${fields.member
        ? `
      member {
        ${MemberGQLFields(fields.member)}
      }
    `
        : ``}
  
      `;
};
export const SupportSsoUrlGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        url
      `;
};
export const TagGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        description
id
slug
spaceId
title
      `;
};
export const TagEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${TagGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const TagFilterGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        filterType
filters
      `;
};
export const TemplateGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            apps: 'basic',
            banner: 'basic',
            contentTypes: 'basic',
            createdBy: 'basic',
            embeds: 'basic',
            favicon: 'basic',
            image: 'basic',
            images: 'basic',
            network: 'basic',
            requiredTemplates: 'basic',
            slate: 'basic',
            updatedBy: 'basic',
        };
    }
    return `
        __typename
        about
appIds

    ${fields.apps
        ? `
      apps {
        ${AppGQLFields(fields.apps)}
      }
    `
        : ``}
  
authorName
authorUrl

    ${fields.banner
        ? `
      banner {
        ${MediaGQLFields(fields.banner)}
      }
    `
        : ``}
  
bannerId
categories
comingSoon

    ${fields.contentTypes
        ? `
      contentTypes {
        ${ContentTypeTemplateGQLFields(fields.contentTypes)}
      }
    `
        : ``}
  
createdAt

    ${fields.createdBy
        ? `
      createdBy {
        ${MemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
  
createdById
description
embedIds

    ${fields.embeds
        ? `
      embeds {
        ${EmbedGQLFields(fields.embeds)}
      }
    `
        : ``}
  
entityProperties
entityType

    ${fields.favicon
        ? `
      favicon {
        ${MediaGQLFields(fields.favicon)}
      }
    `
        : ``}
  
faviconId
id

    ${fields.image
        ? `
      image {
        ${MediaGQLFields(fields.image)}
      }
    `
        : ``}
  
imageId
imageIds

    ${fields.images
        ? `
      images {
        ${MediaGQLFields(fields.images)}
      }
    `
        : ``}
  
installed
name

    ${fields.network
        ? `
      network {
        ${NetworkGQLFields(fields.network)}
      }
    `
        : ``}
  
networkId
privacyPolicyUrl
requiredPlan
requiredTemplateIds

    ${fields.requiredTemplates
        ? `
      requiredTemplates {
        ${TemplateGQLFields(fields.requiredTemplates)}
      }
    `
        : ``}
  

    ${fields.slate
        ? `
      slate {
        ${SlateGQLFields(fields.slate)}
      }
    `
        : ``}
  
slug
standing
status
termsOfServiceUrl
updatedAt

    ${fields.updatedBy
        ? `
      updatedBy {
        ${MemberGQLFields(fields.updatedBy)}
      }
    `
        : ``}
  
updatedById
      `;
};
export const TemplateCreatedEntityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            onSpace: 'basic',
        };
    }
    return `
        __typename
        
          ${fields.onSpace
        ? `
            ... on Space {
              ${SpaceGQLFields(fields.onSpace)}
            }
          `
        : ``}
        
      `;
};
export const TemplateEdgeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            node: 'basic',
        };
    }
    return `
        __typename
        cursor

    ${fields.node
        ? `
      node {
        ${TemplateGQLFields(fields.node)}
      }
    `
        : ``}
  
      `;
};
export const TemplateFieldMappingGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        from
to
      `;
};
export const TemplateRequestGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            createdEntity: 'basic',
        };
    }
    return `
        __typename
        createdAt
createdById

    ${fields.createdEntity
        ? `
      createdEntity {
        ${TemplateCreatedEntityGQLFields(fields.createdEntity)}
      }
    `
        : ``}
  
createdEntityAt
createdEntityId
createdEntityType
id
networkId
processedPercentage
status
templateId
updatedAt
      `;
};
export const TemplatesMappingGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            fields: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.fields
        ? `
      fields {
        ${TemplateFieldMappingGQLFields(fields.fields)}
      }
    `
        : ``}
  
from
to
      `;
};
export const ThemeGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            tokens: 'basic',
        };
    }
    return `
        __typename
        name
status

    ${fields.tokens
        ? `
      tokens {
        ${ThemeTokensGQLFields(fields.tokens)}
      }
    `
        : ``}
  
      `;
};
export const ThemeColorGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            weights: 'basic',
        };
    }
    return `
        __typename
        key

    ${fields.weights
        ? `
      weights {
        ${ThemeTokenGQLFields(fields.weights)}
      }
    `
        : ``}
  
      `;
};
export const ThemeColorsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            dark: 'basic',
            light: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.dark
        ? `
      dark {
        ${ThemeColorGQLFields(fields.dark)}
      }
    `
        : ``}
  

    ${fields.light
        ? `
      light {
        ${ThemeColorGQLFields(fields.light)}
      }
    `
        : ``}
  
      `;
};
export const ThemeTokenGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
value
      `;
};
export const ThemeTokensGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            breakpoints: 'basic',
            colors: 'basic',
            fontSizes: 'basic',
            fontWeights: 'basic',
            opacity: 'basic',
            shadows: 'basic',
            sizes: 'basic',
            textStyles: 'basic',
            zIndices: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.breakpoints
        ? `
      breakpoints {
        ${ThemeTokenGQLFields(fields.breakpoints)}
      }
    `
        : ``}
  

    ${fields.colors
        ? `
      colors {
        ${ThemeTokenGQLFields(fields.colors)}
      }
    `
        : ``}
  

    ${fields.fontSizes
        ? `
      fontSizes {
        ${ThemeTokenGQLFields(fields.fontSizes)}
      }
    `
        : ``}
  

    ${fields.fontWeights
        ? `
      fontWeights {
        ${ThemeTokenGQLFields(fields.fontWeights)}
      }
    `
        : ``}
  

    ${fields.opacity
        ? `
      opacity {
        ${ThemeTokenGQLFields(fields.opacity)}
      }
    `
        : ``}
  

    ${fields.shadows
        ? `
      shadows {
        ${ThemeTokenGQLFields(fields.shadows)}
      }
    `
        : ``}
  

    ${fields.sizes
        ? `
      sizes {
        ${ThemeTokenGQLFields(fields.sizes)}
      }
    `
        : ``}
  

    ${fields.textStyles
        ? `
      textStyles {
        ${ThemeTokenGQLFields(fields.textStyles)}
      }
    `
        : ``}
  

    ${fields.zIndices
        ? `
      zIndices {
        ${ThemeTokenGQLFields(fields.zIndices)}
      }
    `
        : ``}
  
      `;
};
export const ThemesGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            active: 'basic',
            drafts: 'basic',
            published: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.active
        ? `
      active {
        ${ThemeGQLFields(fields.active)}
      }
    `
        : ``}
  

    ${fields.drafts
        ? `
      drafts {
        ${ThemeGQLFields(fields.drafts)}
      }
    `
        : ``}
  

    ${fields.published
        ? `
      published {
        ${ThemeGQLFields(fields.published)}
      }
    `
        : ``}
  
      `;
};
export const ToastGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        description
duration
status
title
      `;
};
export const TopNavigationGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            items: 'basic',
        };
    }
    return `
        __typename
        alignment
enabled

    ${fields.items
        ? `
      items {
        ${NavigationItemGQLFields(fields.items)}
      }
    `
        : ``}
  
      `;
};
export const UploadedMigrationsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            results: 'basic',
        };
    }
    return `
        __typename
        migrationId

    ${fields.results
        ? `
      results {
        ${MigrationFileResultGQLFields(fields.results)}
      }
    `
        : ``}
  
      `;
};
export const UsernameAvailabilityGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        available
      `;
};
export const ValuePermissionsGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {
            isAuthorized: 'basic',
        };
    }
    return `
        __typename
        
    ${fields.isAuthorized
        ? `
      isAuthorized {
        ${IsAuthorizedGQLFields(fields.isAuthorized)}
      }
    `
        : ``}
  
value
      `;
};
export const VatGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        text
vatId
vatType
      `;
};
export const VatTypeInfoGQLFields = (fields) => {
    if (fields === 'basic') {
        fields = {};
    }
    if (fields === 'all') {
        fields = {};
    }
    return `
        __typename
        key
placeholder
text
value
      `;
};
export const QueryFunctions = {
    accessGroup: (fields) => gql `
      query accessGroup($id: ID!) {
        accessGroup(id: $id) {
          ${AccessGroupGQLFields(fields)}
        }
      }
    `,
    accessGroups: (fields) => gql `
      query accessGroups {
        accessGroups {
          ${AccessGroupGQLFields(fields)}
        }
      }
    `,
    activityLogs: (fields) => gql `
      query activityLogs($query: String!) {
        activityLogs(query: $query) {
          ${ReportRecordGQLFields(fields)}
        }
      }
    `,
    analytics: (fields) => gql `
      query analytics($queries: [String!]!) {
        analytics(queries: $queries) {
          ${AnalyticsResponseGQLFields(fields)}
        }
      }
    `,
    app: (fields) => gql `
      query app($clientId: String
$id: ID
$redirectUri: String
$slug: String) {
        app(clientId: $clientId
id: $id
redirectUri: $redirectUri
slug: $slug) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    apps: (fields) => gql `
      query apps($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$standing: StoreItemStanding
$status: StoreItemStatus) {
        apps(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
standing: $standing
status: $status) {
          ${PaginatedAppGQLFields(fields)}
        }
      }
    `,
    authMember: (fields) => gql `
      query authMember {
        authMember {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    authMemberAppInstallation: (fields) => gql `
      query authMemberAppInstallation($appId: String!) {
        authMemberAppInstallation(appId: $appId) {
          ${AppInstallationGQLFields(fields)}
        }
      }
    `,
    authMemberAppInstallations: (fields) => gql `
      query authMemberAppInstallations($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$status: AppInstallationStatus) {
        authMemberAppInstallations(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
status: $status) {
          ${PaginatedAppInstallationGQLFields(fields)}
        }
      }
    `,
    availableDynamicBlocks: (fields) => gql `
      query availableDynamicBlocks($context: PermissionContext
$size: DynamicBlockSize) {
        availableDynamicBlocks(context: $context
size: $size) {
          ${DynamicBlockGQLFields(fields)}
        }
      }
    `,
    baskets: (fields) => gql `
      query baskets($input: BasketsInput!) {
        baskets(input: $input) {
          ${BasketGQLFields(fields)}
        }
      }
    `,
    billingDetails: (fields) => gql `
      query billingDetails {
        billingDetails {
          ${BillingDetailsGQLFields(fields)}
        }
      }
    `,
    cancelSubscription: (fields) => gql `
      query cancelSubscription {
        cancelSubscription {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    checkDomainAvailability: (fields) => gql `
      query checkDomainAvailability($input: DomainAvailabilityInput!) {
        checkDomainAvailability(input: $input) {
          ${DomainAvailabilityGQLFields(fields)}
        }
      }
    `,
    checkEmailAvailability: (fields) => gql `
      query checkEmailAvailability($email: String!) {
        checkEmailAvailability(email: $email) {
          ${EmailAvailabilityGQLFields(fields)}
        }
      }
    `,
    checkInvitationLinkValidity: (fields) => gql `
      query checkInvitationLinkValidity($invitationLinkId: String!) {
        checkInvitationLinkValidity(invitationLinkId: $invitationLinkId) {
          ${MemberInvitationLinkGQLFields(fields)}
        }
      }
    `,
    checkMemberInvitationValidity: (fields) => gql `
      query checkMemberInvitationValidity($token: String!) {
        checkMemberInvitationValidity(token: $token) {
          ${MemberInvitationGQLFields(fields)}
        }
      }
    `,
    checkNewDomainStatus: (fields) => gql `
      query checkNewDomainStatus($domain: String!) {
        checkNewDomainStatus(domain: $domain) {
          ${DomainTransferStatusGQLFields(fields)}
        }
      }
    `,
    checkPasswordComplexity: (fields) => gql `
      query checkPasswordComplexity($password: String!) {
        checkPasswordComplexity(password: $password) {
          ${PasswordComplexityGQLFields(fields)}
        }
      }
    `,
    checkUsernameAvailability: (fields) => gql `
      query checkUsernameAvailability($username: String!) {
        checkUsernameAvailability(username: $username) {
          ${UsernameAvailabilityGQLFields(fields)}
        }
      }
    `,
    collection: (fields) => gql `
      query collection($id: ID) {
        collection(id: $id) {
          ${CollectionGQLFields(fields)}
        }
      }
    `,
    collections: (fields) => gql `
      query collections($orderBy: CollectionListOrderByEnum
$reverse: Boolean) {
        collections(orderBy: $orderBy
reverse: $reverse) {
          ${CollectionGQLFields(fields)}
        }
      }
    `,
    domainAvailability: (fields) => gql `
      query domainAvailability($input: DomainAvailabilityInput!) {
        domainAvailability(input: $input) {
          ${DomainAvailabilityGQLFields(fields)}
        }
      }
    `,
    dynamicBlock: (fields) => gql `
      query dynamicBlock($blockId: ID!) {
        dynamicBlock(blockId: $blockId) {
          ${DynamicBlockGQLFields(fields)}
        }
      }
    `,
    dynamicBlockByKey: (fields) => gql `
      query dynamicBlockByKey($appId: ID!
$key: String!) {
        dynamicBlockByKey(appId: $appId
key: $key) {
          ${DynamicBlockGQLFields(fields)}
        }
      }
    `,
    dynamicBlocks: (fields) => gql `
      query dynamicBlocks($after: String
$appIds: [ID!]
$before: String
$contexts: [PermissionContext!]
$limit: Int!
$offset: Int
$reverse: Boolean) {
        dynamicBlocks(after: $after
appIds: $appIds
before: $before
contexts: $contexts
limit: $limit
offset: $offset
reverse: $reverse) {
          ${PaginatedDynamicBlockGQLFields(fields)}
        }
      }
    `,
    emailAvailability: (fields) => gql `
      query emailAvailability($email: String!) {
        emailAvailability(email: $email) {
          ${EmailAvailabilityGQLFields(fields)}
        }
      }
    `,
    emailLogs: (fields) => gql `
      query emailLogs($after: String
$limit: Int!
$recipient: String
$reverse: Boolean
$statuses: [EmailStatus!]
$types: [EmailType!]) {
        emailLogs(after: $after
limit: $limit
recipient: $recipient
reverse: $reverse
statuses: $statuses
types: $types) {
          ${PaginatedEmailLogGQLFields(fields)}
        }
      }
    `,
    embed: (fields) => gql `
      query embed($input: EmbedInput!) {
        embed(input: $input) {
          ${EmbedGQLFields(fields)}
        }
      }
    `,
    exploreSpaces: (fields) => gql `
      query exploreSpaces($after: String
$before: String
$collectionId: String
$limit: Int!
$offset: Int
$reverse: Boolean) {
        exploreSpaces(after: $after
before: $before
collectionId: $collectionId
limit: $limit
offset: $offset
reverse: $reverse) {
          ${PaginatedSpaceGQLFields(fields)}
        }
      }
    `,
    exportMemberRequest: (fields) => gql `
      query exportMemberRequest($id: ID!) {
        exportMemberRequest(id: $id) {
          ${ExportGQLFields(fields)}
        }
      }
    `,
    exportMemberRequests: (fields) => gql `
      query exportMemberRequests($after: String
$before: String
$limit: Int!
$offset: Int
$orderBy: ExportListOrderByEnum
$query: String
$reverse: Boolean
$statuses: [ExportStatus!]) {
        exportMemberRequests(after: $after
before: $before
limit: $limit
offset: $offset
orderBy: $orderBy
query: $query
reverse: $reverse
statuses: $statuses) {
          ${PaginatedExportGQLFields(fields)}
        }
      }
    `,
    extraProperties: (fields) => gql `
      query extraProperties($entityId: String
$entityType: ExtraPropertyEntityType!
$keys: [String!]) {
        extraProperties(entityId: $entityId
entityType: $entityType
keys: $keys) {
          ${ExtraPropertyGQLFields(fields)}
        }
      }
    `,
    feed: (fields) => gql `
      query feed($after: String
$before: String
$filterBy: [PostListFilterByInput!]
$limit: Int!
$offset: Int
$onlyMemberSpaces: Boolean
$orderBy: PostListOrderByEnum
$orderByString: String
$postTypeIds: [String!]
$reverse: Boolean) {
        feed(after: $after
before: $before
filterBy: $filterBy
limit: $limit
offset: $offset
onlyMemberSpaces: $onlyMemberSpaces
orderBy: $orderBy
orderByString: $orderByString
postTypeIds: $postTypeIds
reverse: $reverse) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    getAppById: (fields) => gql `
      query getAppById($id: ID!) {
        getAppById(id: $id) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    getAppBySlug: (fields) => gql `
      query getAppBySlug($slug: String!) {
        getAppBySlug(slug: $slug) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    getAppNetworkSettings: () => gql `
    query getAppNetworkSettings($appId: ID!) {
      getAppNetworkSettings(appId: $appId)
    }
  `,
    getAppSpaceSettings: () => gql `
    query getAppSpaceSettings($appId: ID!, $spaceId: ID!) {
      getAppSpaceSettings(appId: $appId, spaceId: $spaceId)
    }
  `,
    getApps: (fields) => gql `
      query getApps($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$status: StoreItemStatus) {
        getApps(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
status: $status) {
          ${PaginatedAppGQLFields(fields)}
        }
      }
    `,
    getAuthMember: (fields) => gql `
      query getAuthMember {
        getAuthMember {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    getEmbed: (fields) => gql `
      query getEmbed($input: EmbedInput!) {
        getEmbed(input: $input) {
          ${EmbedGQLFields(fields)}
        }
      }
    `,
    getFeed: (fields) => gql `
      query getFeed($after: String
$before: String
$filterBy: [PostListFilterByInput!]
$limit: Int!
$offset: Int
$onlyMemberSpaces: Boolean
$orderBy: PostListOrderByEnum
$postTypeIds: [String!]
$reverse: Boolean) {
        getFeed(after: $after
before: $before
filterBy: $filterBy
limit: $limit
offset: $offset
onlyMemberSpaces: $onlyMemberSpaces
orderBy: $orderBy
postTypeIds: $postTypeIds
reverse: $reverse) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    getGroup: (fields) => gql `
      query getGroup($groupId: ID) {
        getGroup(groupId: $groupId) {
          ${CollectionGQLFields(fields)}
        }
      }
    `,
    getGroups: (fields) => gql `
      query getGroups {
        getGroups {
          ${CollectionGQLFields(fields)}
        }
      }
    `,
    getMedia: (fields) => gql `
      query getMedia($mediaId: ID!) {
        getMedia(mediaId: $mediaId) {
          ${MediaGQLFields(fields)}
        }
      }
    `,
    getMember: (fields) => gql `
      query getMember($memberId: ID
$username: String) {
        getMember(memberId: $memberId
username: $username) {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    getMemberAppInstallations: (fields) => gql `
      query getMemberAppInstallations($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$status: AppInstallationStatus) {
        getMemberAppInstallations(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
status: $status) {
          ${PaginatedAppInstallationGQLFields(fields)}
        }
      }
    `,
    getMemberInvitation: (fields) => gql `
      query getMemberInvitation($id: ID!) {
        getMemberInvitation(id: $id) {
          ${MemberInvitationGQLFields(fields)}
        }
      }
    `,
    getMemberInvitationLink: (fields) => gql `
      query getMemberInvitationLink {
        getMemberInvitationLink {
          ${MemberInvitationLinkGQLFields(fields)}
        }
      }
    `,
    getMemberInvitations: (fields) => gql `
      query getMemberInvitations($after: String
$before: String
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean
$roleIds: [String!]
$status: MemberInvitationStatus) {
        getMemberInvitations(after: $after
before: $before
limit: $limit
offset: $offset
query: $query
reverse: $reverse
roleIds: $roleIds
status: $status) {
          ${PaginatedMemberInvitationGQLFields(fields)}
        }
      }
    `,
    getMemberNetworkNotificationSettings: (fields) => gql `
      query getMemberNetworkNotificationSettings($memberId: ID) {
        getMemberNetworkNotificationSettings(memberId: $memberId) {
          ${MemberNetworkNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    getMemberNotificationSettings: (fields) => gql `
      query getMemberNotificationSettings($memberId: ID) {
        getMemberNotificationSettings(memberId: $memberId) {
          ${MemberNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    getMemberPosts: (fields) => gql `
      query getMemberPosts($after: String
$before: String
$limit: Int!
$memberId: ID!
$offset: Int
$reverse: Boolean) {
        getMemberPosts(after: $after
before: $before
limit: $limit
memberId: $memberId
offset: $offset
reverse: $reverse) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    getMemberSpaceNotificationSettings: (fields) => gql `
      query getMemberSpaceNotificationSettings($memberId: ID
$spaceId: ID!) {
        getMemberSpaceNotificationSettings(memberId: $memberId
spaceId: $spaceId) {
          ${MemberSpaceNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    getMemberSpaces: (fields) => gql `
      query getMemberSpaces($after: String
$before: String
$groupId: String
$limit: Int!
$memberId: ID!
$offset: Int
$reverse: Boolean
$roleIds: [ID!]) {
        getMemberSpaces(after: $after
before: $before
groupId: $groupId
limit: $limit
memberId: $memberId
offset: $offset
reverse: $reverse
roleIds: $roleIds) {
          ${PaginatedSpaceMemberGQLFields(fields)}
        }
      }
    `,
    getMembers: (fields) => gql `
      query getMembers($after: String
$before: String
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean
$roleIds: [ID!]
$status: [MemberStatusInput!]) {
        getMembers(after: $after
before: $before
limit: $limit
offset: $offset
query: $query
reverse: $reverse
roleIds: $roleIds
status: $status) {
          ${PaginatedMemberGQLFields(fields)}
        }
      }
    `,
    getModerationById: (fields) => gql `
      query getModerationById($moderationId: ID!) {
        getModerationById(moderationId: $moderationId) {
          ${ModerationItemGQLFields(fields)}
        }
      }
    `,
    getModerationReporters: (fields) => gql `
      query getModerationReporters($after: String
$before: String
$limit: Int!
$moderationId: String!
$offset: Int
$reverse: Boolean) {
        getModerationReporters(after: $after
before: $before
limit: $limit
moderationId: $moderationId
offset: $offset
reverse: $reverse) {
          ${PaginatedModerationItemReporterGQLFields(fields)}
        }
      }
    `,
    getModerationSetting: (fields) => gql `
      query getModerationSetting {
        getModerationSetting {
          ${ModerationSettingsGQLFields(fields)}
        }
      }
    `,
    getModerations: (fields) => gql `
      query getModerations($after: String
$before: String
$entityId: String
$entityType: ModerationEntityType
$flaggedBy: FlaggedType
$limit: Int!
$offset: Int
$reverse: Boolean
$spaceId: String
$status: ModerationStatus) {
        getModerations(after: $after
before: $before
entityId: $entityId
entityType: $entityType
flaggedBy: $flaggedBy
limit: $limit
offset: $offset
reverse: $reverse
spaceId: $spaceId
status: $status) {
          ${PaginatedModerationGQLFields(fields)}
        }
      }
    `,
    getNetwork: (fields) => gql `
      query getNetwork {
        getNetwork {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    getNetworkAppInstallations: (fields) => gql `
      query getNetworkAppInstallations($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$status: AppInstallationStatus) {
        getNetworkAppInstallations(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
status: $status) {
          ${PaginatedAppInstallationGQLFields(fields)}
        }
      }
    `,
    getNetworkApps: (fields) => gql `
      query getNetworkApps($status: AppInstallationStatus) {
        getNetworkApps(status: $status) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    getNetworkPublicInfo: (fields) => gql `
      query getNetworkPublicInfo {
        getNetworkPublicInfo {
          ${NetworkPublicInfoGQLFields(fields)}
        }
      }
    `,
    getNetworks: (fields) => gql `
      query getNetworks($after: String
$before: String
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean) {
        getNetworks(after: $after
before: $before
limit: $limit
offset: $offset
query: $query
reverse: $reverse) {
          ${PaginatedNetworkGQLFields(fields)}
        }
      }
    `,
    getNotifications: (fields) => gql `
      query getNotifications($after: String
$limit: Int!) {
        getNotifications(after: $after
limit: $limit) {
          ${PaginatedNotificationGQLFields(fields)}
        }
      }
    `,
    getNotificationsCount: (fields) => gql `
      query getNotificationsCount {
        getNotificationsCount {
          ${NotificationsCountGQLFields(fields)}
        }
      }
    `,
    getPost: (fields) => gql `
      query getPost($postId: ID!) {
        getPost(postId: $postId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    getPostAppInstallations: (fields) => gql `
      query getPostAppInstallations($after: String
$before: String
$limit: Int!
$offset: Int
$postId: ID!
$reverse: Boolean
$status: AppInstallationStatus) {
        getPostAppInstallations(after: $after
before: $before
limit: $limit
offset: $offset
postId: $postId
reverse: $reverse
status: $status) {
          ${PaginatedAppInstallationGQLFields(fields)}
        }
      }
    `,
    getPostReactionParticipants: (fields) => gql `
      query getPostReactionParticipants($after: String
$before: String
$limit: Int!
$offset: Int
$postId: ID!
$reaction: ID!
$reverse: Boolean) {
        getPostReactionParticipants(after: $after
before: $before
limit: $limit
offset: $offset
postId: $postId
reaction: $reaction
reverse: $reverse) {
          ${PaginatedPostReactionParticipantGQLFields(fields)}
        }
      }
    `,
    getPosts: (fields) => gql `
      query getPosts($after: String
$before: String
$excludePins: Boolean
$filterBy: [PostListFilterByInput!]
$limit: Int!
$offset: Int
$orderBy: PostListOrderByEnum
$postTypeIds: [String!]
$reverse: Boolean
$spaceIds: [ID!]) {
        getPosts(after: $after
before: $before
excludePins: $excludePins
filterBy: $filterBy
limit: $limit
offset: $offset
orderBy: $orderBy
postTypeIds: $postTypeIds
reverse: $reverse
spaceIds: $spaceIds) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    getRedirectUrl: (fields) => gql `
      query getRedirectUrl($url: String!) {
        getRedirectUrl(url: $url) {
          ${RedirectGQLFields(fields)}
        }
      }
    `,
    getReplies: (fields) => gql `
      query getReplies($after: String
$before: String
$excludePins: Boolean
$limit: Int!
$offset: Int
$orderBy: PostListOrderByEnum
$postId: ID!
$reverse: Boolean) {
        getReplies(after: $after
before: $before
excludePins: $excludePins
limit: $limit
offset: $offset
orderBy: $orderBy
postId: $postId
reverse: $reverse) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    getReport: (fields) => gql `
      query getReport($input: ReportInput!) {
        getReport(input: $input) {
          ${ReportGQLFields(fields)}
        }
      }
    `,
    getRoles: (fields) => gql `
      query getRoles {
        getRoles {
          ${RoleGQLFields(fields)}
        }
      }
    `,
    getScopes: (fields) => gql `
      query getScopes($contexts: [PermissionsContextInput!]) {
        getScopes(contexts: $contexts) {
          ${ScopesGQLFields(fields)}
        }
      }
    `,
    getSpace: (fields) => gql `
      query getSpace($spaceId: ID
$spaceSlug: ID) {
        getSpace(spaceId: $spaceId
spaceSlug: $spaceSlug) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    getSpaceAppInstallations: (fields) => gql `
      query getSpaceAppInstallations($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$spaceId: ID!
$status: AppInstallationStatus) {
        getSpaceAppInstallations(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
spaceId: $spaceId
status: $status) {
          ${PaginatedAppInstallationGQLFields(fields)}
        }
      }
    `,
    getSpaceMembers: (fields) => gql `
      query getSpaceMembers($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$roleIds: [ID!]
$spaceId: ID!) {
        getSpaceMembers(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
roleIds: $roleIds
spaceId: $spaceId) {
          ${PaginatedSpaceMemberGQLFields(fields)}
        }
      }
    `,
    getSpaceMembershipRequestForMember: (fields) => gql `
      query getSpaceMembershipRequestForMember($status: SpaceJoinRequestStatus) {
        getSpaceMembershipRequestForMember(status: $status) {
          ${SpaceJoinRequestGQLFields(fields)}
        }
      }
    `,
    getSpaceMembershipRequests: (fields) => gql `
      query getSpaceMembershipRequests($spaceId: ID!
$status: SpaceJoinRequestStatus) {
        getSpaceMembershipRequests(spaceId: $spaceId
status: $status) {
          ${SpaceJoinRequestGQLFields(fields)}
        }
      }
    `,
    getSpacePinnedPosts: (fields) => gql `
      query getSpacePinnedPosts($spaceId: ID!) {
        getSpacePinnedPosts(spaceId: $spaceId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    getSpaceReport: (fields) => gql `
      query getSpaceReport($input: ReportInput!
$spaceId: String!) {
        getSpaceReport(input: $input
spaceId: $spaceId) {
          ${ReportGQLFields(fields)}
        }
      }
    `,
    getSpaceRoles: (fields) => gql `
      query getSpaceRoles($spaceId: ID) {
        getSpaceRoles(spaceId: $spaceId) {
          ${SpaceRoleGQLFields(fields)}
        }
      }
    `,
    getSpaces: (fields) => gql `
      query getSpaces($after: String
$before: String
$limit: Int!
$memberId: ID
$offset: Int
$query: String
$reverse: Boolean) {
        getSpaces(after: $after
before: $before
limit: $limit
memberId: $memberId
offset: $offset
query: $query
reverse: $reverse) {
          ${PaginatedSpaceGQLFields(fields)}
        }
      }
    `,
    getSsoMemberships: (fields) => gql `
      query getSsoMemberships($memberId: String!) {
        getSsoMemberships(memberId: $memberId) {
          ${SsoMembershipGQLFields(fields)}
        }
      }
    `,
    getSupportNetworkTokens: (fields) => gql `
      query getSupportNetworkTokens($input: CreateLimitedSupportTokenInput!) {
        getSupportNetworkTokens(input: $input) {
          ${SupportLimitedAuthTokenGQLFields(fields)}
        }
      }
    `,
    getTokens: (fields) => gql `
      query getTokens($networkDomain: String
$networkId: ID
$otp: String
$refreshToken: String) {
        getTokens(networkDomain: $networkDomain
networkId: $networkId
otp: $otp
refreshToken: $refreshToken) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    globalApp: (fields) => gql `
      query globalApp($id: ID
$slug: String) {
        globalApp(id: $id
slug: $slug) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    globalAppCollaborators: (fields) => gql `
      query globalAppCollaborators($appId: String!) {
        globalAppCollaborators(appId: $appId) {
          ${AppCollaboratorGQLFields(fields)}
        }
      }
    `,
    globalAppPublications: (fields) => gql `
      query globalAppPublications($appId: ID!) {
        globalAppPublications(appId: $appId) {
          ${AppPublicationGQLFields(fields)}
        }
      }
    `,
    globalAppSettings: (fields) => gql `
      query globalAppSettings($context: PermissionContext!
$entityId: ID
$networkId: ID!) {
        globalAppSettings(context: $context
entityId: $entityId
networkId: $networkId) {
          ${AppSettingGQLFields(fields)}
        }
      }
    `,
    globalApps: (fields) => gql `
      query globalApps($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$standing: StoreItemStanding
$status: StoreItemStatus) {
        globalApps(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
standing: $standing
status: $status) {
          ${PaginatedAppGQLFields(fields)}
        }
      }
    `,
    globalEmbed: (fields) => gql `
      query globalEmbed($input: EmbedInput!) {
        globalEmbed(input: $input) {
          ${EmbedGQLFields(fields)}
        }
      }
    `,
    globalEventTypes: (fields) => gql `
      query globalEventTypes {
        globalEventTypes {
          ${EventTypeGQLFields(fields)}
        }
      }
    `,
    globalMedia: (fields) => gql `
      query globalMedia($id: ID!) {
        globalMedia(id: $id) {
          ${MediaGQLFields(fields)}
        }
      }
    `,
    globalNetworks: (fields) => gql `
      query globalNetworks($after: String
$before: String
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean
$roleType: RoleType) {
        globalNetworks(after: $after
before: $before
limit: $limit
offset: $offset
query: $query
reverse: $reverse
roleType: $roleType) {
          ${PaginatedNetworkGQLFields(fields)}
        }
      }
    `,
    globalToken: (fields) => gql `
      query globalToken($input: GlobalTokenInput!) {
        globalToken(input: $input) {
          ${GlobalTokenGQLFields(fields)}
        }
      }
    `,
    impersonateLoginToNetwork: (fields) => gql `
      query impersonateLoginToNetwork($input: ImpersonateLoginToNetworkInput!) {
        impersonateLoginToNetwork(input: $input) {
          ${AuthInfoWithOtpGQLFields(fields)}
        }
      }
    `,
    invitationLinkValidity: (fields) => gql `
      query invitationLinkValidity($id: String!) {
        invitationLinkValidity(id: $id) {
          ${MemberInvitationLinkGQLFields(fields)}
        }
      }
    `,
    invoices: (fields) => gql `
      query invoices {
        invoices {
          ${InvoiceGQLFields(fields)}
        }
      }
    `,
    leaderboard: (fields) => gql `
      query leaderboard($input: ReportInput!) {
        leaderboard(input: $input) {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    leaderboardWithScores: (fields) => gql `
      query leaderboardWithScores($includeAuthMember: Boolean!
$input: ReportInput!) {
        leaderboardWithScores(includeAuthMember: $includeAuthMember
input: $input) {
          ${LeaderboardItemGQLFields(fields)}
        }
      }
    `,
    limitedToken: (fields) => gql `
      query limitedToken($context: PermissionContext
$entityId: String
$impersonateMemberId: String
$networkId: String!) {
        limitedToken(context: $context
entityId: $entityId
impersonateMemberId: $impersonateMemberId
networkId: $networkId) {
          ${AppTokenGQLFields(fields)}
        }
      }
    `,
    loginNetwork: (fields) => gql `
      query loginNetwork($input: LoginNetworkWithPasswordInput!) {
        loginNetwork(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    loginNetworkWithGlobalToken: (fields) => gql `
      query loginNetworkWithGlobalToken($input: LoginNetworkWithGlobalTokenInput!) {
        loginNetworkWithGlobalToken(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    loginNetworkWithPassword: (fields) => gql `
      query loginNetworkWithPassword($input: LoginNetworkWithPasswordInput!) {
        loginNetworkWithPassword(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    loginSupportWithSso: (fields) => gql `
      query loginSupportWithSso($input: SupportSsoUrlInput) {
        loginSupportWithSso(input: $input) {
          ${SupportSsoUrlGQLFields(fields)}
        }
      }
    `,
    loginSupportWithSsoCode: (fields) => gql `
      query loginSupportWithSsoCode($input: LoginSupportWithSsoCodeInput!) {
        loginSupportWithSsoCode(input: $input) {
          ${SupportAuthTokenGQLFields(fields)}
        }
      }
    `,
    loginWithSso: (fields) => gql `
      query loginWithSso($input: SsoUrlInput!) {
        loginWithSso(input: $input) {
          ${SsoUrlGQLFields(fields)}
        }
      }
    `,
    loginWithSsoCode: (fields) => gql `
      query loginWithSsoCode($input: LoginWithSsoCodeInput!) {
        loginWithSsoCode(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    massActionRequest: (fields) => gql `
      query massActionRequest($id: String!) {
        massActionRequest(id: $id) {
          ${MassActionRequestGQLFields(fields)}
        }
      }
    `,
    massActionRequestInProgress: (fields) => gql `
      query massActionRequestInProgress {
        massActionRequestInProgress {
          ${MassActionRequestGQLFields(fields)}
        }
      }
    `,
    media: (fields) => gql `
      query media($id: ID!) {
        media(id: $id) {
          ${MediaGQLFields(fields)}
        }
      }
    `,
    member: (fields) => gql `
      query member($id: ID
$username: String) {
        member(id: $id
username: $username) {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    memberInvitation: (fields) => gql `
      query memberInvitation($id: ID!) {
        memberInvitation(id: $id) {
          ${MemberInvitationGQLFields(fields)}
        }
      }
    `,
    memberInvitationLink: (fields) => gql `
      query memberInvitationLink {
        memberInvitationLink {
          ${MemberInvitationLinkGQLFields(fields)}
        }
      }
    `,
    memberInvitationValidity: (fields) => gql `
      query memberInvitationValidity($token: String!) {
        memberInvitationValidity(token: $token) {
          ${MemberInvitationGQLFields(fields)}
        }
      }
    `,
    memberInvitations: (fields) => gql `
      query memberInvitations($after: String
$before: String
$filterBy: [MemberInvitationFilterByInput!]
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean
$roleIds: [String!]
$status: MemberInvitationStatus) {
        memberInvitations(after: $after
before: $before
filterBy: $filterBy
limit: $limit
offset: $offset
query: $query
reverse: $reverse
roleIds: $roleIds
status: $status) {
          ${PaginatedMemberInvitationGQLFields(fields)}
        }
      }
    `,
    memberNotificationSettings: (fields) => gql `
      query memberNotificationSettings($id: ID) {
        memberNotificationSettings(id: $id) {
          ${MemberNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    memberPostNotificationSettings: (fields) => gql `
      query memberPostNotificationSettings($memberId: ID
$postId: ID!) {
        memberPostNotificationSettings(memberId: $memberId
postId: $postId) {
          ${MemberPostNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    memberPosts: (fields) => gql `
      query memberPosts($after: String
$before: String
$hasParent: Boolean
$limit: Int!
$memberId: ID!
$offset: Int
$reverse: Boolean) {
        memberPosts(after: $after
before: $before
hasParent: $hasParent
limit: $limit
memberId: $memberId
offset: $offset
reverse: $reverse) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    memberScore: (fields) => gql `
      query memberScore($input: ReportInput!
$spaceId: String) {
        memberScore(input: $input
spaceId: $spaceId) {
          ${ReportGQLFields(fields)}
        }
      }
    `,
    memberSpaceMembershipRequest: (fields) => gql `
      query memberSpaceMembershipRequest($status: SpaceJoinRequestStatus) {
        memberSpaceMembershipRequest(status: $status) {
          ${SpaceJoinRequestGQLFields(fields)}
        }
      }
    `,
    memberSpaces: (fields) => gql `
      query memberSpaces($after: String
$before: String
$collectionId: String
$limit: Int!
$memberId: ID!
$offset: Int
$reverse: Boolean
$roleIds: [ID!]) {
        memberSpaces(after: $after
before: $before
collectionId: $collectionId
limit: $limit
memberId: $memberId
offset: $offset
reverse: $reverse
roleIds: $roleIds) {
          ${PaginatedSpaceMemberGQLFields(fields)}
        }
      }
    `,
    members: (fields) => gql `
      query members($after: String
$before: String
$filterBy: [MemberListFilterByInput!]
$limit: Int!
$offset: Int
$orderBy: String
$query: String
$reverse: Boolean
$roleIds: [ID!]
$status: [MemberStatusInput!]) {
        members(after: $after
before: $before
filterBy: $filterBy
limit: $limit
offset: $offset
orderBy: $orderBy
query: $query
reverse: $reverse
roleIds: $roleIds
status: $status) {
          ${PaginatedMemberGQLFields(fields)}
        }
      }
    `,
    membersByIds: (fields) => gql `
      query membersByIds($ids: [String!]!) {
        membersByIds(ids: $ids) {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    migrationSampleFile: () => gql `
    query migrationSampleFile($type: PermissionContext) {
      migrationSampleFile(type: $type)
    }
  `,
    moderationItem: (fields) => gql `
      query moderationItem($id: ID!) {
        moderationItem(id: $id) {
          ${ModerationItemGQLFields(fields)}
        }
      }
    `,
    moderationItemReporters: (fields) => gql `
      query moderationItemReporters($after: String
$before: String
$limit: Int!
$moderationId: String!
$offset: Int
$reverse: Boolean) {
        moderationItemReporters(after: $after
before: $before
limit: $limit
moderationId: $moderationId
offset: $offset
reverse: $reverse) {
          ${PaginatedModerationItemReporterGQLFields(fields)}
        }
      }
    `,
    moderationItems: (fields) => gql `
      query moderationItems($after: String
$before: String
$entityId: String
$entityType: ModerationEntityType
$flaggedBy: FlaggedType
$limit: Int!
$offset: Int
$reverse: Boolean
$spaceId: String
$status: ModerationStatus) {
        moderationItems(after: $after
before: $before
entityId: $entityId
entityType: $entityType
flaggedBy: $flaggedBy
limit: $limit
offset: $offset
reverse: $reverse
spaceId: $spaceId
status: $status) {
          ${PaginatedModerationGQLFields(fields)}
        }
      }
    `,
    moderationSettings: (fields) => gql `
      query moderationSettings {
        moderationSettings {
          ${ModerationSettingsGQLFields(fields)}
        }
      }
    `,
    network: (fields) => gql `
      query network {
        network {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    networkAppInstallations: (fields) => gql `
      query networkAppInstallations($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$status: AppInstallationStatus) {
        networkAppInstallations(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
status: $status) {
          ${PaginatedAppInstallationGQLFields(fields)}
        }
      }
    `,
    networkApps: (fields) => gql `
      query networkApps($status: AppInstallationStatus) {
        networkApps(status: $status) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    networkPublicInfo: (fields) => gql `
      query networkPublicInfo {
        networkPublicInfo {
          ${NetworkPublicInfoGQLFields(fields)}
        }
      }
    `,
    networks: (fields) => gql `
      query networks($after: String
$before: String
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean) {
        networks(after: $after
before: $before
limit: $limit
offset: $offset
query: $query
reverse: $reverse) {
          ${PaginatedNetworkGQLFields(fields)}
        }
      }
    `,
    networksMembers: (fields) => gql `
      query networksMembers($after: String
$before: String
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean
$roleType: RoleType
$status: [MemberStatus!]) {
        networksMembers(after: $after
before: $before
limit: $limit
offset: $offset
query: $query
reverse: $reverse
roleType: $roleType
status: $status) {
          ${PaginatedPluralMemberGQLFields(fields)}
        }
      }
    `,
    newDomainStatus: (fields) => gql `
      query newDomainStatus($domain: String!) {
        newDomainStatus(domain: $domain) {
          ${DomainTransferStatusGQLFields(fields)}
        }
      }
    `,
    notifications: (fields) => gql `
      query notifications($after: String
$limit: Int!) {
        notifications(after: $after
limit: $limit) {
          ${PaginatedNotificationGQLFields(fields)}
        }
      }
    `,
    notificationsCount: (fields) => gql `
      query notificationsCount {
        notificationsCount {
          ${NotificationsCountGQLFields(fields)}
        }
      }
    `,
    oAuthCode: (fields) => gql `
      query oAuthCode($input: OAuthCodeInput!) {
        oAuthCode(input: $input) {
          ${OAuthCodeGQLFields(fields)}
        }
      }
    `,
    oAuthTokens: (fields) => gql `
      query oAuthTokens($input: OAuthTokenInput!) {
        oAuthTokens(input: $input) {
          ${OAuthTokensGQLFields(fields)}
        }
      }
    `,
    page: (fields) => gql `
      query page($path: String!) {
        page(path: $path) {
          ${PageGQLFields(fields)}
        }
      }
    `,
    passwordComplexity: (fields) => gql `
      query passwordComplexity($password: String!) {
        passwordComplexity(password: $password) {
          ${PasswordComplexityGQLFields(fields)}
        }
      }
    `,
    permission: (fields) => gql `
      query permission($id: ID!) {
        permission(id: $id) {
          ${PermissionGQLFields(fields)}
        }
      }
    `,
    permissions: (fields) => gql `
      query permissions {
        permissions {
          ${PermissionGQLFields(fields)}
        }
      }
    `,
    post: (fields) => gql `
      query post($id: ID!) {
        post(id: $id) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    postModerationItems: (fields) => gql `
      query postModerationItems($after: String
$before: String
$entityId: String
$flaggedBy: FlaggedType
$limit: Int!
$offset: Int
$reverse: Boolean
$spaceId: String
$status: ModerationStatus) {
        postModerationItems(after: $after
before: $before
entityId: $entityId
flaggedBy: $flaggedBy
limit: $limit
offset: $offset
reverse: $reverse
spaceId: $spaceId
status: $status) {
          ${PaginatedModerationGQLFields(fields)}
        }
      }
    `,
    postReactionParticipants: (fields) => gql `
      query postReactionParticipants($after: String
$before: String
$limit: Int!
$offset: Int
$postId: ID!
$reaction: ID!
$reverse: Boolean) {
        postReactionParticipants(after: $after
before: $before
limit: $limit
offset: $offset
postId: $postId
reaction: $reaction
reverse: $reverse) {
          ${PaginatedPostReactionParticipantGQLFields(fields)}
        }
      }
    `,
    postType: (fields) => gql `
      query postType($id: ID!) {
        postType(id: $id) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    postTypes: (fields) => gql `
      query postTypes($after: String
$before: String
$context: PostTypeContext
$limit: Int!
$offset: Int
$query: String
$reverse: Boolean) {
        postTypes(after: $after
before: $before
context: $context
limit: $limit
offset: $offset
query: $query
reverse: $reverse) {
          ${PaginatedPostTypeGQLFields(fields)}
        }
      }
    `,
    posts: (fields) => gql `
      query posts($after: String
$before: String
$excludePins: Boolean
$filterBy: [PostListFilterByInput!]
$limit: Int!
$offset: Int
$orderBy: PostListOrderByEnum
$orderByString: String
$postTypeIds: [String!]
$reverse: Boolean
$spaceIds: [ID!]) {
        posts(after: $after
before: $before
excludePins: $excludePins
filterBy: $filterBy
limit: $limit
offset: $offset
orderBy: $orderBy
orderByString: $orderByString
postTypeIds: $postTypeIds
reverse: $reverse
spaceIds: $spaceIds) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    postsByIds: (fields) => gql `
      query postsByIds($ids: [ID!]!
$statuses: [ID!]) {
        postsByIds(ids: $ids
statuses: $statuses) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    privateMessage: (fields) => gql `
      query privateMessage($input: PrivateMessageInput!) {
        privateMessage(input: $input) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    products: (fields) => gql `
      query products {
        products {
          ${ProductGQLFields(fields)}
        }
      }
    `,
    redirect: (fields) => gql `
      query redirect($url: String!) {
        redirect(url: $url) {
          ${RedirectGQLFields(fields)}
        }
      }
    `,
    replies: (fields) => gql `
      query replies($after: String
$before: String
$excludePins: Boolean
$limit: Int!
$offset: Int
$orderBy: PostListOrderByEnum
$postId: ID!
$reverse: Boolean) {
        replies(after: $after
before: $before
excludePins: $excludePins
limit: $limit
offset: $offset
orderBy: $orderBy
postId: $postId
reverse: $reverse) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    report: (fields) => gql `
      query report($input: ReportInput!
$spaceId: String) {
        report(input: $input
spaceId: $spaceId) {
          ${ReportGQLFields(fields)}
        }
      }
    `,
    roles: (fields) => gql `
      query roles($orderBy: RoleListOrderByEnum
$reverse: Boolean) {
        roles(orderBy: $orderBy
reverse: $reverse) {
          ${RoleGQLFields(fields)}
        }
      }
    `,
    scopes: (fields) => gql `
      query scopes($contexts: [PermissionsContextInput!]) {
        scopes(contexts: $contexts) {
          ${ScopesGQLFields(fields)}
        }
      }
    `,
    search: (fields) => gql `
      query search($input: SearchInput!) {
        search(input: $input) {
          ${SearchResultGQLFields(fields)}
        }
      }
    `,
    space: (fields) => gql `
      query space($id: ID
$path: String
$slug: ID) {
        space(id: $id
path: $path
slug: $slug) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    spaceDefaultNotificationSettings: (fields) => gql `
      query spaceDefaultNotificationSettings($spaceId: ID!) {
        spaceDefaultNotificationSettings(spaceId: $spaceId) {
          ${SpaceDefaultNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    spaceMember: (fields) => gql `
      query spaceMember($memberId: ID!
$spaceId: ID!) {
        spaceMember(memberId: $memberId
spaceId: $spaceId) {
          ${SpaceMemberGQLFields(fields)}
        }
      }
    `,
    spaceMembers: (fields) => gql `
      query spaceMembers($after: String
$before: String
$limit: Int!
$offset: Int
$orderBy: SpaceMemberListOrderByEnum
$reverse: Boolean
$roleIds: [ID!]
$spaceId: ID!) {
        spaceMembers(after: $after
before: $before
limit: $limit
offset: $offset
orderBy: $orderBy
reverse: $reverse
roleIds: $roleIds
spaceId: $spaceId) {
          ${PaginatedSpaceMemberGQLFields(fields)}
        }
      }
    `,
    spaceMembershipRequests: (fields) => gql `
      query spaceMembershipRequests($spaceId: ID!
$status: SpaceJoinRequestStatus) {
        spaceMembershipRequests(spaceId: $spaceId
status: $status) {
          ${SpaceJoinRequestGQLFields(fields)}
        }
      }
    `,
    spacePinnedPosts: (fields) => gql `
      query spacePinnedPosts($spaceId: ID!) {
        spacePinnedPosts(spaceId: $spaceId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    spacePostType: (fields) => gql `
      query spacePostType($postTypeId: ID!
$spaceId: ID!) {
        spacePostType(postTypeId: $postTypeId
spaceId: $spaceId) {
          ${SpacePostTypeGQLFields(fields)}
        }
      }
    `,
    spacePostTypes: (fields) => gql `
      query spacePostTypes($after: String
$before: String
$context: PostTypeContext
$limit: Int!
$offset: Int
$reverse: Boolean
$spaceId: ID!) {
        spacePostTypes(after: $after
before: $before
context: $context
limit: $limit
offset: $offset
reverse: $reverse
spaceId: $spaceId) {
          ${PaginatedSpacePostTypeGQLFields(fields)}
        }
      }
    `,
    spaceRoles: (fields) => gql `
      query spaceRoles($orderBy: SpaceRoleListOrderByEnum
$reverse: Boolean
$spaceId: ID) {
        spaceRoles(orderBy: $orderBy
reverse: $reverse
spaceId: $spaceId) {
          ${SpaceRoleGQLFields(fields)}
        }
      }
    `,
    spaces: (fields) => gql `
      query spaces($after: String
$before: String
$collectionId: String
$limit: Int!
$memberId: ID
$offset: Int
$orderBy: SpaceListOrderByEnum
$query: String
$reverse: Boolean
$type: [SpaceType!]) {
        spaces(after: $after
before: $before
collectionId: $collectionId
limit: $limit
memberId: $memberId
offset: $offset
orderBy: $orderBy
query: $query
reverse: $reverse
type: $type) {
          ${PaginatedSpaceGQLFields(fields)}
        }
      }
    `,
    spacesByIds: (fields) => gql `
      query spacesByIds($ids: [ID!]!) {
        spacesByIds(ids: $ids) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    spacesBySlugs: (fields) => gql `
      query spacesBySlugs($slugs: [String!]!) {
        spacesBySlugs(slugs: $slugs) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    ssoMemberships: (fields) => gql `
      query ssoMemberships($memberId: String!) {
        ssoMemberships(memberId: $memberId) {
          ${SsoMembershipGQLFields(fields)}
        }
      }
    `,
    ssoUrl: (fields) => gql `
      query ssoUrl($input: SsoUrlInput!) {
        ssoUrl(input: $input) {
          ${SsoUrlGQLFields(fields)}
        }
      }
    `,
    ssos: (fields) => gql `
      query ssos($status: SsoStatus) {
        ssos(status: $status) {
          ${SsoGQLFields(fields)}
        }
      }
    `,
    subscription: (fields) => gql `
      query subscription($input: subscriptionInput!) {
        subscription(input: $input) {
          ${SubscriptionGQLFields(fields)}
        }
      }
    `,
    supportNetworkTokens: (fields) => gql `
      query supportNetworkTokens($networkId: String!) {
        supportNetworkTokens(networkId: $networkId) {
          ${SupportLimitedAuthTokenGQLFields(fields)}
        }
      }
    `,
    supportSsoUrl: (fields) => gql `
      query supportSsoUrl($input: SupportSsoUrlInput) {
        supportSsoUrl(input: $input) {
          ${SupportSsoUrlGQLFields(fields)}
        }
      }
    `,
    systemSpaces: (fields) => gql `
      query systemSpaces {
        systemSpaces {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    tagPosts: (fields) => gql `
      query tagPosts($after: String
$before: String
$limit: Int!
$offset: Int
$reverse: Boolean
$spaceId: ID
$tagId: ID
$tagSlug: String) {
        tagPosts(after: $after
before: $before
limit: $limit
offset: $offset
reverse: $reverse
spaceId: $spaceId
tagId: $tagId
tagSlug: $tagSlug) {
          ${PaginatedPostGQLFields(fields)}
        }
      }
    `,
    tags: (fields) => gql `
      query tags($after: String
$before: String
$ids: [ID!]
$limit: Int!
$offset: Int
$orderBy: TagsOrderByEnum
$query: String
$reverse: Boolean
$spaceId: ID) {
        tags(after: $after
before: $before
ids: $ids
limit: $limit
offset: $offset
orderBy: $orderBy
query: $query
reverse: $reverse
spaceId: $spaceId) {
          ${PaginatedTagGQLFields(fields)}
        }
      }
    `,
    templateRequest: (fields) => gql `
      query templateRequest($id: String!) {
        templateRequest(id: $id) {
          ${TemplateRequestGQLFields(fields)}
        }
      }
    `,
    templates: (fields) => gql `
      query templates($after: String
$before: String
$entityTypes: [TemplateEntityType!]
$limit: Int!
$offset: Int
$reverse: Boolean
$status: StoreItemStatus) {
        templates(after: $after
before: $before
entityTypes: $entityTypes
limit: $limit
offset: $offset
reverse: $reverse
status: $status) {
          ${PaginatedTemplateGQLFields(fields)}
        }
      }
    `,
    tokens: (fields) => gql `
      query tokens($networkDomain: String
$networkId: ID
$otp: String
$refreshToken: String
$ssoToken: String) {
        tokens(networkDomain: $networkDomain
networkId: $networkId
otp: $otp
refreshToken: $refreshToken
ssoToken: $ssoToken) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    translateMarkup: () => gql `
    query translateMarkup(
      $format: TranslationMarkupFormat
      $input: [TranslationMarkupInput!]
      $markups: [String!]
    ) {
      translateMarkup(format: $format, input: $input, markups: $markups)
    }
  `,
    usernameAvailability: (fields) => gql `
      query usernameAvailability($username: String!) {
        usernameAvailability(username: $username) {
          ${UsernameAvailabilityGQLFields(fields)}
        }
      }
    `,
    vatTypes: (fields) => gql `
      query vatTypes {
        vatTypes {
          ${VatTypeInfoGQLFields(fields)}
        }
      }
    `,
};
export const MutationFunctions = {
    addEmoji: (fields) => gql `
      mutation addEmoji($input: CreateEmojiInput!) {
        addEmoji(input: $input) {
          ${EmojiGQLFields(fields)}
        }
      }
    `,
    addEmojis: (fields) => gql `
      mutation addEmojis($input: [CreateEmojiInput!]!) {
        addEmojis(input: $input) {
          ${EmojiGQLFields(fields)}
        }
      }
    `,
    addGroup: (fields) => gql `
      mutation addGroup($input: CreateCollectionInput!) {
        addGroup(input: $input) {
          ${CollectionGQLFields(fields)}
        }
      }
    `,
    addImage: (fields) => gql `
      mutation addImage($input: CreateImageInput!) {
        addImage(input: $input) {
          ${SignedUrlGQLFields(fields)}
        }
      }
    `,
    addImages: (fields) => gql `
      mutation addImages($input: [CreateImageInput!]!) {
        addImages(input: $input) {
          ${SignedUrlGQLFields(fields)}
        }
      }
    `,
    addMedias: (fields) => gql `
      mutation addMedias($input: AddMediasInput!) {
        addMedias(input: $input) {
          ${SignedUrlGQLFields(fields)}
        }
      }
    `,
    addMemberSchemaField: (fields) => gql `
      mutation addMemberSchemaField($input: CustomFieldSchemaInput!) {
        addMemberSchemaField(input: $input) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    addModerationReport: (fields) => gql `
      mutation addModerationReport($input: CreateReportInput!) {
        addModerationReport(input: $input) {
          ${ModerationItemGQLFields(fields)}
        }
      }
    `,
    addNetwork: (fields) => gql `
      mutation addNetwork($input: AddNetworkInput!) {
        addNetwork(input: $input) {
          ${AuthTokenWithOtpGQLFields(fields)}
        }
      }
    `,
    addNewDomain: (fields) => gql `
      mutation addNewDomain($input: DomainAvailabilityInput!) {
        addNewDomain(input: $input) {
          ${DomainTransferStatusGQLFields(fields)}
        }
      }
    `,
    addPost: (fields) => gql `
      mutation addPost($input: CreatePostInput!
$spaceId: ID!) {
        addPost(input: $input
spaceId: $spaceId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    addPostTypeField: (fields) => gql `
      mutation addPostTypeField($id: ID!
$input: CustomFieldSchemaInput!) {
        addPostTypeField(id: $id
input: $input) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    addReaction: (fields) => gql `
      mutation addReaction($input: AddReactionInput!
$postId: ID!) {
        addReaction(input: $input
postId: $postId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    addReply: (fields) => gql `
      mutation addReply($input: CreatePostInput!
$postId: ID!) {
        addReply(input: $input
postId: $postId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    addSpace: (fields) => gql `
      mutation addSpace($input: CreateSpaceInput!) {
        addSpace(input: $input) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    addSpaceMembers: (fields) => gql `
      mutation addSpaceMembers($input: [AddSpaceMemberInput!]!
$spaceId: ID!) {
        addSpaceMembers(input: $input
spaceId: $spaceId) {
          ${SpaceMemberGQLFields(fields)}
        }
      }
    `,
    addTrialPlan: (fields) => gql `
      mutation addTrialPlan($trial: AddTrialInput!) {
        addTrialPlan(trial: $trial) {
          ${PlanGQLFields(fields)}
        }
      }
    `,
    approveSpaceJoinRequest: (fields) => gql `
      mutation approveSpaceJoinRequest($spaceId: ID!
$spaceJoinRequestId: ID!) {
        approveSpaceJoinRequest(spaceId: $spaceId
spaceJoinRequestId: $spaceJoinRequestId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    approveSpaceMembershipRequest: (fields) => gql `
      mutation approveSpaceMembershipRequest($spaceId: ID!
$spaceMembershipRequestId: ID!) {
        approveSpaceMembershipRequest(spaceId: $spaceId
spaceMembershipRequestId: $spaceMembershipRequestId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    archiveMemberSchemaField: (fields) => gql `
      mutation archiveMemberSchemaField($key: String!) {
        archiveMemberSchemaField(key: $key) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    archivePostTypeField: (fields) => gql `
      mutation archivePostTypeField($id: ID!
$key: String!) {
        archivePostTypeField(id: $id
key: $key) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    assignBadge: (fields) => gql `
      mutation assignBadge($id: String!
$input: AssignOrRevokeBadgeInput!) {
        assignBadge(id: $id
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    blockMember: (fields) => gql `
      mutation blockMember($memberId: String!) {
        blockMember(memberId: $memberId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    callback: (fields) => gql `
      mutation callback($appId: ID!
$callbackId: ID!
$context: PermissionContext!
$dynamicBlockId: ID
$entityId: ID
$inputs: String) {
        callback(appId: $appId
callbackId: $callbackId
context: $context
dynamicBlockId: $dynamicBlockId
entityId: $entityId
inputs: $inputs) {
          ${CallbackResponseGQLFields(fields)}
        }
      }
    `,
    cancelEmailUpdate: (fields) => gql `
      mutation cancelEmailUpdate($id: ID) {
        cancelEmailUpdate(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    changeNetworkSubscriptionPlan: (fields) => gql `
      mutation changeNetworkSubscriptionPlan($name: PlanName!) {
        changeNetworkSubscriptionPlan(name: $name) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    clearNewDomain: (fields) => gql `
      mutation clearNewDomain {
        clearNewDomain {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    clearNotificationsCount: (fields) => gql `
      mutation clearNotificationsCount {
        clearNotificationsCount {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    closeSpace: (fields) => gql `
      mutation closeSpace($spaceId: ID!) {
        closeSpace(spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    confirmMassActionRequest: (fields) => gql `
      mutation confirmMassActionRequest($massActionRequestId: String!) {
        confirmMassActionRequest(massActionRequestId: $massActionRequestId) {
          ${MassActionRequestGQLFields(fields)}
        }
      }
    `,
    confirmResetPassword: (fields) => gql `
      mutation confirmResetPassword($input: ConfirmResetPasswordInput!) {
        confirmResetPassword(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    createAccessGroup: (fields) => gql `
      mutation createAccessGroup($input: CreateAccessGroupInput!) {
        createAccessGroup(input: $input) {
          ${AccessGroupGQLFields(fields)}
        }
      }
    `,
    createBadge: (fields) => gql `
      mutation createBadge($input: CreateBadgeInput!) {
        createBadge(input: $input) {
          ${BadgeGQLFields(fields)}
        }
      }
    `,
    createCollection: (fields) => gql `
      mutation createCollection($input: CreateCollectionInput!) {
        createCollection(input: $input) {
          ${CollectionGQLFields(fields)}
        }
      }
    `,
    createEmojis: (fields) => gql `
      mutation createEmojis($input: [CreateEmojiInput!]!) {
        createEmojis(input: $input) {
          ${EmojiGQLFields(fields)}
        }
      }
    `,
    createExportMemberRequest: (fields) => gql `
      mutation createExportMemberRequest($input: ExportInput!) {
        createExportMemberRequest(input: $input) {
          ${ExportGQLFields(fields)}
        }
      }
    `,
    createFiles: (fields) => gql `
      mutation createFiles($input: [CreateFileInput!]!) {
        createFiles(input: $input) {
          ${SignedUrlGQLFields(fields)}
        }
      }
    `,
    createImages: (fields) => gql `
      mutation createImages($input: [CreateImageInput!]!) {
        createImages(input: $input) {
          ${SignedUrlGQLFields(fields)}
        }
      }
    `,
    createMassActionRequest: (fields) => gql `
      mutation createMassActionRequest($input: MassActionRequestInput!) {
        createMassActionRequest(input: $input) {
          ${MassActionRequestGQLFields(fields)}
        }
      }
    `,
    createModerationReport: (fields) => gql `
      mutation createModerationReport($input: CreateReportInput!) {
        createModerationReport(input: $input) {
          ${ModerationItemGQLFields(fields)}
        }
      }
    `,
    createNetwork: (fields) => gql `
      mutation createNetwork($input: AddNetworkInput!) {
        createNetwork(input: $input) {
          ${AuthTokenWithOtpGQLFields(fields)}
        }
      }
    `,
    createPermission: (fields) => gql `
      mutation createPermission($input: CreatePermissionInput!) {
        createPermission(input: $input) {
          ${PermissionGQLFields(fields)}
        }
      }
    `,
    createPost: (fields) => gql `
      mutation createPost($input: CreatePostInput!
$spaceId: ID!) {
        createPost(input: $input
spaceId: $spaceId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    createPostType: (fields) => gql `
      mutation createPostType($input: CreatePostTypeInput!) {
        createPostType(input: $input) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    createReply: (fields) => gql `
      mutation createReply($input: CreatePostInput!
$postId: ID!) {
        createReply(input: $input
postId: $postId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    createReport: (fields) => gql `
      mutation createReport($input: CreateReportInput!) {
        createReport(input: $input) {
          ${ModerationItemGQLFields(fields)}
        }
      }
    `,
    createSpace: (fields) => gql `
      mutation createSpace($input: CreateSpaceInput!) {
        createSpace(input: $input) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    createSpaceFromTemplate: (fields) => gql `
      mutation createSpaceFromTemplate($input: CreateSpaceInput!
$style: String
$templateId: String!) {
        createSpaceFromTemplate(input: $input
style: $style
templateId: $templateId) {
          ${TemplateRequestGQLFields(fields)}
        }
      }
    `,
    createTag: (fields) => gql `
      mutation createTag($input: CreateTagInput!
$spaceId: ID) {
        createTag(input: $input
spaceId: $spaceId) {
          ${TagGQLFields(fields)}
        }
      }
    `,
    createTemplate: (fields) => gql `
      mutation createTemplate($input: CreateTemplateInput!) {
        createTemplate(input: $input) {
          ${TemplateGQLFields(fields)}
        }
      }
    `,
    declineSpaceJoinRequest: (fields) => gql `
      mutation declineSpaceJoinRequest($spaceId: ID!
$spaceJoinRequestId: ID!) {
        declineSpaceJoinRequest(spaceId: $spaceId
spaceJoinRequestId: $spaceJoinRequestId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    declineSpaceMembershipRequest: (fields) => gql `
      mutation declineSpaceMembershipRequest($spaceId: ID!
$spaceMembershipRequestId: ID!) {
        declineSpaceMembershipRequest(spaceId: $spaceId
spaceMembershipRequestId: $spaceMembershipRequestId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteAccessGroup: (fields) => gql `
      mutation deleteAccessGroup($id: ID!) {
        deleteAccessGroup(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteBadge: (fields) => gql `
      mutation deleteBadge($id: String!) {
        deleteBadge(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteCollection: (fields) => gql `
      mutation deleteCollection($id: ID!) {
        deleteCollection(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteMember: (fields) => gql `
      mutation deleteMember($id: ID!) {
        deleteMember(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteMemberSchemaField: (fields) => gql `
      mutation deleteMemberSchemaField($key: String!) {
        deleteMemberSchemaField(key: $key) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    deleteNetwork: (fields) => gql `
      mutation deleteNetwork {
        deleteNetwork {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteNotification: (fields) => gql `
      mutation deleteNotification($notificationId: ID!) {
        deleteNotification(notificationId: $notificationId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteNotifications: (fields) => gql `
      mutation deleteNotifications($ids: [ID!]) {
        deleteNotifications(ids: $ids) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deletePermission: (fields) => gql `
      mutation deletePermission($id: ID!) {
        deletePermission(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deletePost: (fields) => gql `
      mutation deletePost($id: ID!) {
        deletePost(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deletePostTypeField: (fields) => gql `
      mutation deletePostTypeField($id: ID!
$key: String!) {
        deletePostTypeField(id: $id
key: $key) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    deleteSpace: (fields) => gql `
      mutation deleteSpace($id: ID!) {
        deleteSpace(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteSpacePostTypes: (fields) => gql `
      mutation deleteSpacePostTypes($postTypeIds: [ID!]!
$spaceId: ID!) {
        deleteSpacePostTypes(postTypeIds: $postTypeIds
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteSsoMembership: (fields) => gql `
      mutation deleteSsoMembership($memberId: String!
$type: SsoType!) {
        deleteSsoMembership(memberId: $memberId
type: $type) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteTag: (fields) => gql `
      mutation deleteTag($id: ID!) {
        deleteTag(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    deleteTemplate: (fields) => gql `
      mutation deleteTemplate($id: String!) {
        deleteTemplate(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    doResetPassword: (fields) => gql `
      mutation doResetPassword($input: UpdatePasswordWithTokenInput!) {
        doResetPassword(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    editImage: (fields) => gql `
      mutation editImage($imageId: String!
$input: UpdateImageInput!) {
        editImage(imageId: $imageId
input: $input) {
          ${ImageGQLFields(fields)}
        }
      }
    `,
    extendCurrentTrial: (fields) => gql `
      mutation extendCurrentTrial($newEndDate: DateTime!) {
        extendCurrentTrial(newEndDate: $newEndDate) {
          ${PlanGQLFields(fields)}
        }
      }
    `,
    globalAddAppCollaborator: (fields) => gql `
      mutation globalAddAppCollaborator($appId: String!
$input: AddAppCollaboratorInput!) {
        globalAddAppCollaborator(appId: $appId
input: $input) {
          ${AppCollaboratorGQLFields(fields)}
        }
      }
    `,
    globalCreateApp: (fields) => gql `
      mutation globalCreateApp($input: CreateAppInput!) {
        globalCreateApp(input: $input) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    globalCreateEmojis: (fields) => gql `
      mutation globalCreateEmojis($input: [CreateEmojiInput!]!) {
        globalCreateEmojis(input: $input) {
          ${EmojiGQLFields(fields)}
        }
      }
    `,
    globalCreateImages: (fields) => gql `
      mutation globalCreateImages($input: [CreateImageInput!]!) {
        globalCreateImages(input: $input) {
          ${SignedUrlGQLFields(fields)}
        }
      }
    `,
    globalDeleteApp: (fields) => gql `
      mutation globalDeleteApp($id: ID!) {
        globalDeleteApp(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    globalDeleteAppSetting: (fields) => gql `
      mutation globalDeleteAppSetting($context: PermissionContext!
$entityId: ID
$networkId: ID!) {
        globalDeleteAppSetting(context: $context
entityId: $entityId
networkId: $networkId) {
          ${AppSettingGQLFields(fields)}
        }
      }
    `,
    globalPublishAppPrivately: (fields) => gql `
      mutation globalPublishAppPrivately($appId: ID!
$networkId: ID!) {
        globalPublishAppPrivately(appId: $appId
networkId: $networkId) {
          ${AppPublicationGQLFields(fields)}
        }
      }
    `,
    globalRegenerateClientSecret: (fields) => gql `
      mutation globalRegenerateClientSecret($appId: ID!) {
        globalRegenerateClientSecret(appId: $appId) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    globalRemoveAppCollaborator: (fields) => gql `
      mutation globalRemoveAppCollaborator($appId: String!
$collaboratorId: String!) {
        globalRemoveAppCollaborator(appId: $appId
collaboratorId: $collaboratorId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    globalTestAppWebhook: (fields) => gql `
      mutation globalTestAppWebhook($appId: ID!
$input: TestAppWebhookInput!) {
        globalTestAppWebhook(appId: $appId
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    globalUnPublishAppPrivately: (fields) => gql `
      mutation globalUnPublishAppPrivately($appId: ID!
$networkId: ID!) {
        globalUnPublishAppPrivately(appId: $appId
networkId: $networkId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    globalUpdateApp: (fields) => gql `
      mutation globalUpdateApp($id: ID!
$input: UpdateAppInput!) {
        globalUpdateApp(id: $id
input: $input) {
          ${AppGQLFields(fields)}
        }
      }
    `,
    globalUpdateAppSetting: (fields) => gql `
      mutation globalUpdateAppSetting($context: PermissionContext!
$entityId: ID
$networkId: ID!
$settings: String!) {
        globalUpdateAppSetting(context: $context
entityId: $entityId
networkId: $networkId
settings: $settings) {
          ${AppSettingGQLFields(fields)}
        }
      }
    `,
    hidePost: (fields) => gql `
      mutation hidePost($id: ID!) {
        hidePost(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    impersonateLoginToNetwork: (fields) => gql `
      mutation impersonateLoginToNetwork($input: ImpersonateLoginToNetworkInput!) {
        impersonateLoginToNetwork(input: $input) {
          ${AuthInfoWithOtpGQLFields(fields)}
        }
      }
    `,
    installApp: (fields) => gql `
      mutation installApp($appId: ID!
$input: InstallAppInput) {
        installApp(appId: $appId
input: $input) {
          ${AppInstallationGQLFields(fields)}
        }
      }
    `,
    installAppOnAuthMember: (fields) => gql `
      mutation installAppOnAuthMember($appId: ID!
$input: InstallAppInput) {
        installAppOnAuthMember(appId: $appId
input: $input) {
          ${AppInstallationGQLFields(fields)}
        }
      }
    `,
    interactWithApps: (fields) => gql `
      mutation interactWithApps($context: PermissionContext!
$entityId: ID
$input: [InteractWithAppInput!]!) {
        interactWithApps(context: $context
entityId: $entityId
input: $input) {
          ${AppInteractionGQLFields(fields)}
        }
      }
    `,
    inviteMembers: (fields) => gql `
      mutation inviteMembers($input: InviteMembersInput!) {
        inviteMembers(input: $input) {
          ${MemberInvitationGQLFields(fields)}
        }
      }
    `,
    joinNetwork: (fields) => gql `
      mutation joinNetwork($input: JoinNetworkInput!) {
        joinNetwork(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    joinNetworkWithInvitationLink: (fields) => gql `
      mutation joinNetworkWithInvitationLink($input: JoinNetworkWithLinkInput!) {
        joinNetworkWithInvitationLink(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    joinNetworkWithToken: (fields) => gql `
      mutation joinNetworkWithToken($input: JoinNetworkWithTokenInput!) {
        joinNetworkWithToken(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    joinSpace: (fields) => gql `
      mutation joinSpace($spaceId: ID!) {
        joinSpace(spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    leaveSpace: (fields) => gql `
      mutation leaveSpace($spaceId: ID!) {
        leaveSpace(spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    loginNetwork: (fields) => gql `
      mutation loginNetwork($input: LoginNetworkWithPasswordInput!) {
        loginNetwork(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    loginNetworkWithPassword: (fields) => gql `
      mutation loginNetworkWithPassword($input: LoginNetworkWithPasswordInput!) {
        loginNetworkWithPassword(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    loginWithSamlResponse: (fields) => gql `
      mutation loginWithSamlResponse($input: LoginWithSamlResponseInput!) {
        loginWithSamlResponse(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    loginWithSsoCode: (fields) => gql `
      mutation loginWithSsoCode($input: LoginWithSsoCodeInput!) {
        loginWithSsoCode(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    logoutMemberSessions: (fields) => gql `
      mutation logoutMemberSessions($memberId: String!) {
        logoutMemberSessions(memberId: $memberId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    logoutNetwork: (fields) => gql `
      mutation logoutNetwork($input: LogoutNetworkInput) {
        logoutNetwork(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    movePost: (fields) => gql `
      mutation movePost($id: ID!
$sendNotification: Boolean
$spaceId: ID!) {
        movePost(id: $id
sendNotification: $sendNotification
spaceId: $spaceId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    movePosts: (fields) => gql `
      mutation movePosts($ids: [ID!]!
$sendNotification: Boolean
$spaceId: ID!) {
        movePosts(ids: $ids
sendNotification: $sendNotification
spaceId: $spaceId) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    organizeCollections: (fields) => gql `
      mutation organizeCollections($ids: [String!]!) {
        organizeCollections(ids: $ids) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    organizeGroupSpaces: (fields) => gql `
      mutation organizeGroupSpaces($groupId: String!
$spaceIds: [String!]!) {
        organizeGroupSpaces(groupId: $groupId
spaceIds: $spaceIds) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    organizeGroups: (fields) => gql `
      mutation organizeGroups($groupIds: [String!]!) {
        organizeGroups(groupIds: $groupIds) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    organizeSpacesInCollection: (fields) => gql `
      mutation organizeSpacesInCollection($collectionId: String!
$spaceIds: [String!]!) {
        organizeSpacesInCollection(collectionId: $collectionId
spaceIds: $spaceIds) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    pinPostToSpace: (fields) => gql `
      mutation pinPostToSpace($postId: ID!) {
        pinPostToSpace(postId: $postId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    pinReplyToPost: (fields) => gql `
      mutation pinReplyToPost($postId: ID!
$replyId: ID!) {
        pinReplyToPost(postId: $postId
replyId: $replyId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    publishAppPrivately: (fields) => gql `
      mutation publishAppPrivately($appId: ID!) {
        publishAppPrivately(appId: $appId) {
          ${AppPublicationGQLFields(fields)}
        }
      }
    `,
    publishTemplate: (fields) => gql `
      mutation publishTemplate($id: String!) {
        publishTemplate(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    purchase: (fields) => gql `
      mutation purchase($input: PurchaseInput!) {
        purchase(input: $input) {
          ${SubscriptionGQLFields(fields)}
        }
      }
    `,
    readNotification: (fields) => gql `
      mutation readNotification($notificationId: ID!) {
        readNotification(notificationId: $notificationId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    readNotifications: (fields) => gql `
      mutation readNotifications($ids: [ID!]) {
        readNotifications(ids: $ids) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    readSpace: (fields) => gql `
      mutation readSpace($date: DateTime!
$spaceId: String!) {
        readSpace(date: $date
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    removeGroup: (fields) => gql `
      mutation removeGroup($groupId: ID) {
        removeGroup(groupId: $groupId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    removeMember: (fields) => gql `
      mutation removeMember($memberId: ID!) {
        removeMember(memberId: $memberId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    removeNetwork: (fields) => gql `
      mutation removeNetwork {
        removeNetwork {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    removePost: (fields) => gql `
      mutation removePost($postId: ID!) {
        removePost(postId: $postId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    removeReaction: (fields) => gql `
      mutation removeReaction($participantId: String
$postId: ID!
$reaction: String!) {
        removeReaction(participantId: $participantId
postId: $postId
reaction: $reaction) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    removeSpace: (fields) => gql `
      mutation removeSpace($spaceId: ID!) {
        removeSpace(spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    removeSpaceMembers: (fields) => gql `
      mutation removeSpaceMembers($memberIds: [ID!]!
$spaceId: ID!) {
        removeSpaceMembers(memberIds: $memberIds
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    reorderMemberSchemaFields: (fields) => gql `
      mutation reorderMemberSchemaFields($input: [ReOrderSchemaFieldInput!]!) {
        reorderMemberSchemaFields(input: $input) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    reorderPostTypeFields: (fields) => gql `
      mutation reorderPostTypeFields($id: ID!
$input: [ReOrderSchemaFieldInput!]!) {
        reorderPostTypeFields(id: $id
input: $input) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    requestGlobalTokenCode: (fields) => gql `
      mutation requestGlobalTokenCode($input: RequestGlobalTokenInput!) {
        requestGlobalTokenCode(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    requestSpaceMembership: (fields) => gql `
      mutation requestSpaceMembership($spaceId: ID!) {
        requestSpaceMembership(spaceId: $spaceId) {
          ${SpaceJoinRequestGQLFields(fields)}
        }
      }
    `,
    resendGlobalTokenCode: (fields) => gql `
      mutation resendGlobalTokenCode($input: RequestGlobalTokenInput!) {
        resendGlobalTokenCode(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    resendMemberInvitation: (fields) => gql `
      mutation resendMemberInvitation($id: ID!) {
        resendMemberInvitation(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    resendVerification: (fields) => gql `
      mutation resendVerification {
        resendVerification {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    resetPassword: (fields) => gql `
      mutation resetPassword($input: ResetPasswordInput!) {
        resetPassword(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    revokeBadge: (fields) => gql `
      mutation revokeBadge($id: String!
$input: AssignOrRevokeBadgeInput!) {
        revokeBadge(id: $id
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    revokeMemberInvitation: (fields) => gql `
      mutation revokeMemberInvitation($id: ID!) {
        revokeMemberInvitation(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    runMigration: (fields) => gql `
      mutation runMigration($id: String!) {
        runMigration(id: $id) {
          ${MigrationGQLFields(fields)}
        }
      }
    `,
    sendResetPasswordEmail: (fields) => gql `
      mutation sendResetPasswordEmail($email: String!) {
        sendResetPasswordEmail(email: $email) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    setPrivatelyPublishedApps: (fields) => gql `
      mutation setPrivatelyPublishedApps($ids: [ID!]!) {
        setPrivatelyPublishedApps(ids: $ids) {
          ${AppPublicationGQLFields(fields)}
        }
      }
    `,
    ssoRedirect: (fields) => gql `
      mutation ssoRedirect($input: LoginWithSsoCodeInput!) {
        ssoRedirect(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
    supportSsoRedirect: (fields) => gql `
      mutation supportSsoRedirect($input: LoginSupportWithSsoCodeInput!) {
        supportSsoRedirect(input: $input) {
          ${SupportAuthTokenGQLFields(fields)}
        }
      }
    `,
    suspendMember: (fields) => gql `
      mutation suspendMember($memberId: String!) {
        suspendMember(memberId: $memberId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    syncTemplate: (fields) => gql `
      mutation syncTemplate($id: String!) {
        syncTemplate(id: $id) {
          ${TemplateGQLFields(fields)}
        }
      }
    `,
    transferToNewDomain: (fields) => gql `
      mutation transferToNewDomain {
        transferToNewDomain {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    unArchiveMemberSchemaField: (fields) => gql `
      mutation unArchiveMemberSchemaField($key: String!) {
        unArchiveMemberSchemaField(key: $key) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    unPublishAppPrivately: () => gql `
    mutation unPublishAppPrivately($appId: ID!, $networkId: ID!) {
      unPublishAppPrivately(appId: $appId, networkId: $networkId)
    }
  `,
    unarchivePostTypeField: (fields) => gql `
      mutation unarchivePostTypeField($id: ID!
$key: String!) {
        unarchivePostTypeField(id: $id
key: $key) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    unblockMember: (fields) => gql `
      mutation unblockMember($memberId: String!) {
        unblockMember(memberId: $memberId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    unhidePost: (fields) => gql `
      mutation unhidePost($id: ID!) {
        unhidePost(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    uninstallApp: (fields) => gql `
      mutation uninstallApp($appInstallationId: ID!
$reason: String) {
        uninstallApp(appInstallationId: $appInstallationId
reason: $reason) {
          ${AppInstallationGQLFields(fields)}
        }
      }
    `,
    unpinPostFromSpace: (fields) => gql `
      mutation unpinPostFromSpace($postId: ID!) {
        unpinPostFromSpace(postId: $postId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    unpinReplyFromPost: (fields) => gql `
      mutation unpinReplyFromPost($postId: ID!
$replyId: ID!) {
        unpinReplyFromPost(postId: $postId
replyId: $replyId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    unpublishTemplate: (fields) => gql `
      mutation unpublishTemplate($id: String!) {
        unpublishTemplate(id: $id) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    unsubscribeFromNotification: (fields) => gql `
      mutation unsubscribeFromNotification($input: UnsubscribeWithTokenInput!) {
        unsubscribeFromNotification(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    unsubscribeWithToken: (fields) => gql `
      mutation unsubscribeWithToken($input: UnsubscribeWithTokenInput!) {
        unsubscribeWithToken(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    unsuspendMember: (fields) => gql `
      mutation unsuspendMember($memberId: String!) {
        unsuspendMember(memberId: $memberId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateAccessGroup: (fields) => gql `
      mutation updateAccessGroup($id: ID!
$input: UpdateAccessGroupInput!) {
        updateAccessGroup(id: $id
input: $input) {
          ${AccessGroupGQLFields(fields)}
        }
      }
    `,
    updateAppInstallation: (fields) => gql `
      mutation updateAppInstallation($appInstallationId: ID!
$input: UpdateAppInstallationInput!) {
        updateAppInstallation(appInstallationId: $appInstallationId
input: $input) {
          ${AppInstallationGQLFields(fields)}
        }
      }
    `,
    updateAppNetworkSettings: (fields) => gql `
      mutation updateAppNetworkSettings($appId: ID!
$settings: String!) {
        updateAppNetworkSettings(appId: $appId
settings: $settings) {
          ${AppActionGQLFields(fields)}
        }
      }
    `,
    updateAppSpaceSetting: (fields) => gql `
      mutation updateAppSpaceSetting($appId: ID!
$settings: String!
$spaceId: ID!) {
        updateAppSpaceSetting(appId: $appId
settings: $settings
spaceId: $spaceId) {
          ${AppActionGQLFields(fields)}
        }
      }
    `,
    updateAppStanding: () => gql `
    mutation updateAppStanding($appId: ID!, $standing: StoreItemStanding!) {
      updateAppStanding(appId: $appId, standing: $standing)
    }
  `,
    updateAppStatus: () => gql `
    mutation updateAppStatus($appId: ID!, $status: StoreItemStatus!) {
      updateAppStatus(appId: $appId, status: $status)
    }
  `,
    updateAuthMember: (fields) => gql `
      mutation updateAuthMember($input: UpdateMemberInput!) {
        updateAuthMember(input: $input) {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    updateBadge: (fields) => gql `
      mutation updateBadge($id: String!
$input: UpdateBadgeInput!) {
        updateBadge(id: $id
input: $input) {
          ${BadgeGQLFields(fields)}
        }
      }
    `,
    updateBillingDetails: (fields) => gql `
      mutation updateBillingDetails($input: BillingDetailsInput!) {
        updateBillingDetails(input: $input) {
          ${BillingDetailsGQLFields(fields)}
        }
      }
    `,
    updateCollection: (fields) => gql `
      mutation updateCollection($id: ID!
$input: UpdateCollectionInput!) {
        updateCollection(id: $id
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateCustomSso: (fields) => gql `
      mutation updateCustomSso($input: UpdateCustomSsoInput!) {
        updateCustomSso(input: $input) {
          ${SsoGQLFields(fields)}
        }
      }
    `,
    updateDefaultSsoStatus: (fields) => gql `
      mutation updateDefaultSsoStatus($sso: DefaultSsoType!
$status: SsoStatus!) {
        updateDefaultSsoStatus(sso: $sso
status: $status) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateFile: (fields) => gql `
      mutation updateFile($id: String!
$input: UpdateFileInput!) {
        updateFile(id: $id
input: $input) {
          ${FileGQLFields(fields)}
        }
      }
    `,
    updateGroup: (fields) => gql `
      mutation updateGroup($groupId: ID
$input: UpdateCollectionInput!) {
        updateGroup(groupId: $groupId
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateImage: (fields) => gql `
      mutation updateImage($id: String!
$input: UpdateImageInput!) {
        updateImage(id: $id
input: $input) {
          ${ImageGQLFields(fields)}
        }
      }
    `,
    updateJwtSso: (fields) => gql `
      mutation updateJwtSso($input: UpdateJwtSsoInput!) {
        updateJwtSso(input: $input) {
          ${SsoGQLFields(fields)}
        }
      }
    `,
    updateMember: (fields) => gql `
      mutation updateMember($id: ID
$input: UpdateMemberInput!) {
        updateMember(id: $id
input: $input) {
          ${MemberGQLFields(fields)}
        }
      }
    `,
    updateMemberInvitation: (fields) => gql `
      mutation updateMemberInvitation($id: ID!
$input: UpdateMemberInvitationInput!) {
        updateMemberInvitation(id: $id
input: $input) {
          ${MemberInvitationGQLFields(fields)}
        }
      }
    `,
    updateMemberNetworkNotificationSettings: (fields) => gql `
      mutation updateMemberNetworkNotificationSettings($channel: NotificationChannel!
$input: UpdateMemberNetworkNotificationSettingsInput!
$memberId: ID) {
        updateMemberNetworkNotificationSettings(channel: $channel
input: $input
memberId: $memberId) {
          ${MemberNetworkNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    updateMemberPostNotificationSettings: (fields) => gql `
      mutation updateMemberPostNotificationSettings($input: UpdateMemberPostNotificationSettingsInput!
$memberId: ID
$postId: ID!) {
        updateMemberPostNotificationSettings(input: $input
memberId: $memberId
postId: $postId) {
          ${MemberPostNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    updateMemberPrivateMessagingSettings: (fields) => gql `
      mutation updateMemberPrivateMessagingSettings($input: UpdateMemberPrivateMessagingSettingsInput!) {
        updateMemberPrivateMessagingSettings(input: $input) {
          ${MemberPrivateMessagingSettingsGQLFields(fields)}
        }
      }
    `,
    updateMemberSchemaField: (fields) => gql `
      mutation updateMemberSchemaField($input: UpdateCustomFieldSchemaInput!) {
        updateMemberSchemaField(input: $input) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    updateMemberSpaceNotificationSettings: (fields) => gql `
      mutation updateMemberSpaceNotificationSettings($channel: NotificationChannel!
$input: UpdateMemberSpaceNotificationSettingsInput!
$memberId: ID
$spaceId: ID!) {
        updateMemberSpaceNotificationSettings(channel: $channel
input: $input
memberId: $memberId
spaceId: $spaceId) {
          ${MemberSpaceNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    updateMemberSpaceRole: (fields) => gql `
      mutation updateMemberSpaceRole($input: UpdateSpaceMemberRoleInput!
$memberId: ID!
$spaceId: ID!) {
        updateMemberSpaceRole(input: $input
memberId: $memberId
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateModeration: (fields) => gql `
      mutation updateModeration($id: ID!
$input: UpdateModerationItemInput!) {
        updateModeration(id: $id
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateModerationItem: (fields) => gql `
      mutation updateModerationItem($id: ID!
$input: UpdateModerationItemInput!) {
        updateModerationItem(id: $id
input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateModerationSettings: (fields) => gql `
      mutation updateModerationSettings($input: UpdateModerationSettingsInput!) {
        updateModerationSettings(input: $input) {
          ${ModerationSettingsGQLFields(fields)}
        }
      }
    `,
    updateNetwork: (fields) => gql `
      mutation updateNetwork($input: UpdateNetworkInput!) {
        updateNetwork(input: $input) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    updateNetworkAvailableLocales: (fields) => gql `
      mutation updateNetworkAvailableLocales($availableLocales: [String!]!) {
        updateNetworkAvailableLocales(availableLocales: $availableLocales) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    updateNetworkCustomCapacities: (fields) => gql `
      mutation updateNetworkCustomCapacities($additionalSeats: Int
$customMemberCapacity: Int) {
        updateNetworkCustomCapacities(additionalSeats: $additionalSeats
customMemberCapacity: $customMemberCapacity) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    updateNetworkDomainSubfolder: (fields) => gql `
      mutation updateNetworkDomainSubfolder($domainSubfolder: String) {
        updateNetworkDomainSubfolder(domainSubfolder: $domainSubfolder) {
          ${NetworkGQLFields(fields)}
        }
      }
    `,
    updateNetworkMediaSettings: (fields) => gql `
      mutation updateNetworkMediaSettings($input: UpdateMediaNetworkSettingsInput!) {
        updateNetworkMediaSettings(input: $input) {
          ${MediaNetworkSettingsGQLFields(fields)}
        }
      }
    `,
    updateNetworkNotificationSettings: (fields) => gql `
      mutation updateNetworkNotificationSettings($input: UpdateNotificationNetworkSettingsInput!) {
        updateNetworkNotificationSettings(input: $input) {
          ${NotificationNetworkSettingsGQLFields(fields)}
        }
      }
    `,
    updateNetworkStatus: (fields) => gql `
      mutation updateNetworkStatus($input: UpdateNetworkStatusInput!) {
        updateNetworkStatus(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateNewDomain: (fields) => gql `
      mutation updateNewDomain($input: UpdateNewDomainInput!) {
        updateNewDomain(input: $input) {
          ${DomainTransferStatusGQLFields(fields)}
        }
      }
    `,
    updatePasswordWithToken: (fields) => gql `
      mutation updatePasswordWithToken($input: UpdatePasswordWithTokenInput!) {
        updatePasswordWithToken(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updatePermission: (fields) => gql `
      mutation updatePermission($id: ID!
$input: UpdatePermissionInput!) {
        updatePermission(id: $id
input: $input) {
          ${PermissionGQLFields(fields)}
        }
      }
    `,
    updatePost: (fields) => gql `
      mutation updatePost($id: ID!
$input: UpdatePostInput!) {
        updatePost(id: $id
input: $input) {
          ${PostGQLFields(fields)}
        }
      }
    `,
    updatePostType: (fields) => gql `
      mutation updatePostType($id: ID!
$input: UpdatePostTypeInput!) {
        updatePostType(id: $id
input: $input) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    updatePostTypeField: (fields) => gql `
      mutation updatePostTypeField($id: ID!
$input: UpdateCustomFieldSchemaInput!) {
        updatePostTypeField(id: $id
input: $input) {
          ${PostTypeGQLFields(fields)}
        }
      }
    `,
    updatePrivateMessagingSettings: (fields) => gql `
      mutation updatePrivateMessagingSettings($input: UpdatePrivateMessagingSettingsInput!) {
        updatePrivateMessagingSettings(input: $input) {
          ${PrivateMessagingSettingsGQLFields(fields)}
        }
      }
    `,
    updateSpace: (fields) => gql `
      mutation updateSpace($id: ID!
$input: UpdateSpaceInput!) {
        updateSpace(id: $id
input: $input) {
          ${SpaceGQLFields(fields)}
        }
      }
    `,
    updateSpaceDefaultNotificationSettings: (fields) => gql `
      mutation updateSpaceDefaultNotificationSettings($channel: NotificationChannel!
$input: UpdateSpaceDefaultNotificationSettingsInput!
$spaceId: ID!) {
        updateSpaceDefaultNotificationSettings(channel: $channel
input: $input
spaceId: $spaceId) {
          ${SpaceDefaultNotificationSettingsGQLFields(fields)}
        }
      }
    `,
    updateSpaceHighlightedTags: (fields) => gql `
      mutation updateSpaceHighlightedTags($input: UpdateHighlightedTags!
$spaceId: ID!) {
        updateSpaceHighlightedTags(input: $input
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateSpaceMemberRole: (fields) => gql `
      mutation updateSpaceMemberRole($input: UpdateSpaceMemberRoleInput!
$memberId: ID!
$spaceId: ID!) {
        updateSpaceMemberRole(input: $input
memberId: $memberId
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateSpacePostTypes: (fields) => gql `
      mutation updateSpacePostTypes($input: [UpdateSpacePostTypeInput!]!
$spaceId: ID!) {
        updateSpacePostTypes(input: $input
spaceId: $spaceId) {
          ${SpacePostTypeGQLFields(fields)}
        }
      }
    `,
    updateSpaceTagFilter: (fields) => gql `
      mutation updateSpaceTagFilter($input: UpdateTagFilter!
$spaceId: ID!) {
        updateSpaceTagFilter(input: $input
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateSpaceTopicFilter: (fields) => gql `
      mutation updateSpaceTopicFilter($input: UpdateTagFilter!
$spaceId: ID!) {
        updateSpaceTopicFilter(input: $input
spaceId: $spaceId) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    updateTag: (fields) => gql `
      mutation updateTag($id: ID!
$input: UpdateTagInput!
$spaceId: ID) {
        updateTag(id: $id
input: $input
spaceId: $spaceId) {
          ${TagGQLFields(fields)}
        }
      }
    `,
    updateTemplate: (fields) => gql `
      mutation updateTemplate($id: String!
$input: UpdateTemplateInput!) {
        updateTemplate(id: $id
input: $input) {
          ${TemplateGQLFields(fields)}
        }
      }
    `,
    uploadMigrationFiles: (fields) => gql `
      mutation uploadMigrationFiles($baseUrl: String
$changeMemberEmails: Boolean
$dryRun: Boolean
$members: Upload
$migrationId: String
$posts: Upload
$spaces: Upload) {
        uploadMigrationFiles(baseUrl: $baseUrl
changeMemberEmails: $changeMemberEmails
dryRun: $dryRun
members: $members
migrationId: $migrationId
posts: $posts
spaces: $spaces) {
          ${UploadedMigrationsGQLFields(fields)}
        }
      }
    `,
    upsertExtraProperty: (fields) => gql `
      mutation upsertExtraProperty($input: UpsertExtraPropertyInput!) {
        upsertExtraProperty(input: $input) {
          ${ActionGQLFields(fields)}
        }
      }
    `,
    upsertTheme: (fields) => gql `
      mutation upsertTheme($input: UpsertTheme!) {
        upsertTheme(input: $input) {
          ${NewThemeGQLFields(fields)}
        }
      }
    `,
    verifyMember: (fields) => gql `
      mutation verifyMember($input: VerifyMemberInput!) {
        verifyMember(input: $input) {
          ${AuthTokenGQLFields(fields)}
        }
      }
    `,
};
//# sourceMappingURL=fields.generated.js.map